{
  "level": "ab02",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:ab02",
    "objects": "AREAS.E3:ab02.e3",
    "mesh": "TREES.E3:ab02.e3"
  },
  "spawn_point": {
    "position": [
      -3556.164891202685,
      -4984.443585793608,
      862.27978515625
    ],
    "facing_rad": 0.0,
    "look_point": [
      -3556.164891202685,
      -4884.443585793608,
      862.27978515625
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3618.054931640625,
      -5066.109375,
      838.27978515625
    ],
    "bbox_max": [
      -3370.0,
      -4930.87451171875,
      1078.70703125
    ],
    "vertex_count": 923,
    "vertices": [
      [
        -3511.800048828125,
        -4989.00048828125,
        949.70703125
      ],
      [
        -3511.800048828125,
        -4986.00048828125,
        952.70703125
      ],
      [
        -3511.800048828125,
        -4982.00048828125,
        952.70703125
      ],
      [
        -3511.800048828125,
        -4979.00048828125,
        949.70703125
      ],
      [
        -3511.800048828125,
        -4986.00048828125,
        942.70703125
      ],
      [
        -3511.800048828125,
        -4989.00048828125,
        945.70703125
      ],
      [
        -3511.800048828125,
        -4979.00048828125,
        945.70703125
      ],
      [
        -3511.800048828125,
        -4982.00048828125,
        942.70703125
      ],
      [
        -3511.800048828125,
        -4989.00048828125,
        945.70703125
      ],
      [
        -3511.800048828125,
        -4989.00048828125,
        949.70703125
      ],
      [
        -3511.800048828125,
        -4979.00048828125,
        949.70703125
      ],
      [
        -3511.800048828125,
        -4979.00048828125,
        945.70703125
      ],
      [
        -3511.800048828125,
        -4986.00048828125,
        952.70703125
      ],
      [
        -3511.800048828125,
        -4982.00048828125,
        952.70703125
      ],
      [
        -3511.800048828125,
        -4982.00048828125,
        942.70703125
      ],
      [
        -3511.800048828125,
        -4986.00048828125,
        942.70703125
      ],
      [
        -3511.800048828125,
        -4994.0205078125,
        998.92236328125
      ],
      [
        -3511.800048828125,
        -4974.0205078125,
        998.92236328125
      ],
      [
        -3400.0,
        -4974.00048828125,
        1031.70703125
      ],
      [
        -3380.0,
        -4974.00048828125,
        1031.70703125
      ],
      [
        -3380.0,
        -4994.00048828125,
        1031.70703125
      ],
      [
        -3400.0,
        -4994.00048828125,
        1031.70703125
      ],
      [
        -3400.0,
        -4994.00048828125,
        1031.70703125
      ],
      [
        -3400.0,
        -4974.00048828125,
        1031.70703125
      ],
      [
        -3380.0,
        -4974.00048828125,
        1031.70703125
      ],
      [
        -3380.0,
        -4994.00048828125,
        1031.70703125
      ],
      [
        -3470.257080078125,
        -4997.00048828125,
        996.704833984375
      ],
      [
        -3467.00927734375,
        -4994.00048828125,
        997.7042236328125
      ],
      [
        -3470.257080078125,
        -4997.00048828125,
        996.704833984375
      ],
      [
        -3470.250732421875,
        -4996.99462890625,
        996.706787109375
      ],
      [
        -3480.0,
        -4974.00048828125,
        1001.70703125
      ],
      [
        -3502.75,
        -4974.0146484375,
        1001.70703125
      ],
      [
        -3470.2431640625,
        -4971.00048828125,
        996.7091064453125
      ],
      [
        -3463.75,
        -4971.00048828125,
        1001.70703125
      ],
      [
        -3466.990966796875,
        -4973.9921875,
        1001.70703125
      ],
      [
        -3463.75,
        -4971.00048828125,
        1001.70703125
      ],
      [
        -3467.0,
        -4974.00048828125,
        1001.70703125
      ],
      [
        -3467.0,
        -4974.00048828125,
        1001.70703125
      ],
      [
        -3480.0,
        -4974.00048828125,
        1001.70703125
      ],
      [
        -3425.0,
        -4994.00048828125,
        1015.20703125
      ],
      [
        -3425.0,
        -4974.00048828125,
        1015.20703125
      ],
      [
        -3388.75,
        -5009.00048828125,
        1061.70703125
      ],
      [
        -3380.301513671875,
        -5009.00048828125,
        1059.4541015625
      ],
      [
        -3370.0,
        -5009.00048828125,
        1059.4539794921875
      ],
      [
        -3372.970947265625,
        -4940.70068359375,
        1057.499267578125
      ],
      [
        -3370.0,
        -4959.00048828125,
        1078.70703125
      ],
      [
        -3374.0,
        -4959.00048828125,
        1078.70703125
      ],
      [
        -3371.0,
        -4949.1923828125,
        1056.70703125
      ],
      [
        -3371.0,
        -4949.1923828125,
        1056.9736328125
      ],
      [
        -3371.0,
        -5009.00048828125,
        1056.70703125
      ],
      [
        -3371.0,
        -5009.00048828125,
        1056.9737548828125
      ],
      [
        -3380.0,
        -4980.00048828125,
        1041.70703125
      ],
      [
        -3380.0,
        -4988.00048828125,
        1041.70703125
      ],
      [
        -3527.91259765625,
        -5023.9755859375,
        878.70703125
      ],
      [
        -3540.037109375,
        -5030.9755859375,
        878.70703125
      ],
      [
        -3593.283935546875,
        -4939.0283203125,
        878.70703125
      ],
      [
        -3581.159912109375,
        -4932.0283203125,
        878.70703125
      ],
      [
        -3581.159912109375,
        -4932.0283203125,
        878.70703125
      ],
      [
        -3593.283935546875,
        -4939.0283203125,
        878.70703125
      ],
      [
        -3540.036865234375,
        -5030.9755859375,
        878.70703125
      ],
      [
        -3527.91259765625,
        -5023.9755859375,
        878.70703125
      ],
      [
        -3540.036865234375,
        -5030.9755859375,
        878.70703125
      ],
      [
        -3536.5732421875,
        -5028.9755859375,
        878.70703125
      ],
      [
        -3533.97509765625,
        -5027.4755859375,
        881.7071533203125
      ],
      [
        -3533.974853515625,
        -5027.4755859375,
        885.7071533203125
      ],
      [
        -3536.57275390625,
        -5028.9755859375,
        888.70703125
      ],
      [
        -3540.03662109375,
        -5030.9755859375,
        888.70703125
      ],
      [
        -3542.63525390625,
        -5032.4755859375,
        885.7064819335938
      ],
      [
        -3542.63525390625,
        -5032.4755859375,
        881.7074584960938
      ],
      [
        -3589.82080078125,
        -4937.02880859375,
        878.70703125
      ],
      [
        -3593.283935546875,
        -4939.0283203125,
        878.70703125
      ],
      [
        -3595.882568359375,
        -4940.5283203125,
        881.7075805664062
      ],
      [
        -3595.882568359375,
        -4940.5283203125,
        885.70654296875
      ],
      [
        -3593.283935546875,
        -4939.0283203125,
        888.707275390625
      ],
      [
        -3589.820068359375,
        -4937.0283203125,
        888.707275390625
      ],
      [
        -3587.222412109375,
        -4935.52880859375,
        885.7076416015625
      ],
      [
        -3587.222412109375,
        -4935.52880859375,
        881.7075805664062
      ],
      [
        -3585.490234375,
        -4934.52880859375,
        883.7075805664062
      ],
      [
        -3532.242919921875,
        -5026.4755859375,
        883.7072143554688
      ],
      [
        -3538.3046875,
        -5029.9755859375,
        890.7069091796875
      ],
      [
        -3591.552001953125,
        -4938.0283203125,
        890.7069702148438
      ],
      [
        -3544.366943359375,
        -5033.4755859375,
        883.7069702148438
      ],
      [
        -3597.6142578125,
        -4941.5283203125,
        883.7070922851562
      ],
      [
        -3581.15966796875,
        -4932.0283203125,
        878.70703125
      ],
      [
        -3527.91259765625,
        -5023.9755859375,
        878.70703125
      ],
      [
        -3563.412841796875,
        -4963.474609375,
        879.1083374023438
      ],
      [
        -3563.7353515625,
        -4962.2744140625,
        878.785888671875
      ],
      [
        -3562.949462890625,
        -4963.474609375,
        878.7070922851562
      ],
      [
        -3563.412841796875,
        -4963.474609375,
        879.1083374023438
      ],
      [
        -3563.7353515625,
        -4962.2744140625,
        878.785888671875
      ],
      [
        -3563.644287109375,
        -4962.2744140625,
        878.70703125
      ],
      [
        -3550.35546875,
        -4942.78369140625,
        843.43994140625
      ],
      [
        -3553.24951171875,
        -4940.42431640625,
        844.7619018554688
      ],
      [
        -3551.977783203125,
        -4935.677734375,
        855.2828369140625
      ],
      [
        -3532.490966796875,
        -4951.5654296875,
        846.3814086914062
      ],
      [
        -3516.571533203125,
        -4996.95703125,
        855.35302734375
      ],
      [
        -3521.321044921875,
        -4995.6845703125,
        844.8253173828125
      ],
      [
        -3521.946044921875,
        -4991.8408203125,
        843.43994140625
      ],
      [
        -3520.609375,
        -4972.12548828125,
        846.4028930664062
      ],
      [
        -3575.074951171875,
        -4933.474609375,
        860.166015625
      ],
      [
        -3558.896484375,
        -4933.474609375,
        860.166015625
      ],
      [
        -3551.977783203125,
        -4935.677734375,
        855.2828369140625
      ],
      [
        -3553.24951171875,
        -4940.42431640625,
        844.7619018554688
      ],
      [
        -3521.321044921875,
        -4995.6845703125,
        844.8253173828125
      ],
      [
        -3516.571533203125,
        -4996.95703125,
        855.35302734375
      ],
      [
        -3518.0927734375,
        -5003.9345703125,
        860.166015625
      ],
      [
        -3526.16943359375,
        -5017.923828125,
        860.166015625
      ],
      [
        -3526.16943359375,
        -5017.923828125,
        860.166015625
      ],
      [
        -3518.0927734375,
        -5003.9345703125,
        860.166015625
      ],
      [
        -3526.249755859375,
        -5022.67724609375,
        876.6172485351562
      ],
      [
        -3527.635009765625,
        -5021.29150390625,
        863.121826171875
      ],
      [
        -3558.896484375,
        -4933.474609375,
        860.166015625
      ],
      [
        -3575.074951171875,
        -4933.474609375,
        860.166015625
      ],
      [
        -3578.570556640625,
        -4933.078125,
        862.9923706054688
      ],
      [
        -3579.077392578125,
        -4931.1865234375,
        876.48291015625
      ],
      [
        -3532.490966796875,
        -4951.5654296875,
        846.3814086914062
      ],
      [
        -3520.609375,
        -4972.12548828125,
        846.4028930664062
      ],
      [
        -3536.80712890625,
        -4955.8818359375,
        838.27978515625
      ],
      [
        -3526.502197265625,
        -4973.70458984375,
        838.2942504882812
      ],
      [
        -3593.283935546875,
        -4939.0283203125,
        878.70703125
      ],
      [
        -3581.159912109375,
        -4932.0283203125,
        878.70703125
      ],
      [
        -3579.077392578125,
        -4931.1865234375,
        876.48291015625
      ],
      [
        -3578.570556640625,
        -4933.078125,
        862.9923706054688
      ],
      [
        -3527.635009765625,
        -5021.29150390625,
        863.121826171875
      ],
      [
        -3526.249755859375,
        -5022.67724609375,
        876.6172485351562
      ],
      [
        -3527.91259765625,
        -5023.9755859375,
        878.70703125
      ],
      [
        -3540.036865234375,
        -5030.9755859375,
        878.70703125
      ],
      [
        -3550.35546875,
        -4942.78369140625,
        843.43994140625
      ],
      [
        -3536.80712890625,
        -4955.8818359375,
        838.27978515625
      ],
      [
        -3526.502197265625,
        -4973.70458984375,
        838.2942504882812
      ],
      [
        -3521.946044921875,
        -4991.8408203125,
        843.43994140625
      ],
      [
        -3562.977294921875,
        -4962.2744140625,
        878.1297607421875
      ],
      [
        -3563.644287109375,
        -4962.2744140625,
        878.70703125
      ],
      [
        -3555.47216796875,
        -4962.2744140625,
        871.635009765625
      ],
      [
        -3554.713623046875,
        -4962.2744140625,
        870.9790649414062
      ],
      [
        -3562.977294921875,
        -4962.2744140625,
        878.1297607421875
      ],
      [
        -3555.47216796875,
        -4962.2744140625,
        871.635009765625
      ],
      [
        -3559.72900390625,
        -4951.87451171875,
        870.1070556640625
      ],
      [
        -3557.0,
        -4956.5869140625,
        870.1070556640625
      ],
      [
        -3564.0,
        -4951.87451171875,
        873.8031005859375
      ],
      [
        -3564.0,
        -4958.46728515625,
        877.1070556640625
      ],
      [
        -3557.0,
        -4956.5869140625,
        870.1070556640625
      ],
      [
        -3555.47216796875,
        -4962.2744140625,
        871.635009765625
      ],
      [
        -3562.977294921875,
        -4962.2744140625,
        878.1297607421875
      ],
      [
        -3564.0,
        -4958.46728515625,
        877.1070556640625
      ],
      [
        -3561.833251953125,
        -4950.3466796875,
        871.16259765625
      ],
      [
        -3564.0,
        -4950.7978515625,
        873.2636108398438
      ],
      [
        -3561.833251953125,
        -4950.3466796875,
        871.16259765625
      ],
      [
        -3559.72900390625,
        -4951.87451171875,
        870.1070556640625
      ],
      [
        -3564.52734375,
        -4950.90771484375,
        873.7749633789062
      ],
      [
        -3564.52734375,
        -4950.90771484375,
        873.7749633789062
      ],
      [
        -3564.0,
        -4951.87451171875,
        873.8031005859375
      ],
      [
        -3562.949462890625,
        -4963.474609375,
        878.7070922851562
      ],
      [
        -3562.655029296875,
        -4963.474609375,
        878.4521484375
      ],
      [
        -3554.391357421875,
        -4963.474609375,
        871.301513671875
      ],
      [
        -3555.149658203125,
        -4963.474609375,
        871.9574584960938
      ],
      [
        -3554.713623046875,
        -4962.2744140625,
        870.9790649414062
      ],
      [
        -3554.391357421875,
        -4963.474609375,
        871.301513671875
      ],
      [
        -3555.47216796875,
        -4962.2744140625,
        871.635009765625
      ],
      [
        -3555.149658203125,
        -4963.474609375,
        871.9574584960938
      ],
      [
        -3562.655029296875,
        -4963.474609375,
        878.4521484375
      ],
      [
        -3562.977294921875,
        -4962.2744140625,
        878.1297607421875
      ],
      [
        -3526.03515625,
        -4945.109375,
        943.8541259765625
      ],
      [
        -3511.800048828125,
        -4969.765625,
        943.8168334960938
      ],
      [
        -3550.69091796875,
        -4930.87451171875,
        929.6520385742188
      ],
      [
        -3526.03515625,
        -4945.109375,
        943.8544921875
      ],
      [
        -3579.160888671875,
        -4930.87451171875,
        905.0147705078125
      ],
      [
        -3550.69091796875,
        -4930.87451171875,
        929.6520385742188
      ],
      [
        -3511.800048828125,
        -4998.2353515625,
        929.5491333007812
      ],
      [
        -3526.03515625,
        -5022.8916015625,
        904.8745727539062
      ],
      [
        -3579.160888671875,
        -4930.87451171875,
        905.0147705078125
      ],
      [
        -3526.03515625,
        -5022.8916015625,
        904.8745727539062
      ],
      [
        -3567.0,
        -4944.50634765625,
        908.70703125
      ],
      [
        -3566.207763671875,
        -4945.87451171875,
        908.70703125
      ],
      [
        -3549.973388671875,
        -4953.95361328125,
        918.70703125
      ],
      [
        -3550.719970703125,
        -4953.9541015625,
        918.0607299804688
      ],
      [
        -3549.597900390625,
        -4954.60205078125,
        918.70703125
      ],
      [
        -3549.973388671875,
        -4953.95361328125,
        918.70703125
      ],
      [
        -3550.719970703125,
        -4953.9541015625,
        918.0607299804688
      ],
      [
        -3549.597900390625,
        -4954.60205078125,
        918.70703125
      ],
      [
        -3524.397705078125,
        -4958.2080078125,
        938.70703125
      ],
      [
        -3522.3935546875,
        -4961.66943359375,
        938.70703125
      ],
      [
        -3523.302978515625,
        -4954.11181640625,
        941.70703125
      ],
      [
        -3524.397705078125,
        -4958.2080078125,
        938.70703125
      ],
      [
        -3522.3935546875,
        -4961.66943359375,
        938.70703125
      ],
      [
        -3518.291748046875,
        -4962.765625,
        941.70703125
      ],
      [
        -3521.45751953125,
        -4953.04638671875,
        943.837890625
      ],
      [
        -3523.302978515625,
        -4954.11181640625,
        941.70703125
      ],
      [
        -3516.45751953125,
        -4961.70654296875,
        943.8247680664062
      ],
      [
        -3518.291748046875,
        -4962.765625,
        941.70703125
      ],
      [
        -3560.0,
        -4945.87451171875,
        914.078857421875
      ],
      [
        -3560.0,
        -4942.62548828125,
        915.70703125
      ],
      [
        -3570.0,
        -4933.33984375,
        911.70703125
      ],
      [
        -3567.0,
        -4944.50634765625,
        908.70703125
      ],
      [
        -3560.0,
        -4942.62548828125,
        915.70703125
      ],
      [
        -3563.0,
        -4931.458984375,
        918.70703125
      ],
      [
        -3560.0,
        -4945.87451171875,
        914.078857421875
      ],
      [
        -3566.207763671875,
        -4945.87451171875,
        908.70703125
      ],
      [
        -3570.0,
        -4930.87451171875,
        912.9423217773438
      ],
      [
        -3570.0,
        -4933.33984375,
        911.70703125
      ],
      [
        -3563.33837890625,
        -4930.87451171875,
        918.70703125
      ],
      [
        -3563.0,
        -4931.458984375,
        918.70703125
      ],
      [
        -3536.6162109375,
        -4977.01806640625,
        918.70703125
      ],
      [
        -3538.896728515625,
        -4973.08056640625,
        918.70703125
      ],
      [
        -3541.918701171875,
        -4977.01806640625,
        914.11865234375
      ],
      [
        -3536.6162109375,
        -4977.01806640625,
        918.70703125
      ],
      [
        -3541.918701171875,
        -4977.01806640625,
        914.11865234375
      ],
      [
        -3541.860107421875,
        -4973.94921875,
        915.70703125
      ],
      [
        -3541.860107421875,
        -4973.94921875,
        915.70703125
      ],
      [
        -3540.24365234375,
        -4973.4384765625,
        917.3621215820312
      ],
      [
        -3538.885986328125,
        -4971.19189453125,
        918.70703125
      ],
      [
        -3540.18212890625,
        -4973.42236328125,
        917.4235229492188
      ],
      [
        -3540.24365234375,
        -4973.4384765625,
        917.3621215820312
      ],
      [
        -3532.12060546875,
        -4972.34130859375,
        913.0856323242188
      ],
      [
        -3532.12060546875,
        -4972.34130859375,
        914.3286743164062
      ],
      [
        -3532.12060546875,
        -4972.34130859375,
        914.3286743164062
      ],
      [
        -3532.12060546875,
        -4972.34130859375,
        913.0856323242188
      ],
      [
        -3532.09033203125,
        -4973.04150390625,
        913.7071533203125
      ],
      [
        -3538.896728515625,
        -4973.08056640625,
        918.70703125
      ],
      [
        -3532.05029296875,
        -4973.96826171875,
        914.530029296875
      ],
      [
        -3531.9931640625,
        -4975.29443359375,
        915.70703125
      ],
      [
        -3532.938720703125,
        -4977.01806640625,
        916.7269897460938
      ],
      [
        -3531.9931640625,
        -4975.29443359375,
        915.70703125
      ],
      [
        -3531.240966796875,
        -4971.3095703125,
        912.6318969726562
      ],
      [
        -3539.2080078125,
        -5005.69775390625,
        882.7071533203125
      ],
      [
        -3537.9150390625,
        -5003.4580078125,
        878.70703125
      ],
      [
        -3538.342041015625,
        -5006.19775390625,
        882.7071533203125
      ],
      [
        -3537.049072265625,
        -5003.9580078125,
        878.70703125
      ],
      [
        -3537.9150390625,
        -5003.4580078125,
        878.70703125
      ],
      [
        -3537.049072265625,
        -5003.9580078125,
        878.70703125
      ],
      [
        -3539.2080078125,
        -5005.69775390625,
        882.7071533203125
      ],
      [
        -3538.342041015625,
        -5006.19775390625,
        882.7071533203125
      ],
      [
        -3557.423828125,
        -4979.00048828125,
        899.7071533203125
      ],
      [
        -3552.802001953125,
        -4979.00048828125,
        903.7071533203125
      ],
      [
        -3547.010498046875,
        -4989.00048828125,
        903.7071533203125
      ],
      [
        -3551.633056640625,
        -4989.00048828125,
        899.7071533203125
      ],
      [
        -3552.802001953125,
        -4979.00048828125,
        903.7071533203125
      ],
      [
        -3547.597900390625,
        -4982.00048828125,
        906.7071533203125
      ],
      [
        -3558.0,
        -4979.99951171875,
        898.7080688476562
      ],
      [
        -3557.423828125,
        -4979.00048828125,
        899.7071533203125
      ],
      [
        -3558.0,
        -4983.99267578125,
        896.7071533203125
      ],
      [
        -3556.83740234375,
        -4986.00048828125,
        896.7071533203125
      ],
      [
        -3551.633056640625,
        -4989.00048828125,
        899.7071533203125
      ],
      [
        -3556.83740234375,
        -4986.00048828125,
        896.7071533203125
      ],
      [
        -3547.597900390625,
        -4982.00048828125,
        906.7071533203125
      ],
      [
        -3545.28125,
        -4986.00048828125,
        906.7071533203125
      ],
      [
        -3545.28125,
        -4986.00048828125,
        906.7071533203125
      ],
      [
        -3547.010498046875,
        -4989.00048828125,
        903.7071533203125
      ],
      [
        -3558.7802734375,
        -4982.00048828125,
        897.0303955078125
      ],
      [
        -3558.0,
        -4979.99951171875,
        898.7080688476562
      ],
      [
        -3558.7802734375,
        -4982.00048828125,
        897.0303955078125
      ],
      [
        -3558.0,
        -4983.99267578125,
        896.7071533203125
      ],
      [
        -3541.19970703125,
        -4986.74609375,
        896.7071533203125
      ],
      [
        -3541.19970703125,
        -4986.74609375,
        896.7071533203125
      ],
      [
        -3538.945556640625,
        -4989.00048828125,
        896.7071533203125
      ],
      [
        -3540.28857421875,
        -4986.00048828125,
        892.7071533203125
      ],
      [
        -3536.0458984375,
        -4989.00048828125,
        889.706787109375
      ],
      [
        -3541.72705078125,
        -4982.52783203125,
        896.1798706054688
      ],
      [
        -3540.28857421875,
        -4986.00048828125,
        892.7071533203125
      ],
      [
        -3541.72705078125,
        -4982.52783203125,
        896.1798706054688
      ],
      [
        -3543.0,
        -4984.94580078125,
        896.7071533203125
      ],
      [
        -3542.1513671875,
        -4982.35205078125,
        896.3556518554688
      ],
      [
        -3527.884033203125,
        -4979.00048828125,
        886.9016723632812
      ],
      [
        -3527.884033203125,
        -4989.00048828125,
        886.9016723632812
      ],
      [
        -3529.384033203125,
        -4984.1845703125,
        890.5230102539062
      ],
      [
        -3529.384033203125,
        -4983.81640625,
        890.5230102539062
      ],
      [
        -3533.2080078125,
        -4995.30517578125,
        882.70703125
      ],
      [
        -3534.5009765625,
        -4997.544921875,
        878.70703125
      ],
      [
        -3532.342041015625,
        -4995.80517578125,
        882.70703125
      ],
      [
        -3533.635009765625,
        -4998.044921875,
        878.70703125
      ],
      [
        -3534.5009765625,
        -4997.544921875,
        878.70703125
      ],
      [
        -3533.635009765625,
        -4998.044921875,
        878.70703125
      ],
      [
        -3533.2080078125,
        -4995.30517578125,
        882.70703125
      ],
      [
        -3532.342041015625,
        -4995.80517578125,
        882.70703125
      ],
      [
        -3535.7080078125,
        -4999.63525390625,
        889.7071533203125
      ],
      [
        -3536.707763671875,
        -5001.3671875,
        889.7071533203125
      ],
      [
        -3535.841796875,
        -5001.8671875,
        889.7071533203125
      ],
      [
        -3534.842041015625,
        -5000.13525390625,
        889.7071533203125
      ],
      [
        -3536.707763671875,
        -5001.3671875,
        889.7071533203125
      ],
      [
        -3535.7080078125,
        -4999.63525390625,
        889.7071533203125
      ],
      [
        -3534.842041015625,
        -5000.13525390625,
        889.7071533203125
      ],
      [
        -3535.841796875,
        -5001.8671875,
        889.7071533203125
      ],
      [
        -3532.84228515625,
        -4996.67138671875,
        887.1217651367188
      ],
      [
        -3533.708251953125,
        -4996.17138671875,
        887.121826171875
      ],
      [
        -3533.708251953125,
        -4996.17138671875,
        887.121826171875
      ],
      [
        -3532.84228515625,
        -4996.67138671875,
        887.1217651367188
      ],
      [
        -3537.842041015625,
        -5005.33154296875,
        887.1212768554688
      ],
      [
        -3538.707763671875,
        -5004.83154296875,
        887.121826171875
      ],
      [
        -3538.707763671875,
        -5004.83154296875,
        887.121826171875
      ],
      [
        -3537.842041015625,
        -5005.33154296875,
        887.1212768554688
      ],
      [
        -3560.0,
        -4942.4921875,
        878.70703125
      ],
      [
        -3555.60009765625,
        -4953.900390625,
        878.7071533203125
      ],
      [
        -3562.39990234375,
        -4953.900390625,
        878.7071533203125
      ],
      [
        -3565.764404296875,
        -4948.6396484375,
        875.342041015625
      ],
      [
        -3567.855224609375,
        -4939.42724609375,
        878.70703125
      ],
      [
        -3562.144775390625,
        -4939.42724609375,
        878.70703125
      ],
      [
        -3548.697021484375,
        -5035.97509765625,
        878.70703125
      ],
      [
        -3601.944580078125,
        -4944.0283203125,
        878.70703125
      ],
      [
        -3601.944580078125,
        -4944.0283203125,
        878.70703125
      ],
      [
        -3548.697021484375,
        -5035.9755859375,
        878.70703125
      ],
      [
        -3601.944580078125,
        -4944.0283203125,
        878.70703125
      ],
      [
        -3548.697021484375,
        -5035.9755859375,
        878.70703125
      ],
      [
        -3603.60302734375,
        -4945.3232421875,
        876.6228637695312
      ],
      [
        -3601.944580078125,
        -4944.0283203125,
        878.70703125
      ],
      [
        -3548.697021484375,
        -5035.9755859375,
        878.70703125
      ],
      [
        -3550.774169921875,
        -5036.8154296875,
        876.488525390625
      ],
      [
        -3613.2822265625,
        -4971.04345703125,
        855.3571166992188
      ],
      [
        -3611.76220703125,
        -4964.072265625,
        860.166015625
      ],
      [
        -3570.9619140625,
        -5034.5263671875,
        860.166015625
      ],
      [
        -3577.87451171875,
        -5032.3251953125,
        855.2870483398438
      ],
      [
        -3609.244140625,
        -4995.8759765625,
        846.4067993164062
      ],
      [
        -3613.2822265625,
        -4971.04345703125,
        855.3571166992188
      ],
      [
        -3577.87451171875,
        -5032.3251953125,
        855.2870483398438
      ],
      [
        -3597.362060546875,
        -5016.4365234375,
        846.3855590820312
      ],
      [
        -3611.76220703125,
        -4964.072265625,
        860.166015625
      ],
      [
        -3603.60302734375,
        -4945.3232421875,
        876.6228637695312
      ],
      [
        -3570.9619140625,
        -5034.5263671875,
        860.166015625
      ],
      [
        -3550.774169921875,
        -5036.8154296875,
        876.488525390625
      ],
      [
        -3597.362060546875,
        -5016.4365234375,
        846.3855590820312
      ],
      [
        -3609.244140625,
        -4995.8759765625,
        846.4067993164062
      ],
      [
        -3618.0517578125,
        -4998.2353515625,
        989.9419555664062
      ],
      [
        -3618.0517578125,
        -4969.765625,
        989.941650390625
      ],
      [
        -3618.0517578125,
        -4971.00048828125,
        988.70703125
      ],
      [
        -3618.0517578125,
        -4997.00048828125,
        988.70703125
      ],
      [
        -3618.0517578125,
        -4969.765625,
        989.941650390625
      ],
      [
        -3615.8779296875,
        -4966.0,
        993.70703125
      ],
      [
        -3615.8779296875,
        -5002.00048828125,
        993.70703125
      ],
      [
        -3618.0517578125,
        -4998.2353515625,
        989.9419555664062
      ],
      [
        -3513.93603515625,
        -4969.765625,
        989.9417724609375
      ],
      [
        -3513.936767578125,
        -4998.2353515625,
        989.9418334960938
      ],
      [
        -3511.800048828125,
        -4998.00048828125,
        989.70703125
      ],
      [
        -3511.800048828125,
        -4970.00048828125,
        989.70703125
      ],
      [
        -3513.93603515625,
        -4969.765625,
        989.9417724609375
      ],
      [
        -3511.800048828125,
        -4969.765625,
        989.9417724609375
      ],
      [
        -3513.936767578125,
        -4998.2353515625,
        989.9418334960938
      ],
      [
        -3511.800048828125,
        -4998.2353515625,
        989.9418334960938
      ],
      [
        -3511.800048828125,
        -4998.2353515625,
        989.94189453125
      ],
      [
        -3513.973876953125,
        -5002.00048828125,
        993.70703125
      ],
      [
        -3513.973876953125,
        -4966.0,
        993.70703125
      ],
      [
        -3511.800048828125,
        -4969.765625,
        989.941650390625
      ],
      [
        -3579.160888671875,
        -4930.87451171875,
        989.70703125
      ],
      [
        -3550.69091796875,
        -4930.87451171875,
        989.70703125
      ],
      [
        -3603.81689453125,
        -4945.109375,
        991.2713012695312
      ],
      [
        -3579.160888671875,
        -4930.87451171875,
        989.70703125
      ],
      [
        -3550.69091796875,
        -4930.87451171875,
        989.70703125
      ],
      [
        -3526.03515625,
        -4945.109375,
        991.2713012695312
      ],
      [
        -3606.106201171875,
        -4949.07470703125,
        993.70703125
      ],
      [
        -3603.81689453125,
        -4945.109375,
        991.2713012695312
      ],
      [
        -3606.106201171875,
        -4949.07470703125,
        991.70703125
      ],
      [
        -3526.03515625,
        -4945.109375,
        991.2713012695312
      ],
      [
        -3523.745849609375,
        -4949.07470703125,
        993.70703125
      ],
      [
        -3523.745849609375,
        -4949.07470703125,
        991.70703125
      ],
      [
        -3513.901123046875,
        -4966.1259765625,
        993.580810546875
      ],
      [
        -3615.95068359375,
        -4966.1259765625,
        993.580810546875
      ],
      [
        -3603.81689453125,
        -4945.109375,
        988.70703125
      ],
      [
        -3579.160888671875,
        -4930.87451171875,
        988.70703125
      ],
      [
        -3550.69091796875,
        -4930.87451171875,
        988.70703125
      ],
      [
        -3526.03515625,
        -4945.109375,
        988.70703125
      ],
      [
        -3579.160888671875,
        -4930.87451171875,
        988.70703125
      ],
      [
        -3550.69091796875,
        -4930.87451171875,
        988.70703125
      ],
      [
        -3526.03515625,
        -4945.109375,
        988.70703125
      ],
      [
        -3511.800048828125,
        -4969.765625,
        988.70703125
      ],
      [
        -3618.0517578125,
        -4969.765625,
        988.70703125
      ],
      [
        -3603.81689453125,
        -4945.109375,
        988.70703125
      ],
      [
        -3618.0517578125,
        -4969.765625,
        988.70703125
      ],
      [
        -3603.81689453125,
        -4945.109375,
        936.815673828125
      ],
      [
        -3579.160888671875,
        -4930.87451171875,
        922.5809326171875
      ],
      [
        -3579.160888671875,
        -4930.87451171875,
        922.5809326171875
      ],
      [
        -3558.862060546875,
        -4930.87451171875,
        922.5809326171875
      ],
      [
        -3618.0517578125,
        -4969.765625,
        961.4722290039062
      ],
      [
        -3603.81689453125,
        -4945.109375,
        936.815673828125
      ],
      [
        -3511.800048828125,
        -4969.765625,
        961.4722290039062
      ],
      [
        -3521.977783203125,
        -4952.13720703125,
        943.843505859375
      ],
      [
        -3618.0517578125,
        -4969.765625,
        961.4722290039062
      ],
      [
        -3519.174560546875,
        -4957.00048828125,
        948.70703125
      ],
      [
        -3522.306396484375,
        -4957.00048828125,
        948.70703125
      ],
      [
        -3563.0,
        -4957.00048828125,
        948.7070922851562
      ],
      [
        -3567.0,
        -4957.00048828125,
        948.7070922851562
      ],
      [
        -3567.0,
        -4957.00048828125,
        948.7070922851562
      ],
      [
        -3570.0,
        -4954.00048828125,
        945.7070922851562
      ],
      [
        -3560.0,
        -4954.00048828125,
        945.7070922851562
      ],
      [
        -3563.0,
        -4957.00048828125,
        948.7070922851562
      ],
      [
        -3560.0,
        -4950.00048828125,
        941.7070922851562
      ],
      [
        -3560.0,
        -4954.00048828125,
        945.7070922851562
      ],
      [
        -3570.0,
        -4954.00048828125,
        945.7070922851562
      ],
      [
        -3570.0,
        -4950.00048828125,
        941.7070922851562
      ],
      [
        -3563.0,
        -4947.00048828125,
        938.7070922851562
      ],
      [
        -3560.0,
        -4950.00048828125,
        941.7070922851562
      ],
      [
        -3570.0,
        -4950.00048828125,
        941.7070922851562
      ],
      [
        -3567.0,
        -4947.00048828125,
        938.7070922851562
      ],
      [
        -3567.0,
        -4947.00048828125,
        938.7070922851562
      ],
      [
        -3563.0,
        -4947.00048828125,
        938.7070922851562
      ],
      [
        -3522.306396484375,
        -4957.00048828125,
        948.70703125
      ],
      [
        -3523.1103515625,
        -4954.00048828125,
        945.70703125
      ],
      [
        -3521.45751953125,
        -4953.04638671875,
        944.7528076171875
      ],
      [
        -3523.1103515625,
        -4954.00048828125,
        945.70703125
      ],
      [
        -3541.13623046875,
        -4988.5009765625,
        980.20703125
      ],
      [
        -3537.135986328125,
        -4988.50048828125,
        980.20703125
      ],
      [
        -3511.80517578125,
        -4980.25048828125,
        971.95703125
      ],
      [
        -3532.0,
        -4980.25048828125,
        971.95703125
      ],
      [
        -3511.80517578125,
        -4987.25048828125,
        978.95703125
      ],
      [
        -3532.0,
        -4987.25048828125,
        978.95703125
      ],
      [
        -3541.8994140625,
        -4983.10107421875,
        974.8075561523438
      ],
      [
        -3538.034912109375,
        -4981.50048828125,
        973.20703125
      ],
      [
        -3532.0,
        -4980.25048828125,
        971.95703125
      ],
      [
        -3538.034912109375,
        -4981.50048828125,
        973.20703125
      ],
      [
        -3542.893310546875,
        -4985.50048828125,
        977.20703125
      ],
      [
        -3540.100341796875,
        -4986.00048828125,
        980.20703125
      ],
      [
        -3541.868408203125,
        -4987.25048828125,
        978.9568481445312
      ],
      [
        -3541.8994140625,
        -4983.10107421875,
        974.8075561523438
      ],
      [
        -3542.893310546875,
        -4985.50048828125,
        977.20703125
      ],
      [
        -3536.763427734375,
        -4988.2373046875,
        979.9434814453125
      ],
      [
        -3532.0,
        -4987.25048828125,
        978.95703125
      ],
      [
        -3541.13623046875,
        -4988.5009765625,
        980.20703125
      ],
      [
        -3537.135986328125,
        -4988.50048828125,
        980.20703125
      ],
      [
        -3536.763427734375,
        -4988.2373046875,
        979.9434814453125
      ],
      [
        -3618.054931640625,
        -4979.00048828125,
        970.7070922851562
      ],
      [
        -3603.054931640625,
        -4979.00048828125,
        970.7070922851562
      ],
      [
        -3618.054931640625,
        -4983.00048828125,
        974.70703125
      ],
      [
        -3603.054931640625,
        -4983.00048828125,
        974.70703125
      ],
      [
        -3603.054931640625,
        -4979.00048828125,
        970.7070922851562
      ],
      [
        -3603.054931640625,
        -4983.00048828125,
        974.70703125
      ],
      [
        -3602.637451171875,
        -4960.00048828125,
        951.70703125
      ],
      [
        -3601.107177734375,
        -4960.41064453125,
        952.1170654296875
      ],
      [
        -3604.812255859375,
        -4966.82763671875,
        958.5340576171875
      ],
      [
        -3611.441162109375,
        -4963.00048828125,
        954.70703125
      ],
      [
        -3601.107177734375,
        -4960.41064453125,
        952.1170654296875
      ],
      [
        -3604.812255859375,
        -4966.82763671875,
        958.5340576171875
      ],
      [
        -3610.63720703125,
        -4960.00048828125,
        951.70703125
      ],
      [
        -3602.637451171875,
        -4960.00048828125,
        951.70703125
      ],
      [
        -3611.441162109375,
        -4963.00048828125,
        954.70703125
      ],
      [
        -3610.63720703125,
        -4960.00048828125,
        951.70703125
      ],
      [
        -3618.0517578125,
        -4989.00048828125,
        980.7070922851562
      ],
      [
        -3618.0517578125,
        -4989.00048828125,
        878.70703125
      ],
      [
        -3560.0,
        -4982.00048828125,
        918.7067260742188
      ],
      [
        -3560.0,
        -4986.00048828125,
        918.7073974609375
      ],
      [
        -3560.0,
        -4984.0009765625,
        920.7072143554688
      ],
      [
        -3570.0,
        -4984.00048828125,
        920.7071533203125
      ],
      [
        -3567.0,
        -4989.00048828125,
        925.7070922851562
      ],
      [
        -3570.0,
        -4986.00048828125,
        922.7069702148438
      ],
      [
        -3560.0,
        -4986.00048828125,
        922.7069702148438
      ],
      [
        -3563.0,
        -4989.00048828125,
        925.7070922851562
      ],
      [
        -3570.0,
        -4986.00048828125,
        922.7069702148438
      ],
      [
        -3560.0,
        -4986.00048828125,
        922.70703125
      ],
      [
        -3581.843505859375,
        -4989.00048828125,
        972.70703125
      ],
      [
        -3577.89892578125,
        -4989.00048828125,
        972.70703125
      ],
      [
        -3577.89892578125,
        -4989.00048828125,
        962.70703125
      ],
      [
        -3581.843505859375,
        -4989.00048828125,
        962.70703125
      ],
      [
        -3537.135986328125,
        -4988.50048828125,
        970.20703125
      ],
      [
        -3541.135986328125,
        -4988.50048828125,
        970.20703125
      ],
      [
        -3511.80517578125,
        -4980.75048828125,
        971.45703125
      ],
      [
        -3532.0,
        -4980.75048828125,
        971.45703125
      ],
      [
        -3511.80517578125,
        -4987.25048828125,
        971.45703125
      ],
      [
        -3532.0,
        -4987.25048828125,
        971.45703125
      ],
      [
        -3540.46435546875,
        -4982.00048828125,
        970.20703125
      ],
      [
        -3540.46435546875,
        -4986.00048828125,
        970.20703125
      ],
      [
        -3581.9853515625,
        -4983.01513671875,
        970.20703125
      ],
      [
        -3579.535888671875,
        -4982.00048828125,
        970.20703125
      ],
      [
        -3573.5,
        -4980.75048828125,
        971.45703125
      ],
      [
        -3546.5,
        -4987.25048828125,
        971.45703125
      ],
      [
        -3540.46435546875,
        -4986.00048828125,
        970.20703125
      ],
      [
        -3546.5,
        -4980.75048828125,
        971.45703125
      ],
      [
        -3540.46435546875,
        -4982.00048828125,
        970.20703125
      ],
      [
        -3581.9853515625,
        -4983.01513671875,
        970.20703125
      ],
      [
        -3581.88671875,
        -4986.8662109375,
        971.8411254882812
      ],
      [
        -3582.41552734375,
        -4987.25048828125,
        971.4568481445312
      ],
      [
        -3583.15576171875,
        -4986.00048828125,
        970.20703125
      ],
      [
        -3580.686767578125,
        -4986.00048828125,
        972.70703125
      ],
      [
        -3581.88671875,
        -4986.8662109375,
        971.8411254882812
      ],
      [
        -3603.054931640625,
        -4987.25048828125,
        971.4569702148438
      ],
      [
        -3603.054931640625,
        -4986.00048828125,
        972.70703125
      ],
      [
        -3603.054931640625,
        -4982.00048828125,
        972.70703125
      ],
      [
        -3603.054931640625,
        -4980.75048828125,
        971.45703125
      ],
      [
        -3603.054931640625,
        -4982.00048828125,
        970.20703125
      ],
      [
        -3603.054931640625,
        -4986.00048828125,
        970.20703125
      ],
      [
        -3541.5458984375,
        -4983.45458984375,
        972.70703125
      ],
      [
        -3532.0,
        -4980.75048828125,
        971.45703125
      ],
      [
        -3538.034912109375,
        -4982.00048828125,
        972.70703125
      ],
      [
        -3540.1005859375,
        -4986.0009765625,
        970.20703125
      ],
      [
        -3541.5458984375,
        -4983.45458984375,
        972.70703125
      ],
      [
        -3542.600341796875,
        -4986.00048828125,
        972.70703125
      ],
      [
        -3541.8681640625,
        -4987.25048828125,
        971.45703125
      ],
      [
        -3546.5,
        -4988.50048828125,
        970.20703125
      ],
      [
        -3584.1357421875,
        -4988.50048828125,
        970.20703125
      ],
      [
        -3603.054931640625,
        -4988.5,
        970.20703125
      ],
      [
        -3536.763427734375,
        -4988.23681640625,
        970.4703369140625
      ],
      [
        -3532.0,
        -4987.25048828125,
        971.45703125
      ],
      [
        -3541.135986328125,
        -4988.50048828125,
        970.20703125
      ],
      [
        -3536.763427734375,
        -4988.23681640625,
        970.4703369140625
      ],
      [
        -3537.135986328125,
        -4988.50048828125,
        970.20703125
      ],
      [
        -3573.5,
        -4979.50048828125,
        970.20703125
      ],
      [
        -3546.5,
        -4979.50048828125,
        970.20703125
      ],
      [
        -3603.054931640625,
        -4979.50048828125,
        970.20703125
      ],
      [
        -3535.328369140625,
        -4982.00048828125,
        962.70703125
      ],
      [
        -3535.328369140625,
        -4986.00048828125,
        962.70703125
      ],
      [
        -3584.823974609375,
        -4989.00048828125,
        965.70703125
      ],
      [
        -3584.823974609375,
        -4989.00048828125,
        969.70703125
      ],
      [
        -3539.571044921875,
        -4979.00048828125,
        965.70703125
      ],
      [
        -3535.328369140625,
        -4982.00048828125,
        962.70703125
      ],
      [
        -3535.328369140625,
        -4986.00048828125,
        962.70703125
      ],
      [
        -3539.571044921875,
        -4989.00048828125,
        965.7069091796875
      ],
      [
        -3581.886962890625,
        -4986.86669921875,
        963.5730590820312
      ],
      [
        -3584.823974609375,
        -4989.00048828125,
        965.70703125
      ],
      [
        -3584.823974609375,
        -4989.00048828125,
        969.70703125
      ],
      [
        -3580.686767578125,
        -4986.00048828125,
        962.70703125
      ],
      [
        -3581.886962890625,
        -4986.86669921875,
        963.5730590820312
      ],
      [
        -3603.054931640625,
        -4979.00048828125,
        969.7072143554688
      ],
      [
        -3603.054931640625,
        -4989.00048828125,
        969.7066650390625
      ],
      [
        -3511.80517578125,
        -4988.50048828125,
        972.70703125
      ],
      [
        -3532.0,
        -4988.50048828125,
        972.70703125
      ],
      [
        -3618.054931640625,
        -4988.25048828125,
        972.4570922851562
      ],
      [
        -3618.054931640625,
        -4988.00048828125,
        972.70703125
      ],
      [
        -3603.054931640625,
        -4988.00048828125,
        972.70703125
      ],
      [
        -3603.054931640625,
        -4988.25048828125,
        972.4570922851562
      ],
      [
        -3577.020751953125,
        -4987.9794921875,
        972.1860961914062
      ],
      [
        -3573.5,
        -4987.25048828125,
        971.4571533203125
      ],
      [
        -3581.4580078125,
        -4988.0009765625,
        972.70703125
      ],
      [
        -3581.80419921875,
        -4988.2509765625,
        972.457275390625
      ],
      [
        -3582.321533203125,
        -4987.4091796875,
        971.615478515625
      ],
      [
        -3582.41552734375,
        -4987.25048828125,
        971.4569091796875
      ],
      [
        -3582.321533203125,
        -4987.4091796875,
        971.615478515625
      ],
      [
        -3603.054931640625,
        -4988.25048828125,
        972.4570922851562
      ],
      [
        -3603.054931640625,
        -4988.00048828125,
        972.70703125
      ],
      [
        -3603.054931640625,
        -4987.25048828125,
        971.45703125
      ],
      [
        -3541.8681640625,
        -4987.25048828125,
        971.45703125
      ],
      [
        -3543.42919921875,
        -4988.0009765625,
        972.70703125
      ],
      [
        -3543.282958984375,
        -4988.2509765625,
        972.4573974609375
      ],
      [
        -3577.5322265625,
        -4988.0009765625,
        972.70703125
      ],
      [
        -3577.020751953125,
        -4987.9794921875,
        972.1860961914062
      ],
      [
        -3577.382568359375,
        -4988.25048828125,
        972.457275390625
      ],
      [
        -3577.715576171875,
        -4988.50048828125,
        972.70703125
      ],
      [
        -3581.650634765625,
        -4988.50048828125,
        972.70703125
      ],
      [
        -3543.635986328125,
        -4988.50048828125,
        972.70703125
      ],
      [
        -3576.000244140625,
        -4989.00048828125,
        970.74267578125
      ],
      [
        -3583.596435546875,
        -4989.00048828125,
        970.9540405273438
      ],
      [
        -3582.84326171875,
        -4989.00048828125,
        971.707275390625
      ],
      [
        -3583.596435546875,
        -4989.00048828125,
        970.9540405273438
      ],
      [
        -3581.80419921875,
        -4988.2509765625,
        972.457275390625
      ],
      [
        -3537.343017578125,
        -4989.00048828125,
        970.20703125
      ],
      [
        -3541.343017578125,
        -4989.00048828125,
        970.20703125
      ],
      [
        -3536.0,
        -4989.00048828125,
        971.55029296875
      ],
      [
        -3535.62158203125,
        -4989.00048828125,
        971.70703125
      ],
      [
        -3532.0,
        -4988.2509765625,
        972.4573974609375
      ],
      [
        -3541.343017578125,
        -4989.00048828125,
        970.20703125
      ],
      [
        -3543.282958984375,
        -4988.2509765625,
        972.4573974609375
      ],
      [
        -3542.84326171875,
        -4989.00048828125,
        971.7073364257812
      ],
      [
        -3577.382568359375,
        -4988.25048828125,
        972.457275390625
      ],
      [
        -3576.000244140625,
        -4989.00048828125,
        970.74267578125
      ],
      [
        -3576.9326171875,
        -4989.00048828125,
        971.707275390625
      ],
      [
        -3536.0,
        -4989.00048828125,
        971.55029296875
      ],
      [
        -3537.343017578125,
        -4989.00048828125,
        970.20703125
      ],
      [
        -3533.207275390625,
        -4989.00048828125,
        972.70703125
      ],
      [
        -3532.0,
        -4988.50048828125,
        972.70703125
      ],
      [
        -3577.89892578125,
        -4989.00048828125,
        972.70703125
      ],
      [
        -3581.843505859375,
        -4989.00048828125,
        972.70703125
      ],
      [
        -3543.843017578125,
        -4989.00048828125,
        972.70703125
      ],
      [
        -3538.328369140625,
        -4989.00048828125,
        962.70703125
      ],
      [
        -3576.000244140625,
        -4989.00048828125,
        964.67138671875
      ],
      [
        -3583.596435546875,
        -4989.00048828125,
        964.4600219726562
      ],
      [
        -3581.843505859375,
        -4989.00048828125,
        962.70703125
      ],
      [
        -3583.596435546875,
        -4989.00048828125,
        964.4600219726562
      ],
      [
        -3544.5,
        -4986.8291015625,
        962.70703125
      ],
      [
        -3544.5,
        -4986.8291015625,
        962.70703125
      ],
      [
        -3542.328369140625,
        -4989.00048828125,
        962.70703125
      ],
      [
        -3576.000244140625,
        -4989.00048828125,
        964.67138671875
      ],
      [
        -3577.89892578125,
        -4989.00048828125,
        962.70703125
      ],
      [
        -3538.328369140625,
        -4979.00048828125,
        962.70703125
      ],
      [
        -3544.5,
        -4981.171875,
        962.70703125
      ],
      [
        -3544.5,
        -4981.171875,
        962.70703125
      ],
      [
        -3542.328369140625,
        -4979.00048828125,
        962.70703125
      ],
      [
        -3560.0,
        -4979.00048828125,
        944.8787231445312
      ],
      [
        -3560.0,
        -4979.00048828125,
        940.8787231445312
      ],
      [
        -3570.0,
        -4979.00048828125,
        940.8787231445312
      ],
      [
        -3570.0,
        -4979.00048828125,
        944.8787231445312
      ],
      [
        -3567.0,
        -4979.00048828125,
        947.8787231445312
      ],
      [
        -3563.0,
        -4979.00048828125,
        947.8787231445312
      ],
      [
        -3563.0,
        -4979.00048828125,
        947.8787231445312
      ],
      [
        -3560.0,
        -4982.0009765625,
        943.6359252929688
      ],
      [
        -3570.0,
        -4982.00048828125,
        943.6361083984375
      ],
      [
        -3567.0,
        -4979.00048828125,
        947.8787231445312
      ],
      [
        -3570.0,
        -4979.00048828125,
        944.8787231445312
      ],
      [
        -3567.490234375,
        -4979.00048828125,
        937.8902587890625
      ],
      [
        -3567.490234375,
        -4979.00048828125,
        937.8902587890625
      ],
      [
        -3567.82861328125,
        -4979.00048828125,
        938.7072143554688
      ],
      [
        -3567.82861328125,
        -4979.00048828125,
        938.7072143554688
      ],
      [
        -3570.0,
        -4979.00048828125,
        940.8787231445312
      ],
      [
        -3603.585693359375,
        -4985.41455078125,
        938.1212158203125
      ],
      [
        -3603.585693359375,
        -4982.5859375,
        938.1212158203125
      ],
      [
        -3603.0,
        -4984.0,
        936.70703125
      ],
      [
        -3603.585693359375,
        -4982.5859375,
        938.1212158203125
      ],
      [
        -3603.585693359375,
        -4985.41455078125,
        938.1212158203125
      ],
      [
        -3603.0,
        -4984.8291015625,
        936.70703125
      ],
      [
        -3603.0,
        -4983.17236328125,
        936.70703125
      ],
      [
        -3560.0,
        -4979.00048828125,
        944.8787231445312
      ],
      [
        -3562.509765625,
        -4979.00048828125,
        937.8902587890625
      ],
      [
        -3562.17138671875,
        -4979.00048828125,
        938.7072143554688
      ],
      [
        -3562.509765625,
        -4979.00048828125,
        937.8902587890625
      ],
      [
        -3562.17138671875,
        -4979.00048828125,
        938.7072143554688
      ],
      [
        -3560.0,
        -4979.00048828125,
        940.8787231445312
      ],
      [
        -3538.600341796875,
        -4989.00048828125,
        949.7070922851562
      ],
      [
        -3542.843017578125,
        -4986.00048828125,
        952.706787109375
      ],
      [
        -3542.8427734375,
        -4982.00048828125,
        952.7064208984375
      ],
      [
        -3538.600341796875,
        -4979.00048828125,
        949.7067260742188
      ],
      [
        -3533.328369140625,
        -4984.82861328125,
        953.8786010742188
      ],
      [
        -3533.328369140625,
        -4983.17236328125,
        953.8786010742188
      ],
      [
        -3533.328369140625,
        -4983.17236328125,
        953.8786010742188
      ],
      [
        -3533.328369140625,
        -4984.82861328125,
        953.8786010742188
      ],
      [
        -3533.67138671875,
        -4984.00048828125,
        954.7067260742188
      ],
      [
        -3541.5,
        -4979.00048828125,
        959.70703125
      ],
      [
        -3532.385498046875,
        -4982.78173828125,
        953.4880981445312
      ],
      [
        -3537.5,
        -4979.00048828125,
        959.70703125
      ],
      [
        -3545.085693359375,
        -4985.4150390625,
        962.1212158203125
      ],
      [
        -3545.328125,
        -4981.51513671875,
        962.70703125
      ],
      [
        -3546.5,
        -4984.00048828125,
        962.70703125
      ],
      [
        -3545.085693359375,
        -4985.4150390625,
        962.1212158203125
      ],
      [
        -3546.5,
        -4984.82861328125,
        962.70703125
      ],
      [
        -3532.38525390625,
        -4985.21923828125,
        953.4879760742188
      ],
      [
        -3535.620849609375,
        -4981.00048828125,
        972.70703125
      ],
      [
        -3603.054931640625,
        -4980.75048828125,
        971.4570922851562
      ],
      [
        -3603.054931640625,
        -4981.00048828125,
        972.70703125
      ],
      [
        -3603.054931640625,
        -4980.25048828125,
        971.95703125
      ],
      [
        -3543.721923828125,
        -4987.5009765625,
        973.20703125
      ],
      [
        -3543.42919921875,
        -4988.0009765625,
        972.70703125
      ],
      [
        -3543.721923828125,
        -4987.5009765625,
        973.20703125
      ],
      [
        -3541.8994140625,
        -4983.10107421875,
        974.70703125
      ],
      [
        -3543.1005859375,
        -4986.00048828125,
        974.70703125
      ],
      [
        -3541.8994140625,
        -4983.10107421875,
        974.70703125
      ],
      [
        -3541.65673828125,
        -4983.00048828125,
        974.70703125
      ],
      [
        -3544.343017578125,
        -4989.00048828125,
        973.20703125
      ],
      [
        -3544.343017578125,
        -4989.00048828125,
        974.70703125
      ],
      [
        -3544.343017578125,
        -4989.00048828125,
        973.20703125
      ],
      [
        -3543.635986328125,
        -4988.50048828125,
        972.70703125
      ],
      [
        -3544.343017578125,
        -4989.00048828125,
        977.20703125
      ],
      [
        -3544.343017578125,
        -4989.00048828125,
        977.20703125
      ],
      [
        -3541.868408203125,
        -4987.25048828125,
        978.9568481445312
      ],
      [
        -3541.343017578125,
        -4989.00048828125,
        980.20703125
      ],
      [
        -3541.343017578125,
        -4989.00048828125,
        980.20703125
      ],
      [
        -3537.343017578125,
        -4989.00048828125,
        980.20703125
      ],
      [
        -3536.0,
        -4989.00048828125,
        978.8639526367188
      ],
      [
        -3537.343017578125,
        -4989.00048828125,
        980.20703125
      ],
      [
        -3536.0,
        -4989.00048828125,
        978.8639526367188
      ],
      [
        -3560.0,
        -4979.00048828125,
        941.70703125
      ],
      [
        -3570.0,
        -4979.00048828125,
        941.70703125
      ],
      [
        -3561.5849609375,
        -4979.00048828125,
        939.293701171875
      ],
      [
        -3560.982666015625,
        -4977.00048828125,
        940.7244873046875
      ],
      [
        -3562.947265625,
        -4977.00048828125,
        938.7598876953125
      ],
      [
        -3562.98974609375,
        -4977.02490234375,
        938.7071533203125
      ],
      [
        -3574.894287109375,
        -4930.87451171875,
        908.70703125
      ],
      [
        -3599.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      [
        -3595.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      [
        -3594.0,
        -4965.68310546875,
        908.70703125
      ],
      [
        -3602.34326171875,
        -4960.0263671875,
        908.70703125
      ],
      [
        -3602.34326171875,
        -4964.0263671875,
        908.70703125
      ],
      [
        -3602.34326171875,
        -4964.0263671875,
        908.70703125
      ],
      [
        -3599.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      [
        -3595.122802734375,
        -4940.087890625,
        916.585205078125
      ],
      [
        -3590.000244140625,
        -4944.71630859375,
        918.7070922851562
      ],
      [
        -3587.723876953125,
        -4954.6591796875,
        916.0504760742188
      ],
      [
        -3587.723876953125,
        -4954.6591796875,
        916.0504760742188
      ],
      [
        -3587.52685546875,
        -4955.00048828125,
        916.1547241210938
      ],
      [
        -3587.52685546875,
        -4955.00048828125,
        916.1547241210938
      ],
      [
        -3586.040771484375,
        -4957.5751953125,
        918.7071533203125
      ],
      [
        -3590.66015625,
        -4957.0263671875,
        915.4337158203125
      ],
      [
        -3591.83154296875,
        -4960.0263671875,
        917.9485473632812
      ],
      [
        -3587.974365234375,
        -4955.00048828125,
        912.0949096679688
      ],
      [
        -3587.974365234375,
        -4955.00048828125,
        914.5202026367188
      ],
      [
        -3588.567626953125,
        -4956.43310546875,
        913.3247680664062
      ],
      [
        -3588.383056640625,
        -4953.51708984375,
        912.867431640625
      ],
      [
        -3587.974365234375,
        -4955.00048828125,
        914.5202026367188
      ],
      [
        -3587.974365234375,
        -4955.00048828125,
        912.0949096679688
      ],
      [
        -3588.567626953125,
        -4956.43310546875,
        913.3247680664062
      ],
      [
        -3590.0,
        -4957.0263671875,
        914.8619384765625
      ],
      [
        -3590.0,
        -4957.0263671875,
        914.8619384765625
      ],
      [
        -3590.66015625,
        -4957.0263671875,
        915.4337158203125
      ],
      [
        -3588.383056640625,
        -4953.51708984375,
        914.6839599609375
      ],
      [
        -3599.34326171875,
        -4957.0263671875,
        908.70703125
      ],
      [
        -3602.34326171875,
        -4960.0263671875,
        908.70703125
      ],
      [
        -3595.34326171875,
        -4957.0263671875,
        908.70703125
      ],
      [
        -3599.34326171875,
        -4957.0263671875,
        908.70703125
      ],
      [
        -3594.0,
        -4958.36962890625,
        908.70703125
      ],
      [
        -3587.974365234375,
        -4957.0263671875,
        910.8680419921875
      ],
      [
        -3585.8134765625,
        -4957.0263671875,
        908.7071533203125
      ],
      [
        -3587.974365234375,
        -4957.0263671875,
        910.8680419921875
      ],
      [
        -3594.0,
        -4958.36962890625,
        908.70703125
      ],
      [
        -3595.34326171875,
        -4957.0263671875,
        908.70703125
      ],
      [
        -3588.17041015625,
        -4955.47412109375,
        912.5015869140625
      ],
      [
        -3588.298828125,
        -4955.7841796875,
        912.2448120117188
      ],
      [
        -3595.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      [
        -3594.0,
        -4965.68310546875,
        908.70703125
      ],
      [
        -3562.5146484375,
        -4979.00048828125,
        937.878662109375
      ],
      [
        -3565.828125,
        -4979.00048828125,
        936.70703125
      ],
      [
        -3559.999755859375,
        -4981.17236328125,
        906.7071533203125
      ],
      [
        -3559.999755859375,
        -4981.17236328125,
        906.7071533203125
      ],
      [
        -3560.868408203125,
        -4980.3037109375,
        906.7071533203125
      ],
      [
        -3562.171630859375,
        -4979.00048828125,
        906.7071533203125
      ],
      [
        -3560.868408203125,
        -4980.3037109375,
        906.7071533203125
      ],
      [
        -3559.4140625,
        -4985.4150390625,
        907.2928466796875
      ],
      [
        -3558.0,
        -4983.1728515625,
        906.7071533203125
      ],
      [
        -3560.0,
        -4984.0009765625,
        908.70703125
      ],
      [
        -3559.4140625,
        -4985.4150390625,
        907.2928466796875
      ],
      [
        -3558.94287109375,
        -4985.60986328125,
        907.0977172851562
      ],
      [
        -3590.4140625,
        -4962.0263671875,
        908.5355834960938
      ],
      [
        -3590.0,
        -4962.369140625,
        908.7071533203125
      ],
      [
        -3566.990234375,
        -5066.109375,
        951.1815185546875
      ],
      [
        -3563.009033203125,
        -5066.109375,
        951.1815185546875
      ],
      [
        -3563.0,
        -5046.45703125,
        939.4762573242188
      ],
      [
        -3566.216796875,
        -5044.599609375,
        938.70703125
      ],
      [
        -3560.0,
        -5048.18896484375,
        943.1937255859375
      ],
      [
        -3563.0,
        -5046.45703125,
        939.4762573242188
      ],
      [
        -3570.0,
        -5042.41552734375,
        945.70703125
      ],
      [
        -3570.0,
        -5042.41552734375,
        941.70703125
      ],
      [
        -3560.0,
        -5048.18896484375,
        945.117919921875
      ],
      [
        -3560.0,
        -5048.18896484375,
        948.70703125
      ],
      [
        -3560.0,
        -5048.18896484375,
        945.117919921875
      ],
      [
        -3560.0,
        -5048.18896484375,
        943.1937255859375
      ],
      [
        -3567.0,
        -5044.1474609375,
        948.70703125
      ],
      [
        -3570.0,
        -5042.41552734375,
        945.70703125
      ],
      [
        -3570.0,
        -5042.41552734375,
        941.70703125
      ],
      [
        -3567.0,
        -5044.1474609375,
        938.70703125
      ],
      [
        -3567.0,
        -5044.1474609375,
        938.70703125
      ],
      [
        -3566.216796875,
        -5044.599609375,
        938.70703125
      ],
      [
        -3567.0,
        -5044.1474609375,
        948.70703125
      ],
      [
        -3566.216796875,
        -5044.599609375,
        948.70703125
      ],
      [
        -3560.0,
        -5042.5009765625,
        941.70703125
      ],
      [
        -3560.0,
        -5042.5009765625,
        945.70703125
      ],
      [
        -3563.0,
        -5044.23291015625,
        938.70703125
      ],
      [
        -3560.0,
        -5042.5009765625,
        941.70703125
      ],
      [
        -3560.0,
        -5042.5009765625,
        945.70703125
      ],
      [
        -3563.0,
        -5044.23291015625,
        948.70703125
      ],
      [
        -3564.92578125,
        -5045.34521484375,
        939.0157470703125
      ],
      [
        -3563.634765625,
        -5044.599609375,
        938.70703125
      ],
      [
        -3563.0,
        -5044.23291015625,
        938.70703125
      ],
      [
        -3563.634765625,
        -5044.599609375,
        938.70703125
      ],
      [
        -3563.0,
        -5044.23291015625,
        948.70703125
      ],
      [
        -3563.634765625,
        -5044.599609375,
        948.70703125
      ],
      [
        -3567.0,
        -5037.12646484375,
        938.70703125
      ],
      [
        -3563.0,
        -5037.12646484375,
        938.70703125
      ],
      [
        -3563.0,
        -5037.12646484375,
        948.70703125
      ],
      [
        -3567.0,
        -5037.12646484375,
        948.70703125
      ],
      [
        -3563.0,
        -5037.12646484375,
        938.70703125
      ],
      [
        -3560.0,
        -5037.12646484375,
        941.70703125
      ],
      [
        -3560.0,
        -5037.12646484375,
        945.70703125
      ],
      [
        -3563.0,
        -5037.12646484375,
        948.70703125
      ],
      [
        -3570.0,
        -5037.12646484375,
        941.70703125
      ],
      [
        -3567.0,
        -5037.12646484375,
        938.70703125
      ],
      [
        -3567.0,
        -5037.12646484375,
        948.70703125
      ],
      [
        -3570.0,
        -5037.12646484375,
        945.70703125
      ],
      [
        -3560.0,
        -5037.12646484375,
        941.70703125
      ],
      [
        -3560.0,
        -5037.12646484375,
        945.70703125
      ],
      [
        -3570.0,
        -5037.12646484375,
        945.70703125
      ],
      [
        -3570.0,
        -5037.12646484375,
        941.70703125
      ],
      [
        -3569.860107421875,
        -5006.00048828125,
        957.7067260742188
      ],
      [
        -3569.860107421875,
        -5002.00048828125,
        957.7067260742188
      ],
      [
        -3559.860107421875,
        -5006.17578125,
        967.7069091796875
      ],
      [
        -3559.860107421875,
        -5004.52001953125,
        967.7069702148438
      ],
      [
        -3559.860107421875,
        -5006.17626953125,
        967.7066650390625
      ],
      [
        -3562.860107421875,
        -5000.2236328125,
        964.7066650390625
      ],
      [
        -3566.860107421875,
        -5000.22412109375,
        964.7073974609375
      ],
      [
        -3559.860107421875,
        -5004.52001953125,
        967.7066650390625
      ],
      [
        -3560.721923828125,
        -5003.28857421875,
        966.8448486328125
      ],
      [
        -3562.860107421875,
        -5000.2236328125,
        964.7066650390625
      ],
      [
        -3560.721923828125,
        -5003.28857421875,
        966.8448486328125
      ],
      [
        -3568.9990234375,
        -5003.2900390625,
        966.846435546875
      ],
      [
        -3569.860107421875,
        -5004.5205078125,
        967.7075805664062
      ],
      [
        -3566.860107421875,
        -5000.22412109375,
        964.70751953125
      ],
      [
        -3568.9990234375,
        -5003.2900390625,
        966.846435546875
      ],
      [
        -3563.65087890625,
        -5009.966796875,
        963.916015625
      ],
      [
        -3566.068603515625,
        -5009.966796875,
        963.916015625
      ],
      [
        -3564.859619140625,
        -4999.373046875,
        962.7071533203125
      ],
      [
        -3566.068603515625,
        -5009.966796875,
        963.916015625
      ],
      [
        -3563.65087890625,
        -5009.966796875,
        963.916015625
      ],
      [
        -3564.859619140625,
        -5009.40673828125,
        962.7070922851562
      ],
      [
        -3569.860107421875,
        -5002.00048828125,
        957.7067260742188
      ],
      [
        -3566.860107421875,
        -4999.00048828125,
        960.7067260742188
      ],
      [
        -3565.73583984375,
        -4999.00048828125,
        961.8309326171875
      ],
      [
        -3566.85009765625,
        -5000.2197265625,
        964.6973266601562
      ],
      [
        -3565.73583984375,
        -4999.00048828125,
        961.8309326171875
      ],
      [
        -3566.860107421875,
        -4999.00048828125,
        960.7067260742188
      ],
      [
        -3566.860107421875,
        -5009.00048828125,
        960.7067260742188
      ],
      [
        -3569.860107421875,
        -5006.00048828125,
        957.7067260742188
      ],
      [
        -3565.94873046875,
        -5009.9111328125,
        963.796142578125
      ],
      [
        -3565.73583984375,
        -5009.00048828125,
        961.8309326171875
      ],
      [
        -3565.73583984375,
        -5009.00048828125,
        961.8309326171875
      ],
      [
        -3566.860107421875,
        -5009.00048828125,
        960.7067260742188
      ],
      [
        -3566.3125,
        -5010.63134765625,
        964.1597290039062
      ],
      [
        -3605.860107421875,
        -5001.93798828125,
        921.70703125
      ],
      [
        -3604.7421875,
        -5001.29248046875,
        922.824951171875
      ],
      [
        -3600.447998046875,
        -5008.72998046875,
        927.1187744140625
      ],
      [
        -3601.859619140625,
        -5011.17529296875,
        925.70703125
      ],
      [
        -3608.859619140625,
        -5007.1337890625,
        918.70703125
      ],
      [
        -3605.85986328125,
        -5001.9375,
        921.70703125
      ],
      [
        -3604.7421875,
        -5001.29248046875,
        922.824951171875
      ],
      [
        -3600.447998046875,
        -5008.72998046875,
        927.1187744140625
      ],
      [
        -3601.859619140625,
        -5011.17529296875,
        925.70703125
      ],
      [
        -3605.859619140625,
        -5013.484375,
        921.70703125
      ],
      [
        -3608.859619140625,
        -5011.75244140625,
        918.70703125
      ],
      [
        -3608.859619140625,
        -5007.1337890625,
        918.70703125
      ],
      [
        -3605.859619140625,
        -5013.484375,
        921.70703125
      ],
      [
        -3608.859619140625,
        -5011.75244140625,
        918.70703125
      ],
      [
        -3581.757080078125,
        -4989.00048828125,
        962.70703125
      ],
      [
        -3578.171630859375,
        -4994.00048828125,
        962.70703125
      ],
      [
        -3576.0,
        -4990.177734375,
        965.1184692382812
      ],
      [
        -3576.0,
        -4990.177734375,
        965.1184692382812
      ],
      [
        -3576.0,
        -4996.17236328125,
        962.70703125
      ],
      [
        -3578.171630859375,
        -4994.00048828125,
        962.70703125
      ],
      [
        -3576.171630859375,
        -4996.8291015625,
        960.70703125
      ],
      [
        -3581.82861328125,
        -4994.00048828125,
        960.70703125
      ],
      [
        -3575.031494140625,
        -4989.00048828125,
        965.0726928710938
      ],
      [
        -3573.5,
        -4989.00048828125,
        968.1757202148438
      ],
      [
        -3575.01806640625,
        -4989.62939453125,
        969.70703125
      ],
      [
        -3573.5,
        -4989.00048828125,
        968.4495849609375
      ],
      [
        -3575.646240234375,
        -4989.00048828125,
        970.5960693359375
      ],
      [
        -3575.01806640625,
        -4989.62939453125,
        969.70703125
      ],
      [
        -3582.0,
        -5009.00048828125,
        945.5668334960938
      ],
      [
        -3582.0,
        -4999.00048828125,
        945.5668334960938
      ],
      [
        -3577.999755859375,
        -5002.00048828125,
        949.5670776367188
      ],
      [
        -3577.999755859375,
        -5006.00048828125,
        949.5670776367188
      ],
      [
        -3577.999755859375,
        -5006.00048828125,
        949.5670776367188
      ],
      [
        -3577.999755859375,
        -5002.00048828125,
        949.5670776367188
      ],
      [
        -3580.999755859375,
        -5009.00048828125,
        946.5670776367188
      ],
      [
        -3577.999755859375,
        -5006.00048828125,
        949.5670776367188
      ],
      [
        -3577.999755859375,
        -5002.00048828125,
        949.5670776367188
      ],
      [
        -3580.999755859375,
        -4999.00048828125,
        946.5670776367188
      ],
      [
        -3582.0,
        -5009.00048828125,
        945.5668334960938
      ],
      [
        -3580.999755859375,
        -5009.00048828125,
        946.5670776367188
      ],
      [
        -3580.999755859375,
        -4999.00048828125,
        946.5670776367188
      ],
      [
        -3582.0,
        -4999.00048828125,
        945.5668334960938
      ],
      [
        -3562.870849609375,
        -5000.21923828125,
        964.6958618164062
      ],
      [
        -3570.48681640625,
        -5005.37353515625,
        950.19384765625
      ],
      [
        -3570.48681640625,
        -5002.626953125,
        950.19384765625
      ],
      [
        -3570.48681640625,
        -5002.626953125,
        950.19384765625
      ],
      [
        -3570.48681640625,
        -5005.37353515625,
        950.19384765625
      ],
      [
        -3571.85986328125,
        -5004.0,
        949.6251220703125
      ],
      [
        -3576.860107421875,
        -5009.00048828125,
        946.5670776367188
      ],
      [
        -3573.860107421875,
        -5006.00048828125,
        949.5670776367188
      ],
      [
        -3572.0,
        -5004.14013671875,
        949.5670776367188
      ],
      [
        -3573.860107421875,
        -5006.00048828125,
        949.5670776367188
      ],
      [
        -3572.0,
        -5004.14013671875,
        949.5670776367188
      ],
      [
        -3570.278076171875,
        -5005.58251953125,
        950.6980590820312
      ],
      [
        -3570.278076171875,
        -5002.41845703125,
        950.69775390625
      ],
      [
        -3563.77099609375,
        -5009.9111328125,
        963.7958984375
      ],
      [
        -3563.407470703125,
        -5010.630859375,
        964.159423828125
      ],
      [
        -3566.414306640625,
        -5025.08642578125,
        938.1212768554688
      ],
      [
        -3563.585693359375,
        -5025.08642578125,
        938.1212768554688
      ],
      [
        -3563.585693359375,
        -5025.08642578125,
        938.1212768554688
      ],
      [
        -3566.414306640625,
        -5025.08642578125,
        938.1212768554688
      ],
      [
        -3565.000244140625,
        -5024.50048828125,
        936.70703125
      ],
      [
        -3566.414306640625,
        -5025.08642578125,
        938.1212768554688
      ],
      [
        -3563.585693359375,
        -5025.08642578125,
        938.1212768554688
      ],
      [
        -3563.585693359375,
        -5025.08642578125,
        938.1212768554688
      ],
      [
        -3566.414306640625,
        -5025.08642578125,
        938.1212768554688
      ],
      [
        -3565.000244140625,
        -5024.50048828125,
        936.70703125
      ],
      [
        -3570.0,
        -5021.50048828125,
        931.7072143554688
      ],
      [
        -3567.0,
        -5024.50048828125,
        934.7072143554688
      ],
      [
        -3567.0,
        -5024.50048828125,
        934.7071533203125
      ],
      [
        -3570.0,
        -5021.50048828125,
        931.7072143554688
      ],
      [
        -3566.609619140625,
        -5024.89111328125,
        937.6499633789062
      ],
      [
        -3566.609619140625,
        -5024.89111328125,
        937.6499633789062
      ],
      [
        -3565.000244140625,
        -5024.50048828125,
        936.70703125
      ],
      [
        -3567.0,
        -5024.50048828125,
        934.7072143554688
      ],
      [
        -3567.0,
        -5024.50048828125,
        934.7072143554688
      ],
      [
        -3565.000244140625,
        -5024.50048828125,
        936.70703125
      ],
      [
        -3570.0,
        -5022.91455078125,
        926.70703125
      ],
      [
        -3570.0,
        -5022.91455078125,
        927.70703125
      ],
      [
        -3566.000244140625,
        -5025.50048828125,
        927.70703125
      ],
      [
        -3570.0,
        -5022.91455078125,
        927.70703125
      ],
      [
        -3566.000244140625,
        -5025.50048828125,
        926.70703125
      ],
      [
        -3566.000244140625,
        -5025.50048828125,
        927.70703125
      ],
      [
        -3563.999755859375,
        -5025.50048828125,
        927.70703125
      ],
      [
        -3563.999755859375,
        -5025.50048828125,
        926.70703125
      ],
      [
        -3563.999755859375,
        -5025.50048828125,
        927.70703125
      ],
      [
        -3560.0,
        -5022.91455078125,
        927.70703125
      ],
      [
        -3560.0,
        -5022.91455078125,
        926.70703125
      ],
      [
        -3560.0,
        -5022.91455078125,
        927.70703125
      ],
      [
        -3563.390380859375,
        -5024.89111328125,
        937.64990234375
      ],
      [
        -3563.390380859375,
        -5024.89111328125,
        937.64990234375
      ],
      [
        -3571.0,
        -5018.5009765625,
        927.70703125
      ],
      [
        -3559.0,
        -5018.5,
        927.70703125
      ],
      [
        -3568.414306640625,
        -5014.50048828125,
        927.70703125
      ],
      [
        -3563.999755859375,
        -5013.50048828125,
        927.70703125
      ],
      [
        -3534.343017578125,
        -4989.00048828125,
        972.236572265625
      ],
      [
        -3532.0,
        -4989.00048828125,
        974.8641967773438
      ],
      [
        -3533.800048828125,
        -4971.66015625,
        1023.70703125
      ],
      [
        -3533.800048828125,
        -4996.3408203125,
        1023.70703125
      ],
      [
        -3544.140625,
        -5010.2509765625,
        1023.70703125
      ],
      [
        -3560.050537109375,
        -5017.12646484375,
        1023.70703125
      ],
      [
        -3577.2666015625,
        -5015.1259765625,
        1023.70703125
      ],
      [
        -3572.95654296875,
        -4954.029296875,
        1025.1507568359375
      ],
      [
        -3574.593017578125,
        -4953.640625,
        1023.70703125
      ],
      [
        -3591.17578125,
        -4963.21484375,
        1023.70703125
      ],
      [
        -3574.593017578125,
        -4953.640625,
        1023.70703125
      ],
      [
        -3576.5927734375,
        -4952.48583984375,
        1023.70703125
      ],
      [
        -3572.95654296875,
        -4954.029296875,
        1025.1507568359375
      ],
      [
        -3565.65771484375,
        -4956.87451171875,
        1028.70703125
      ],
      [
        -3592.0517578125,
        -4983.2685546875,
        1028.70703125
      ],
      [
        -3594.89697265625,
        -4975.9697265625,
        1025.150390625
      ],
      [
        -3596.0517578125,
        -4971.66015625,
        1023.70703125
      ],
      [
        -3596.4404296875,
        -4972.33349609375,
        1023.70703125
      ],
      [
        -3596.0517578125,
        -4973.0068359375,
        1023.70703125
      ],
      [
        -3594.89697265625,
        -4975.9697265625,
        1025.150390625
      ],
      [
        -3595.285888671875,
        -4974.333984375,
        1023.70703125
      ],
      [
        -3595.285888671875,
        -4974.333984375,
        1023.70703125
      ],
      [
        -3588.783203125,
        -4996.93017578125,
        1028.70703125
      ],
      [
        -3594.89697265625,
        -4992.03125,
        1025.150390625
      ],
      [
        -3598.0517578125,
        -4988.876953125,
        1023.70703125
      ],
      [
        -3598.0517578125,
        -4989.65478515625,
        1023.70703125
      ],
      [
        -3597.378173828125,
        -4990.04345703125,
        1023.70703125
      ],
      [
        -3594.89697265625,
        -4992.03125,
        1025.150390625
      ],
      [
        -3596.0517578125,
        -4990.80908203125,
        1023.70703125
      ],
      [
        -3596.0517578125,
        -4973.0068359375,
        1023.70703125
      ],
      [
        -3596.0517578125,
        -4990.80908203125,
        1023.70703125
      ],
      [
        -3541.068359375,
        -4971.0712890625,
        1028.70703125
      ],
      [
        -3534.954833984375,
        -4975.9697265625,
        1025.150390625
      ],
      [
        -3569.802001953125,
        -4950.87451171875,
        1023.70703125
      ],
      [
        -3552.585693359375,
        -4952.87451171875,
        1023.70703125
      ],
      [
        -3538.675537109375,
        -4963.21533203125,
        1023.70703125
      ],
      [
        -3534.56591796875,
        -4974.33349609375,
        1023.70703125
      ],
      [
        -3534.56591796875,
        -4974.33349609375,
        1023.70703125
      ],
      [
        -3533.800048828125,
        -4973.00732421875,
        1023.70703125
      ],
      [
        -3574.593017578125,
        -5014.3603515625,
        1023.70703125
      ],
      [
        -3575.91943359375,
        -5015.1259765625,
        1023.70703125
      ],
      [
        -3572.95654296875,
        -5013.9716796875,
        1025.1507568359375
      ],
      [
        -3574.593017578125,
        -5014.3603515625,
        1023.70703125
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3511.800048828125,
      "bbox_min": [
        -3618.054931640625,
        -5079.00048828125,
        818.70703125
      ],
      "bbox_max": [
        -3355.0,
        -4913.37451171875,
        1081.70703125
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1031.70703125,
      "bbox_min": [
        -3511.800048828125,
        -5079.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3355.0,
        -4940.70068359375,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -993.70703125,
      "bbox_min": [
        -3511.800048828125,
        -4997.0205078125,
        942.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4971.00048828125,
        1031.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4199.30029296875,
      "bbox_min": [
        -3511.800048828125,
        -4989.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3510.30517578125,
        -4979.00048828125,
        952.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2849.140869140625,
      "bbox_min": [
        -3511.800048828125,
        -4989.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3510.30517578125,
        -4979.00048828125,
        952.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2859.040283203125,
      "bbox_min": [
        -3511.800048828125,
        -4989.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3510.30517578125,
        -4979.00048828125,
        952.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4189.40087890625,
      "bbox_min": [
        -3511.800048828125,
        -4989.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3510.30517578125,
        -4979.00048828125,
        952.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4989.00048828125,
      "bbox_min": [
        -3511.800048828125,
        -4989.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3510.30517578125,
        -4979.00048828125,
        952.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4979.00048828125,
      "bbox_min": [
        -3511.800048828125,
        -4986.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3510.30517578125,
        -4979.00048828125,
        952.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -952.70703125,
      "bbox_min": [
        -3511.800048828125,
        -4986.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3510.30517578125,
        -4982.00048828125,
        952.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 942.70703125,
      "bbox_min": [
        -3511.800048828125,
        -4986.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3510.30517578125,
        -4982.00048828125,
        942.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29408586025238037,
        0.0,
        -0.9557790160179138
      ],
      "plane_d": 1987.519775390625,
      "bbox_min": [
        -3511.800048828125,
        -4997.0205078125,
        993.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4971.00048828125,
        1031.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1008.70703125,
      "bbox_min": [
        -3511.800048828125,
        -4994.0205078125,
        998.92236328125
      ],
      "bbox_max": [
        -3480.0,
        -4974.00048828125,
        1008.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0006289303419180214,
        0.9999998211860657,
        0.0
      ],
      "plane_d": 4991.81103515625,
      "bbox_min": [
        -3511.800048828125,
        -4994.0205078125,
        998.92236328125
      ],
      "bbox_max": [
        -3480.0,
        -4974.00048828125,
        1008.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0006289453012868762,
        -0.9999998211860657,
        0.0
      ],
      "plane_d": -4971.810546875,
      "bbox_min": [
        -3511.800048828125,
        -4974.0205078125,
        998.92236328125
      ],
      "bbox_max": [
        -3480.0,
        -4974.00048828125,
        1008.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1016.70703125,
      "bbox_min": [
        -3511.800048828125,
        -4997.0205078125,
        993.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4971.00048828125,
        1031.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4974.00048828125,
      "bbox_min": [
        -3400.0,
        -4994.00048828125,
        1016.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4974.00048828125,
        1031.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4994.00048828125,
      "bbox_min": [
        -3400.0,
        -4994.00048828125,
        1016.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4974.00048828125,
        1031.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3400.0,
      "bbox_min": [
        -3400.0,
        -4994.00048828125,
        1016.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4974.00048828125,
        1031.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3380.0,
      "bbox_min": [
        -3380.0,
        -4994.00048828125,
        1016.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4974.00048828125,
        1031.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0006289453012868762,
        -0.9999998211860657,
        0.0
      ],
      "plane_d": -4968.810546875,
      "bbox_min": [
        -3511.800048828125,
        -4997.0205078125,
        993.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4971.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4994.00048828125,
      "bbox_min": [
        -3511.800048828125,
        -4997.0205078125,
        993.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4971.00048828125,
        1016.70703125
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0006289303419180214,
        0.9999998211860657,
        0.0
      ],
      "plane_d": 4991.81103515625,
      "bbox_min": [
        -3511.800048828125,
        -4997.0205078125,
        993.70703125
      ],
      "bbox_max": [
        -3454.0,
        -4994.00048828125,
        1008.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28020867705345154,
        0.30355939269065857,
        -0.9106782078742981
      ],
      "plane_d": 3399.69189453125,
      "bbox_min": [
        -3480.0,
        -4997.00048828125,
        996.704833984375
      ],
      "bbox_max": [
        -3454.0,
        -4994.00048828125,
        1005.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4997.00048828125,
      "bbox_min": [
        -3480.0,
        -4997.00048828125,
        996.704833984375
      ],
      "bbox_max": [
        -3454.0,
        -4994.00048828125,
        1005.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3454.0,
      "bbox_min": [
        -3454.0,
        -4997.00048828125,
        1001.70703125
      ],
      "bbox_max": [
        -3454.0,
        -4994.00048828125,
        1005.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0006289303419180214,
        0.9999998211860657,
        0.0
      ],
      "plane_d": 4994.81103515625,
      "bbox_min": [
        -3511.800048828125,
        -4997.0205078125,
        993.70703125
      ],
      "bbox_max": [
        -3467.00927734375,
        -4994.00048828125,
        997.7042236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29408586025238037,
        0.0,
        0.9557790160179138
      ],
      "plane_d": -1973.18310546875,
      "bbox_min": [
        -3480.0,
        -4997.00048828125,
        993.70703125
      ],
      "bbox_max": [
        -3470.250732421875,
        -4996.99462890625,
        996.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4997.00048828125,
      "bbox_min": [
        -3480.0,
        -4997.00048828125,
        993.70703125
      ],
      "bbox_max": [
        -3470.257080078125,
        -4997.00048828125,
        996.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29408586025238037,
        0.0,
        0.9557790160179138
      ],
      "plane_d": -1973.18310546875,
      "bbox_min": [
        -3480.0,
        -4997.00048828125,
        993.70703125
      ],
      "bbox_max": [
        -3467.00927734375,
        -4994.00048828125,
        997.7042236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1001.70703125,
      "bbox_min": [
        -3511.800048828125,
        -4994.00048828125,
        993.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4971.00048828125,
        1016.70703125
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.29408586025238037,
        0.0,
        0.9557790160179138
      ],
      "plane_d": -1973.18310546875,
      "bbox_min": [
        -3511.800048828125,
        -4994.00048828125,
        993.70703125
      ],
      "bbox_max": [
        -3454.0,
        -4971.00048828125,
        1001.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.00019888998940587044,
        -0.3162277638912201,
        -0.9486832618713379
      ],
      "plane_d": -625.7169189453125,
      "bbox_min": [
        -3511.800048828125,
        -4974.0205078125,
        993.70703125
      ],
      "bbox_max": [
        -3454.0,
        -4971.00048828125,
        1001.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0006289453012868762,
        -0.9999998211860657,
        0.0
      ],
      "plane_d": -4971.810546875,
      "bbox_min": [
        -3511.800048828125,
        -4974.0205078125,
        996.70703125
      ],
      "bbox_max": [
        -3454.0,
        -4971.00048828125,
        1001.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28020867705345154,
        -0.30355939269065857,
        -0.9106782078742981
      ],
      "plane_d": 373.81170654296875,
      "bbox_min": [
        -3480.0,
        -4974.00048828125,
        996.70703125
      ],
      "bbox_max": [
        -3463.75,
        -4971.00048828125,
        1001.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28020867705345154,
        -0.30355939269065857,
        -0.9106782078742981
      ],
      "plane_d": 373.81170654296875,
      "bbox_min": [
        -3480.0,
        -4974.00048828125,
        997.70703125
      ],
      "bbox_max": [
        -3466.990966796875,
        -4973.9921875,
        1001.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4974.00048828125,
      "bbox_min": [
        -3480.0,
        -4974.00048828125,
        997.70703125
      ],
      "bbox_max": [
        -3467.0,
        -4974.00048828125,
        1001.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4971.00048828125,
      "bbox_min": [
        -3480.0,
        -4971.00048828125,
        993.70703125
      ],
      "bbox_max": [
        -3470.2431640625,
        -4971.00048828125,
        996.7091064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4974.00048828125,
      "bbox_min": [
        -3502.75,
        -4994.00048828125,
        1001.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4971.00048828125,
        1016.70703125
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.28020867705345154,
        -0.30355939269065857,
        -0.9106782078742981
      ],
      "plane_d": 373.81170654296875,
      "bbox_min": [
        -3467.0,
        -4974.00048828125,
        1001.70703125
      ],
      "bbox_max": [
        -3417.0,
        -4971.00048828125,
        1008.9070434570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4971.00048828125,
      "bbox_min": [
        -3463.75,
        -4974.00048828125,
        1001.70703125
      ],
      "bbox_max": [
        -3417.0,
        -4971.00048828125,
        1008.9070434570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4973.6005859375,
      "bbox_min": [
        -3420.0,
        -4974.00048828125,
        1005.70703125
      ],
      "bbox_max": [
        -3417.0,
        -4973.6005859375,
        1008.9070434570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -4898.64697265625,
      "bbox_min": [
        -3420.0,
        -4974.00048828125,
        1005.70703125
      ],
      "bbox_max": [
        -3417.0,
        -4973.6005859375,
        1008.9070434570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1008.9070434570312,
      "bbox_min": [
        -3420.0,
        -4974.00048828125,
        1005.70703125
      ],
      "bbox_max": [
        -3417.0,
        -4973.6005859375,
        1008.9070434570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3420.0,
      "bbox_min": [
        -3420.0,
        -4974.00048828125,
        1005.70703125
      ],
      "bbox_max": [
        -3417.0,
        -4973.6005859375,
        1008.9070434570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3417.0,
      "bbox_min": [
        -3417.0,
        -4974.00048828125,
        1005.70703125
      ],
      "bbox_max": [
        -3417.0,
        -4973.6005859375,
        1008.9070434570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3380.0,
      "bbox_min": [
        -3502.75,
        -4994.00048828125,
        1001.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4974.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0006289453012868762,
        -0.9999998211860657,
        0.0
      ],
      "plane_d": -4971.810546875,
      "bbox_min": [
        -3502.75,
        -4994.00048828125,
        1001.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4974.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1015.20703125,
      "bbox_min": [
        -3452.0,
        -4994.00048828125,
        1014.5070190429688
      ],
      "bbox_max": [
        -3400.0,
        -4974.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3425.0,
      "bbox_min": [
        -3452.0,
        -4994.00048828125,
        1015.20703125
      ],
      "bbox_max": [
        -3400.0,
        -4974.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1015.70703125,
      "bbox_min": [
        -3422.0,
        -4994.00048828125,
        1015.20703125
      ],
      "bbox_max": [
        -3400.0,
        -4974.00048828125,
        1016.70703125
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4984.00048828125,
      "bbox_min": [
        -3422.0,
        -4994.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4974.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4980.00048828125,
      "bbox_min": [
        -3422.0,
        -4984.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4974.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4976.00048828125,
      "bbox_min": [
        -3422.0,
        -4980.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4974.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162277638912201,
        0.0,
        -0.9486833214759827
      ],
      "plane_d": 2039.707275390625,
      "bbox_min": [
        -3403.0,
        -4976.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4974.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4978.00048828125,
      "bbox_min": [
        -3422.0,
        -4980.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4976.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162277638912201,
        0.0,
        -0.9486833214759827
      ],
      "plane_d": 2039.707275390625,
      "bbox_min": [
        -3403.0,
        -4980.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4978.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3422.0,
      "bbox_min": [
        -3422.0,
        -4978.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3422.0,
        -4976.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4982.00048828125,
      "bbox_min": [
        -3422.0,
        -4984.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4980.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162277638912201,
        0.0,
        -0.9486833214759827
      ],
      "plane_d": 2039.707275390625,
      "bbox_min": [
        -3403.0,
        -4984.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4982.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3422.0,
      "bbox_min": [
        -3422.0,
        -4982.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3422.0,
        -4980.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4988.00048828125,
      "bbox_min": [
        -3422.0,
        -4994.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4984.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4986.00048828125,
      "bbox_min": [
        -3422.0,
        -4988.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4984.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162277638912201,
        0.0,
        -0.9486833214759827
      ],
      "plane_d": 2039.707275390625,
      "bbox_min": [
        -3403.0,
        -4988.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4986.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3422.0,
      "bbox_min": [
        -3422.0,
        -4986.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3422.0,
        -4984.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4992.00048828125,
      "bbox_min": [
        -3422.0,
        -4994.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4988.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4990.00048828125,
      "bbox_min": [
        -3422.0,
        -4992.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4988.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162277638912201,
        0.0,
        -0.9486833214759827
      ],
      "plane_d": 2039.707275390625,
      "bbox_min": [
        -3403.0,
        -4992.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4990.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3422.0,
      "bbox_min": [
        -3422.0,
        -4990.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3422.0,
        -4988.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3422.0,
      "bbox_min": [
        -3422.0,
        -4994.00048828125,
        1015.70703125
      ],
      "bbox_max": [
        -3422.0,
        -4992.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3422.0,
      "bbox_min": [
        -3422.0,
        -4994.00048828125,
        1015.20703125
      ],
      "bbox_max": [
        -3422.0,
        -4974.00048828125,
        1015.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": 3133.81103515625,
      "bbox_min": [
        -3452.0,
        -4994.00048828125,
        1015.20703125
      ],
      "bbox_max": [
        -3427.0,
        -4974.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": -1324.014404296875,
      "bbox_min": [
        -3452.0,
        -4994.00048828125,
        1015.20703125
      ],
      "bbox_max": [
        -3427.0,
        -4974.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": -634.4109497070312,
      "bbox_min": [
        -3452.0,
        -4994.00048828125,
        1015.20703125
      ],
      "bbox_max": [
        -3427.0,
        -4974.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": 2441.971435546875,
      "bbox_min": [
        -3430.0,
        -4994.00048828125,
        1015.20703125
      ],
      "bbox_max": [
        -3427.0,
        -4974.00048828125,
        1016.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22722984850406647,
        0.0,
        -0.97384113073349
      ],
      "plane_d": 1766.23095703125,
      "bbox_min": [
        -3425.0,
        -4994.00048828125,
        1014.5070190429688
      ],
      "bbox_max": [
        -3422.0,
        -4974.00048828125,
        1015.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3425.0,
      "bbox_min": [
        -3425.0,
        -4994.00048828125,
        1014.5070190429688
      ],
      "bbox_max": [
        -3425.0,
        -4974.00048828125,
        1015.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3355.0,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1031.70703125
      ],
      "bbox_max": [
        -3355.0,
        -4940.70068359375,
        1081.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1041.70703125,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1031.70703125
      ],
      "bbox_max": [
        -3355.0,
        -4940.70068359375,
        1081.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.25766265392303467,
        -0.0,
        -0.9662349224090576
      ],
      "plane_d": 152.7041015625,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3355.0,
        -4940.70068359375,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3370.0,
      "bbox_min": [
        -3430.0,
        -5040.73974609375,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4940.70068359375,
        1081.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.37906691431999207,
        -0.9253692626953125
      ],
      "plane_d": 2879.132568359375,
      "bbox_min": [
        -3430.0,
        -5034.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4940.70068359375,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1061.70703125,
      "bbox_min": [
        -3388.75,
        -5034.00048828125,
        1059.4539794921875
      ],
      "bbox_max": [
        -3370.0,
        -5003.50048828125,
        1061.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1075.70703125,
      "bbox_min": [
        -3430.0,
        -5009.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4953.50048828125,
        1078.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4959.00048828125,
      "bbox_min": [
        -3388.0,
        -4962.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4953.50048828125,
        1078.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1078.70703125,
      "bbox_min": [
        -3374.0,
        -4959.00048828125,
        1078.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4953.50048828125,
        1078.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1078.70703125,
      "bbox_min": [
        -3374.0,
        -4962.00048828125,
        1078.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4959.00048828125,
        1078.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5009.00048828125,
      "bbox_min": [
        -3380.301513671875,
        -5009.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5009.00048828125,
        1059.4541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3371.0,
      "bbox_min": [
        -3403.782958984375,
        -5016.50048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4940.70068359375,
        1061.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1045.20703125,
      "bbox_min": [
        -3371.0,
        -5009.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4949.1923828125,
        1056.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9741036295890808,
        -0.2261020690202713,
        -0.0
      ],
      "plane_d": -4402.72607421875,
      "bbox_min": [
        -3371.0,
        -5009.00048828125,
        1045.20703125
      ],
      "bbox_max": [
        -3370.0,
        -4949.1923828125,
        1056.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5009.00048828125,
      "bbox_min": [
        -3371.0,
        -5009.00048828125,
        1045.20703125
      ],
      "bbox_max": [
        -3370.0,
        -4977.00048828125,
        1056.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4977.00048828125,
      "bbox_min": [
        -3371.0,
        -4977.00048828125,
        1045.20703125
      ],
      "bbox_max": [
        -3370.5,
        -4977.00048828125,
        1045.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4977.00048828125,
      "bbox_min": [
        -3371.0,
        -4991.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.5,
        -4977.00048828125,
        1045.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4991.00048828125,
      "bbox_min": [
        -3371.0,
        -4991.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.5,
        -4991.00048828125,
        1045.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9659255146980286,
        -0.25882017612457275
      ],
      "plane_d": 5093.44677734375,
      "bbox_min": [
        -3403.782958984375,
        -5009.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3371.0,
        -4940.70068359375,
        1061.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9659255146980286,
        -0.25882017612457275
      ],
      "plane_d": -4534.8994140625,
      "bbox_min": [
        -3403.782958984375,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3371.0,
        -4940.70068359375,
        1057.499267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9741036295890808,
        -0.2261020690202713,
        -0.0
      ],
      "plane_d": -4402.72607421875,
      "bbox_min": [
        -3372.970947265625,
        -4949.1923828125,
        1056.70703125
      ],
      "bbox_max": [
        -3371.0,
        -4940.70068359375,
        1057.499267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071073651313782,
        -0.7071061730384827
      ],
      "plane_d": -2777.966796875,
      "bbox_min": [
        -3403.782958984375,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3371.0,
        -4974.00048828125,
        1051.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071073651313782,
        -0.7071061730384827
      ],
      "plane_d": 4270.47998046875,
      "bbox_min": [
        -3403.782958984375,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3371.0,
        -4974.00048828125,
        1051.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3403.782958984375,
      "bbox_min": [
        -3403.782958984375,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3371.0,
        -4974.00048828125,
        1051.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3380.0,
      "bbox_min": [
        -3403.782958984375,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3371.0,
        -4974.00048828125,
        1051.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1045.20703125,
      "bbox_min": [
        -3378.0,
        -4977.00048828125,
        1045.20703125
      ],
      "bbox_max": [
        -3371.0,
        -4976.50048828125,
        1045.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4991.00048828125,
      "bbox_min": [
        -3380.0,
        -4991.50048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3371.0,
        -4980.00048828125,
        1046.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1045.20703125,
      "bbox_min": [
        -3378.0,
        -4991.50048828125,
        1045.20703125
      ],
      "bbox_max": [
        -3371.0,
        -4991.00048828125,
        1045.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4980.00048828125,
      "bbox_min": [
        -3380.0,
        -4988.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4980.00048828125,
        1046.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4988.00048828125,
      "bbox_min": [
        -3380.0,
        -4988.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4988.00048828125,
        1046.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06389177590608597,
        -0.963952362537384,
        -0.2582899034023285
      ],
      "plane_d": -4308.4052734375,
      "bbox_min": [
        -3403.782958984375,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4974.00048828125,
        1051.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06388971209526062,
        0.9639524817466736,
        -0.2582899332046509
      ],
      "plane_d": 5300.2666015625,
      "bbox_min": [
        -3403.782958984375,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4975.34033203125,
        1051.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06389176845550537,
        -0.25829023122787476,
        -0.9639523029327393
      ],
      "plane_d": -56.29118347167969,
      "bbox_min": [
        -3403.782958984375,
        -4992.66064453125,
        1046.5816650390625
      ],
      "bbox_max": [
        -3400.0,
        -4975.34033203125,
        1051.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06389175355434418,
        0.25829023122787476,
        -0.9639523029327393
      ],
      "plane_d": 2518.345947265625,
      "bbox_min": [
        -3403.782958984375,
        -4992.66064453125,
        1046.5816650390625
      ],
      "bbox_max": [
        -3400.0,
        -4975.34033203125,
        1051.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06389027833938599,
        0.705662727355957,
        -0.7056615352630615
      ],
      "plane_d": 4478.982421875,
      "bbox_min": [
        -3403.782958984375,
        -4992.66064453125,
        1046.5816650390625
      ],
      "bbox_max": [
        -3400.0,
        -4975.34033203125,
        1050.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06389173120260239,
        -0.7056626677513123,
        -0.7056614756584167
      ],
      "plane_d": -2555.05908203125,
      "bbox_min": [
        -3403.782958984375,
        -4979.1259765625,
        1046.5816650390625
      ],
      "bbox_max": [
        -3400.0,
        -4975.34033203125,
        1050.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3380.0,
      "bbox_min": [
        -3400.0,
        -4994.00048828125,
        1031.70703125
      ],
      "bbox_max": [
        -3369.25,
        -4974.00048828125,
        1041.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4988.00048828125,
      "bbox_min": [
        -3380.0,
        -4988.00048828125,
        1031.70703125
      ],
      "bbox_max": [
        -3369.25,
        -4980.00048828125,
        1041.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1036.70703125,
      "bbox_min": [
        -3380.0,
        -4988.00048828125,
        1032.507080078125
      ],
      "bbox_max": [
        -3369.25,
        -4980.00048828125,
        1036.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1034.6070556640625,
      "bbox_min": [
        -3376.75,
        -4988.00048828125,
        1032.507080078125
      ],
      "bbox_max": [
        -3369.25,
        -4980.00048828125,
        1036.007080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1033.20703125,
      "bbox_min": [
        -3373.0,
        -4988.00048828125,
        1032.507080078125
      ],
      "bbox_max": [
        -3369.25,
        -4980.00048828125,
        1033.906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1032.507080078125,
      "bbox_min": [
        -3370.5,
        -4988.00048828125,
        1032.507080078125
      ],
      "bbox_max": [
        -3369.25,
        -4980.00048828125,
        1032.507080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1033.906982421875,
      "bbox_min": [
        -3373.0,
        -4988.00048828125,
        1033.906982421875
      ],
      "bbox_max": [
        -3371.75,
        -4980.00048828125,
        1033.906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1035.3070068359375,
      "bbox_min": [
        -3376.75,
        -4988.00048828125,
        1035.3070068359375
      ],
      "bbox_max": [
        -3374.25,
        -4980.00048828125,
        1036.007080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1036.007080078125,
      "bbox_min": [
        -3376.75,
        -4988.00048828125,
        1036.007080078125
      ],
      "bbox_max": [
        -3375.5,
        -4980.00048828125,
        1036.007080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4974.00048828125,
      "bbox_min": [
        -3400.0,
        -4994.00048828125,
        1031.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4974.00048828125,
        1041.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4994.00048828125,
      "bbox_min": [
        -3400.0,
        -4994.00048828125,
        1031.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4974.00048828125,
        1041.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3400.0,
      "bbox_min": [
        -3400.0,
        -4994.00048828125,
        1031.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4974.00048828125,
        1041.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.611905038356781,
        -0.3543611466884613,
        0.7071070671081543
      ],
      "plane_d": -4577.359375,
      "bbox_min": [
        -3618.054931640625,
        -5067.609375,
        818.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6119066476821899,
        -0.35435834527015686,
        -0.7071070671081543
      ],
      "plane_d": -3327.600341796875,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        943.8544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6119064092636108,
        0.3543584942817688,
        0.7071072459220886
      ],
      "plane_d": 3317.70068359375,
      "bbox_min": [
        -3597.6142578125,
        -5033.4755859375,
        838.27978515625
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        943.8544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 878.70703125,
      "bbox_min": [
        -3597.6142578125,
        -5033.4755859375,
        838.27978515625
      ],
      "bbox_max": [
        -3516.571533203125,
        -4931.1865234375,
        890.7069702148438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6119046807289124,
        0.3543614447116852,
        -0.7071072459220886
      ],
      "plane_d": 4567.4609375,
      "bbox_min": [
        -3597.6142578125,
        -5033.4755859375,
        878.70703125
      ],
      "bbox_max": [
        -3527.91259765625,
        -4932.0283203125,
        890.7069702148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8653658032417297,
        -0.5011407136917114,
        0.0
      ],
      "plane_d": -5587.65380859375,
      "bbox_min": [
        -3597.6142578125,
        -5033.4755859375,
        878.70703125
      ],
      "bbox_max": [
        -3532.242919921875,
        -4934.52880859375,
        890.7069702148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0770937706183759e-06,
        -1.8655795201993897e-06,
        1.0
      ],
      "plane_d": -888.712646484375,
      "bbox_min": [
        -3595.882568359375,
        -5032.4755859375,
        878.70703125
      ],
      "bbox_max": [
        -3532.242919921875,
        -4934.52880859375,
        890.7069702148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8653655648231506,
        0.5011411905288696,
        0.0
      ],
      "plane_d": 5577.6552734375,
      "bbox_min": [
        -3595.882568359375,
        -5032.4755859375,
        878.70703125
      ],
      "bbox_max": [
        -3532.242919921875,
        -4934.52880859375,
        888.707275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000002384185791,
        0.8660252690315247,
        0.0
      ],
      "plane_d": 2586.9326171875,
      "bbox_min": [
        -3595.882568359375,
        -5032.4755859375,
        878.70703125
      ],
      "bbox_max": [
        -3533.974853515625,
        -4935.52880859375,
        888.707275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002980232239,
        -0.8660252094268799,
        0.0
      ],
      "plane_d": -2480.6796875,
      "bbox_min": [
        -3595.882568359375,
        -4940.5283203125,
        878.70703125
      ],
      "bbox_max": [
        -3587.222412109375,
        -4935.52880859375,
        888.707275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002980232239,
        -0.8660252094268799,
        0.0
      ],
      "plane_d": -2480.6796875,
      "bbox_min": [
        -3587.222412109375,
        -5027.4755859375,
        881.7071533203125
      ],
      "bbox_max": [
        -3532.242919921875,
        -4934.52880859375,
        885.7076416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002980232239,
        -0.8660252094268799,
        0.0
      ],
      "plane_d": -2480.6796875,
      "bbox_min": [
        -3593.283935546875,
        -4939.0283203125,
        888.707275390625
      ],
      "bbox_max": [
        -3589.820068359375,
        -4937.0283203125,
        890.7069702148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002980232239,
        -0.8660252094268799,
        0.0
      ],
      "plane_d": -2480.6796875,
      "bbox_min": [
        -3597.6142578125,
        -4941.5283203125,
        881.7075805664062
      ],
      "bbox_max": [
        -3595.882568359375,
        -4940.5283203125,
        885.70654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000002384185791,
        0.8660252690315247,
        0.0
      ],
      "plane_d": 2586.9326171875,
      "bbox_min": [
        -3563.814208984375,
        -5028.9755859375,
        878.70703125
      ],
      "bbox_max": [
        -3527.91259765625,
        -4962.2744140625,
        883.7072143554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4963.474609375,
      "bbox_min": [
        -3563.814208984375,
        -4963.474609375,
        878.70703125
      ],
      "bbox_max": [
        -3562.949462890625,
        -4962.2744140625,
        879.1083374023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4962.27392578125,
      "bbox_min": [
        -3563.814208984375,
        -4962.2744140625,
        878.70703125
      ],
      "bbox_max": [
        -3563.644287109375,
        -4962.2744140625,
        878.785888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.455764502286911,
        -0.7894071340560913,
        0.4112360179424286
      ],
      "plane_d": -5866.84765625,
      "bbox_min": [
        -3593.283935546875,
        -5030.9755859375,
        838.27978515625
      ],
      "bbox_max": [
        -3516.571533203125,
        -4931.1865234375,
        878.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9115286469459534,
        0.0,
        0.41123658418655396
      ],
      "plane_d": -3557.2080078125,
      "bbox_min": [
        -3593.283935546875,
        -5030.9755859375,
        838.27978515625
      ],
      "bbox_max": [
        -3516.571533203125,
        -4931.1865234375,
        878.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.0193518796295393e-07,
        -0.9115290641784668,
        0.4112356901168823
      ],
      "plane_d": -4850.7373046875,
      "bbox_min": [
        -3593.283935546875,
        -5030.9755859375,
        838.27978515625
      ],
      "bbox_max": [
        -3516.571533203125,
        -4931.1865234375,
        878.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7894072532653809,
        0.4557639956474304,
        0.41123640537261963
      ],
      "plane_d": -850.326171875,
      "bbox_min": [
        -3593.283935546875,
        -5030.9755859375,
        838.27978515625
      ],
      "bbox_max": [
        -3516.571533203125,
        -4931.1865234375,
        878.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857633113861084,
        0.49515441060066223,
        0.1388797163963318
      ],
      "plane_d": -658.97216796875,
      "bbox_min": [
        -3593.283935546875,
        -5030.9755859375,
        838.27978515625
      ],
      "bbox_max": [
        -3518.0927734375,
        -4931.1865234375,
        878.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.580791366810445e-07,
        -0.9903091192245483,
        0.13888080418109894
      ],
      "plane_d": -5005.12353515625,
      "bbox_min": [
        -3593.283935546875,
        -5030.9755859375,
        838.27978515625
      ],
      "bbox_max": [
        -3520.609375,
        -4931.1865234375,
        878.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7894070744514465,
        -0.4557642936706543,
        0.41123637557029724
      ],
      "plane_d": -5393.3828125,
      "bbox_min": [
        -3593.283935546875,
        -5030.9755859375,
        838.27978515625
      ],
      "bbox_max": [
        -3520.609375,
        -4931.1865234375,
        878.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6483864784240723,
        -0.37434637546539307,
        0.6629176139831543
      ],
      "plane_d": -4704.14453125,
      "bbox_min": [
        -3593.283935546875,
        -5030.9755859375,
        838.27978515625
      ],
      "bbox_max": [
        -3521.946044921875,
        -4931.1865234375,
        878.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49515417218208313,
        -0.8576332926750183,
        0.1388794481754303
      ],
      "plane_d": -2578.68017578125,
      "bbox_min": [
        -3593.283935546875,
        -5030.9755859375,
        838.27978515625
      ],
      "bbox_max": [
        -3521.946044921875,
        -4931.1865234375,
        878.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4951542913913727,
        0.8576332330703735,
        0.1388794630765915
      ],
      "plane_d": 2439.8330078125,
      "bbox_min": [
        -3565.0,
        -5030.9755859375,
        838.27978515625
      ],
      "bbox_max": [
        -3521.946044921875,
        -4942.78369140625,
        878.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3743467628955841,
        -0.6483868360519409,
        0.6629170775413513
      ],
      "plane_d": -5093.03076171875,
      "bbox_min": [
        -3565.0,
        -4991.8408203125,
        838.27978515625
      ],
      "bbox_max": [
        -3521.946044921875,
        -4942.78369140625,
        878.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7486927509307861,
        0.0,
        0.6629171967506409
      ],
      "plane_d": -3195.986328125,
      "bbox_min": [
        -3565.0,
        -4991.8408203125,
        838.2942504882812
      ],
      "bbox_max": [
        -3521.946044921875,
        -4950.3466796875,
        878.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4962.27392578125,
      "bbox_min": [
        -3565.0,
        -4963.474609375,
        869.1070556640625
      ],
      "bbox_max": [
        -3554.391357421875,
        -4950.3466796875,
        878.7070922851562
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -1902.7486572265625,
      "bbox_min": [
        -3564.52734375,
        -4962.2744140625,
        870.1070556640625
      ],
      "bbox_max": [
        -3555.47216796875,
        -4950.3466796875,
        878.1297607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 870.1070556640625,
      "bbox_min": [
        -3564.52734375,
        -4962.2744140625,
        870.1070556640625
      ],
      "bbox_max": [
        -3555.47216796875,
        -4950.3466796875,
        878.1297607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3564.0,
      "bbox_min": [
        -3564.52734375,
        -4962.2744140625,
        870.1070556640625
      ],
      "bbox_max": [
        -3555.47216796875,
        -4950.3466796875,
        878.1297607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 3130.4375,
      "bbox_min": [
        -3564.0,
        -4962.2744140625,
        870.1070556640625
      ],
      "bbox_max": [
        -3555.47216796875,
        -4950.3466796875,
        878.1297607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -3140.3369140625,
      "bbox_min": [
        -3564.0,
        -4962.2744140625,
        870.1070556640625
      ],
      "bbox_max": [
        -3559.72900390625,
        -4950.3466796875,
        878.1297607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7033962607383728,
        0.10231061279773712,
        -0.7033962607383728
      ],
      "plane_d": -1386.1348876953125,
      "bbox_min": [
        -3564.0,
        -4951.87451171875,
        870.1070556640625
      ],
      "bbox_max": [
        -3559.72900390625,
        -4950.3466796875,
        873.2636108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5684306025505066,
        -0.8227311968803406
      ],
      "plane_d": 3530.6611328125,
      "bbox_min": [
        -3561.833251953125,
        -4951.87451171875,
        870.1070556640625
      ],
      "bbox_max": [
        -3559.72900390625,
        -4950.3466796875,
        871.16259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7033962607383728,
        0.10231061279773712,
        -0.7033962607383728
      ],
      "plane_d": -1386.1348876953125,
      "bbox_min": [
        -3564.52734375,
        -4951.87451171875,
        873.1070556640625
      ],
      "bbox_max": [
        -3564.0,
        -4950.7978515625,
        873.8031005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.877892792224884,
        -0.4788573682308197,
        9.826446330407634e-06
      ],
      "plane_d": -5500.06005859375,
      "bbox_min": [
        -3564.52734375,
        -4951.87451171875,
        873.1070556640625
      ],
      "bbox_max": [
        -3564.0,
        -4950.90771484375,
        873.8031005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071188688278198,
        -0.0,
        -0.7070947885513306
      ],
      "plane_d": -1903.80224609375,
      "bbox_min": [
        -3565.0,
        -4963.474609375,
        869.1070556640625
      ],
      "bbox_max": [
        -3554.391357421875,
        -4962.2744140625,
        878.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4963.474609375,
      "bbox_min": [
        -3565.0,
        -4963.474609375,
        869.1070556640625
      ],
      "bbox_max": [
        -3554.391357421875,
        -4962.2744140625,
        878.7070922851562
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 869.1070556640625,
      "bbox_min": [
        -3565.0,
        -4963.474609375,
        869.1070556640625
      ],
      "bbox_max": [
        -3554.391357421875,
        -4962.2744140625,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3565.0,
      "bbox_min": [
        -3565.0,
        -4963.474609375,
        869.1070556640625
      ],
      "bbox_max": [
        -3554.391357421875,
        -4962.2744140625,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1902.748779296875,
      "bbox_min": [
        -3565.0,
        -4963.474609375,
        869.1070556640625
      ],
      "bbox_max": [
        -3554.391357421875,
        -4962.2744140625,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071188688278198,
        0.0,
        -0.7070947885513306
      ],
      "plane_d": 3129.469970703125,
      "bbox_min": [
        -3565.0,
        -4963.474609375,
        869.1070556640625
      ],
      "bbox_max": [
        -3554.391357421875,
        -4962.2744140625,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -870.1070556640625,
      "bbox_min": [
        -3565.0,
        -4963.474609375,
        870.1070556640625
      ],
      "bbox_max": [
        -3555.149658203125,
        -4962.2744140625,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -3130.4375,
      "bbox_min": [
        -3565.0,
        -4963.474609375,
        870.1070556640625
      ],
      "bbox_max": [
        -3555.149658203125,
        -4962.2744140625,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 3140.3369140625,
      "bbox_min": [
        -3565.0,
        -4963.474609375,
        873.1070556640625
      ],
      "bbox_max": [
        -3562.655029296875,
        -4962.2744140625,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -3141.337158203125,
      "bbox_min": [
        -3565.0,
        -4963.474609375,
        877.521240234375
      ],
      "bbox_max": [
        -3563.814208984375,
        -4962.2744140625,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3564.0,
      "bbox_min": [
        -3564.0,
        -4963.474609375,
        873.1070556640625
      ],
      "bbox_max": [
        -3564.0,
        -4962.2744140625,
        877.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 878.70703125,
      "bbox_min": [
        -3591.552001953125,
        -5029.9755859375,
        846.3814086914062
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        943.8544921875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.866025447845459,
        -0.4999999403953552,
        -0.0
      ],
      "plane_d": -5526.1904296875,
      "bbox_min": [
        -3591.552001953125,
        -5029.9755859375,
        878.7069702148438
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        943.8544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.866025447845459,
        0.0
      ],
      "plane_d": -6045.607421875,
      "bbox_min": [
        -3591.552001953125,
        -5029.9755859375,
        878.7069702148438
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        943.8544921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -5.35958520231361e-07,
        -1.0,
        -0.0
      ],
      "plane_d": -4930.87646484375,
      "bbox_min": [
        -3591.552001953125,
        -5029.9755859375,
        878.7069702148438
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        943.837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253286361694,
        0.5000001192092896,
        0.0
      ],
      "plane_d": -542.189697265625,
      "bbox_min": [
        -3591.552001953125,
        -5029.9755859375,
        878.7069702148438
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        943.837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002980232239,
        -0.8660252094268799,
        0.0
      ],
      "plane_d": -2480.6796875,
      "bbox_min": [
        -3591.552001953125,
        -5029.9755859375,
        878.7069702148438
      ],
      "bbox_max": [
        -3511.80517578125,
        -4930.87451171875,
        943.837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000002384185791,
        0.8660252690315247,
        0.0
      ],
      "plane_d": 2586.9326171875,
      "bbox_min": [
        -3570.0,
        -5029.9755859375,
        878.7069702148438
      ],
      "bbox_max": [
        -3511.80517578125,
        -4930.87451171875,
        943.837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.629358833582955e-07,
        -1.321452373304055e-06,
        -1.0
      ],
      "plane_d": 908.6978149414062,
      "bbox_min": [
        -3570.0,
        -5014.83154296875,
        878.7069702148438
      ],
      "bbox_max": [
        -3511.80517578125,
        -4930.87451171875,
        943.837890625
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.6123724579811096,
        -0.3535518944263458,
        -0.7071075439453125
      ],
      "plane_d": 1062.1513671875,
      "bbox_min": [
        -3570.0,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4930.87451171875,
        943.837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123735308647156,
        0.3535500168800354,
        -0.7071075439453125
      ],
      "plane_d": 220.1142578125,
      "bbox_min": [
        -3570.0,
        -4962.765625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4930.87451171875,
        943.837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123735308647156,
        -0.3535500168800354,
        0.7071075439453125
      ],
      "plane_d": -230.013916015625,
      "bbox_min": [
        -3552.75830078125,
        -4962.765625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4935.45703125,
        943.837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660271167755127,
        0.499997079372406,
        0.0
      ],
      "plane_d": -600.41064453125,
      "bbox_min": [
        -3552.75830078125,
        -4957.77734375,
        908.70703125
      ],
      "bbox_max": [
        -3534.09814453125,
        -4935.45703125,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660271167755127,
        -0.499997079372406,
        0.0
      ],
      "plane_d": 590.41064453125,
      "bbox_min": [
        -3552.75830078125,
        -4957.77734375,
        908.70703125
      ],
      "bbox_max": [
        -3534.09814453125,
        -4935.45703125,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123724579811096,
        0.3535518944263458,
        0.7071075439453125
      ],
      "plane_d": -1072.05078125,
      "bbox_min": [
        -3552.75830078125,
        -4957.77734375,
        908.70703125
      ],
      "bbox_max": [
        -3536.696044921875,
        -4935.45703125,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.629358833582955e-07,
        1.321452373304055e-06,
        1.0
      ],
      "plane_d": -918.6978149414062,
      "bbox_min": [
        -3552.75830078125,
        -4957.77734375,
        908.70703125
      ],
      "bbox_max": [
        -3536.696044921875,
        -4936.95703125,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999895691871643,
        -0.866025984287262,
        -0.0
      ],
      "plane_d": -6065.609375,
      "bbox_min": [
        -3552.75830078125,
        -4957.77734375,
        908.70703125
      ],
      "bbox_max": [
        -3544.097900390625,
        -4952.77734375,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.607248792533937e-07,
        -3.814703006810305e-07,
        -1.0
      ],
      "plane_d": 938.7028198242188,
      "bbox_min": [
        -3524.397705078125,
        -4962.765625,
        938.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4953.04638671875,
        943.837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3535541892051697,
        0.612371563911438,
        -0.7071071267127991
      ],
      "plane_d": 2453.96630859375,
      "bbox_min": [
        -3524.397705078125,
        -4962.765625,
        938.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4953.04638671875,
        943.837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35355344414711,
        -0.6123724579811096,
        -0.7071067690849304
      ],
      "plane_d": -1129.269287109375,
      "bbox_min": [
        -3523.302978515625,
        -4962.765625,
        938.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4953.04638671875,
        943.837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000007152557373,
        0.8660249710083008,
        0.0
      ],
      "plane_d": 2528.73046875,
      "bbox_min": [
        -3523.302978515625,
        -4962.765625,
        941.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4953.04638671875,
        943.837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000007152557373,
        -0.8660249710083008,
        0.0
      ],
      "plane_d": -2538.73046875,
      "bbox_min": [
        -3518.291748046875,
        -4962.765625,
        941.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4961.70654296875,
        943.8247680664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3161.97412109375,
      "bbox_min": [
        -3570.0,
        -4945.87451171875,
        908.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4930.87451171875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        2.0345053144410485e-06,
        -0.0
      ],
      "plane_d": 3560.010009765625,
      "bbox_min": [
        -3570.0,
        -4945.87451171875,
        908.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4930.87451171875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -2.8772249152098084e-06,
        -0.7071067690849304
      ],
      "plane_d": -1879.7109375,
      "bbox_min": [
        -3570.0,
        -4945.87451171875,
        908.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4930.87451171875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        2.8772249152098084e-06,
        0.7071067690849304
      ],
      "plane_d": 1869.8115234375,
      "bbox_min": [
        -3570.0,
        -4945.87451171875,
        908.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4930.87451171875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4945.87451171875,
      "bbox_min": [
        -3570.0,
        -4945.87451171875,
        908.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4930.87451171875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -2.0345053144410485e-06,
        -0.0
      ],
      "plane_d": -3570.010009765625,
      "bbox_min": [
        -3570.0,
        -4933.33984375,
        911.70703125
      ],
      "bbox_max": [
        -3563.0,
        -4930.87451171875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.880510929948899e-12,
        2.0345053144410485e-06,
        1.0
      ],
      "plane_d": -918.697021484375,
      "bbox_min": [
        -3563.33837890625,
        -4931.458984375,
        918.70703125
      ],
      "bbox_max": [
        -3563.0,
        -4930.87451171875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3535533845424652,
        0.6123720407485962,
        0.7071071267127991
      ],
      "plane_d": 1140.5810546875,
      "bbox_min": [
        -3541.918701171875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4953.04638671875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3535533845424652,
        0.6123720407485962,
        -0.7071071267127991
      ],
      "plane_d": 2432.758544921875,
      "bbox_min": [
        -3541.918701171875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4953.04638671875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -918.70703125,
      "bbox_min": [
        -3541.918701171875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4953.04638671875,
        918.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5000002384185791,
        0.8660252690315247,
        0.0
      ],
      "plane_d": 2528.73388671875,
      "bbox_min": [
        -3541.918701171875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4953.04638671875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7822566032409668,
        0.622956395149231,
        0.0
      ],
      "plane_d": 325.35888671875,
      "bbox_min": [
        -3541.918701171875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4959.1083984375,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5765961408615112,
        0.45917701721191406,
        -0.6757909059524536
      ],
      "plane_d": 855.943115234375,
      "bbox_min": [
        -3541.918701171875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4959.1083984375,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5765961408615112,
        0.45917701721191406,
        0.6757909059524536
      ],
      "plane_d": -379.0067138671875,
      "bbox_min": [
        -3541.918701171875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4959.1083984375,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5701964497566223,
        0.4581644535064697,
        0.6818807721138
      ],
      "plane_d": -366.98681640625,
      "bbox_min": [
        -3541.918701171875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4959.1083984375,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5701963901519775,
        0.45816442370414734,
        -0.6818807721138
      ],
      "plane_d": 879.091796875,
      "bbox_min": [
        -3541.918701171875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4959.1083984375,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.271565793103946e-06,
        -1.0,
        -0.0
      ],
      "plane_d": -4977.0224609375,
      "bbox_min": [
        -3541.918701171875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4959.1083984375,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7174146771430969,
        0.013697130605578423,
        -0.6965117454528809
      ],
      "plane_d": -1837.8388671875,
      "bbox_min": [
        -3541.918701171875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4959.1083984375,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071048021316528,
        0.003977695479989052,
        -0.7070975303649902
      ],
      "plane_d": -1840.044921875,
      "bbox_min": [
        -3541.918701171875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4959.1083984375,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9998177886009216,
        0.01908888854086399,
        0.0
      ],
      "plane_d": -3446.267578125,
      "bbox_min": [
        -3541.918701171875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4959.1083984375,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3535535931587219,
        -0.6123723983764648,
        -0.7071067690849304
      ],
      "plane_d": -1150.4815673828125,
      "bbox_min": [
        -3541.860107421875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4959.1083984375,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3535536229610443,
        -0.6123723387718201,
        0.7071067690849304
      ],
      "plane_d": -2442.658203125,
      "bbox_min": [
        -3541.860107421875,
        -4977.01806640625,
        911.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4959.1083984375,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002980232239,
        -0.8660252094268799,
        0.0
      ],
      "plane_d": -2538.73291015625,
      "bbox_min": [
        -3541.860107421875,
        -4973.94921875,
        911.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4961.70654296875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7174146175384521,
        0.013697143644094467,
        0.6965117454528809
      ],
      "plane_d": -3110.65380859375,
      "bbox_min": [
        -3541.860107421875,
        -4973.94921875,
        915.70703125
      ],
      "bbox_max": [
        -3538.88232421875,
        -4969.75341796875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071048021316528,
        0.003977695479989052,
        0.7070975303649902
      ],
      "plane_d": -3132.204833984375,
      "bbox_min": [
        -3540.24365234375,
        -4973.4384765625,
        917.3621215820312
      ],
      "bbox_max": [
        -3538.88232421875,
        -4970.52978515625,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9990679621696472,
        0.043165531009435654,
        0.0
      ],
      "plane_d": 3743.46240234375,
      "bbox_min": [
        -3532.12060546875,
        -4973.04150390625,
        913.0856323242188
      ],
      "bbox_max": [
        -3532.09033203125,
        -4972.34130859375,
        914.3286743164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5538089871406555,
        -0.4721735715866089,
        0.6858190298080444
      ],
      "plane_d": -1019.697265625,
      "bbox_min": [
        -3535.0185546875,
        -4977.01806640625,
        913.7071533203125
      ],
      "bbox_max": [
        -3529.44775390625,
        -4966.6083984375,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7609648108482361,
        -0.6487931609153748,
        0.0
      ],
      "plane_d": -538.201416015625,
      "bbox_min": [
        -3532.12060546875,
        -4973.96826171875,
        913.7071533203125
      ],
      "bbox_max": [
        -3529.44775390625,
        -4969.20654296875,
        915.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.706777036190033,
        0.030536867678165436,
        0.7067769765853882
      ],
      "plane_d": 2001.060791015625,
      "bbox_min": [
        -3535.0185546875,
        -4977.01806640625,
        914.530029296875
      ],
      "bbox_max": [
        -3531.9931640625,
        -4971.56494140625,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9990679621696472,
        0.043165531009435654,
        0.0
      ],
      "plane_d": 3743.46240234375,
      "bbox_min": [
        -3532.12060546875,
        -4975.29443359375,
        914.530029296875
      ],
      "bbox_max": [
        -3531.9931640625,
        -4972.34130859375,
        915.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.720897912979126,
        0.013196637853980064,
        0.6929156184196472
      ],
      "plane_d": 1977.408935546875,
      "bbox_min": [
        -3535.0185546875,
        -4977.01806640625,
        915.70703125
      ],
      "bbox_max": [
        -3532.12060546875,
        -4971.56494140625,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.706777036190033,
        0.030536867678165436,
        0.7067769765853882
      ],
      "plane_d": 2001.060791015625,
      "bbox_min": [
        -3535.0185546875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3529.44775390625,
        -4966.6083984375,
        916.7269897460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.706777036190033,
        0.030536867678165436,
        -0.7067769765853882
      ],
      "plane_d": 3292.63525390625,
      "bbox_min": [
        -3535.0185546875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3529.44775390625,
        -4966.6083984375,
        915.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9990679621696472,
        0.043165531009435654,
        0.0
      ],
      "plane_d": 3743.46240234375,
      "bbox_min": [
        -3532.12060546875,
        -4977.01806640625,
        911.70703125
      ],
      "bbox_max": [
        -3531.240966796875,
        -4971.3095703125,
        915.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7609648108482361,
        -0.6487931609153748,
        0.0
      ],
      "plane_d": -538.201416015625,
      "bbox_min": [
        -3532.12060546875,
        -4972.34130859375,
        911.70703125
      ],
      "bbox_max": [
        -3531.240966796875,
        -4971.3095703125,
        913.0856323242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.720897912979126,
        0.013196648098528385,
        -0.6929156184196472
      ],
      "plane_d": 3243.652587890625,
      "bbox_min": [
        -3535.0185546875,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3529.44775390625,
        -4966.6083984375,
        912.6318969726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5538089871406555,
        -0.4721735715866089,
        -0.6858190298080444
      ],
      "plane_d": 233.578125,
      "bbox_min": [
        -3535.0185546875,
        -4972.34130859375,
        908.70703125
      ],
      "bbox_max": [
        -3529.44775390625,
        -4966.6083984375,
        912.6318969726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5713566541671753,
        -0.469229131937027,
        -0.6733316779136658
      ],
      "plane_d": 298.814453125,
      "bbox_min": [
        -3535.0185546875,
        -4972.34130859375,
        908.70703125
      ],
      "bbox_max": [
        -3530.94775390625,
        -4966.6083984375,
        911.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3535531461238861,
        0.612372636795044,
        0.7071067690849304
      ],
      "plane_d": 3692.482177734375,
      "bbox_min": [
        -3570.0,
        -5014.83154296875,
        878.7069702148438
      ],
      "bbox_max": [
        -3511.80517578125,
        -4930.87451171875,
        906.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660262227058411,
        -0.4999985694885254,
        -2.738839384619496e-06
      ],
      "plane_d": 561.20751953125,
      "bbox_min": [
        -3539.2080078125,
        -5006.19775390625,
        878.70703125
      ],
      "bbox_max": [
        -3536.342041015625,
        -5002.7333984375,
        882.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.35355934500694275,
        -0.6123694181442261,
        -0.7071064114570618
      ],
      "plane_d": -3693.48828125,
      "bbox_min": [
        -3539.2080078125,
        -5006.19775390625,
        878.70703125
      ],
      "bbox_max": [
        -3537.049072265625,
        -5003.4580078125,
        882.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999502301216125,
        -0.8660283088684082,
        -5.131537363922689e-07
      ],
      "plane_d": -6104.662109375,
      "bbox_min": [
        -3539.2080078125,
        -5006.19775390625,
        881.29296875
      ],
      "bbox_max": [
        -3538.342041015625,
        -5005.69775390625,
        882.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999936819076538,
        -0.8660290837287903,
        0.0
      ],
      "plane_d": -6103.6611328125,
      "bbox_min": [
        -3570.0,
        -5014.83154296875,
        878.7069702148438
      ],
      "bbox_max": [
        -3511.80517578125,
        -4930.87451171875,
        906.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4979.00048828125,
      "bbox_min": [
        -3570.0,
        -5014.83154296875,
        878.7069702148438
      ],
      "bbox_max": [
        -3511.80517578125,
        -4930.87451171875,
        906.7071533203125
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4989.00048828125,
      "bbox_min": [
        -3558.7802734375,
        -5014.83154296875,
        878.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2904.295166015625,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        878.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4144.14599609375,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        878.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268527388572693,
        0.0,
        -0.9238787889480591
      ],
      "plane_d": -537.1467895507812,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        878.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.281086266040802,
        -0.6785979866981506,
        -0.6785979866981506
      ],
      "plane_d": -3778.030029296875,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        878.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810860574245453,
        0.6785980463027954,
        -0.6785980463027954
      ],
      "plane_d": 2986.236328125,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        878.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238827228546143,
        0.0,
        0.38267576694488525
      ],
      "plane_d": 2919.955322265625,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        883.451904296875
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786029934883118,
        -0.6785956025123596,
        0.2810799479484558
      ],
      "plane_d": -1238.735595703125,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        883.451904296875
      ],
      "bbox_max": [
        -3527.884033203125,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786021590232849,
        0.6785959601402283,
        0.28108125925064087
      ],
      "plane_d": 5525.50390625,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        883.451904296875
      ],
      "bbox_max": [
        -3527.884033203125,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268259167671204,
        -0.0,
        0.923879861831665
      ],
      "plane_d": 518.156005859375,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        883.451904296875
      ],
      "bbox_max": [
        -3534.333740234375,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2881.66748046875,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        883.451904296875
      ],
      "bbox_max": [
        -3534.333740234375,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4156.8740234375,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        883.451904296875
      ],
      "bbox_max": [
        -3534.333740234375,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 896.7071533203125,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        889.706787109375
      ],
      "bbox_max": [
        -3534.656005859375,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2891.567138671875,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3534.656005859375,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810842990875244,
        -0.6785995364189148,
        0.6785972714424133
      ],
      "plane_d": -3002.90478515625,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3534.656005859375,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810836434364319,
        0.6785994172096252,
        0.6785976886749268
      ],
      "plane_d": 3761.37255859375,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3534.656005859375,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -906.7071533203125,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3543.0,
        -4979.99951171875,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4166.7734375,
      "bbox_min": [
        -3558.7802734375,
        -4989.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3543.0,
        -4979.99951171875,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810847759246826,
        0.6785996556282043,
        -0.6785969734191895
      ],
      "plane_d": 2989.18701171875,
      "bbox_min": [
        -3558.7802734375,
        -4983.99267578125,
        896.7071533203125
      ],
      "bbox_max": [
        -3558.0,
        -4979.99951171875,
        898.7080688476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826831579208374,
        -0.0,
        -0.9238796234130859
      ],
      "plane_d": -533.13720703125,
      "bbox_min": [
        -3558.7802734375,
        -4983.99267578125,
        896.7071533203125
      ],
      "bbox_max": [
        -3558.0,
        -4982.00048828125,
        897.0303955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810856103897095,
        -0.6785982251167297,
        -0.6785981059074402
      ],
      "plane_d": -3770.873779296875,
      "bbox_min": [
        -3543.0,
        -4989.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3538.945556640625,
        -4986.00048828125,
        899.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786021590232849,
        -0.6785959601402283,
        -0.28108125925064087
      ],
      "plane_d": -5535.00390625,
      "bbox_min": [
        -3541.19970703125,
        -4989.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3538.945556640625,
        -4986.74609375,
        898.3012084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786021590232849,
        -0.6785959601402283,
        -0.28108125925064087
      ],
      "plane_d": -5535.00390625,
      "bbox_min": [
        -3543.0,
        -4989.00048828125,
        889.706787109375
      ],
      "bbox_max": [
        -3536.0458984375,
        -4982.00048828125,
        896.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238819479942322,
        -0.0,
        -0.38267767429351807
      ],
      "plane_d": -2929.189697265625,
      "bbox_min": [
        -3543.0,
        -4986.00048828125,
        892.7071533203125
      ],
      "bbox_max": [
        -3540.28857421875,
        -4982.00048828125,
        896.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826846778392792,
        -0.0,
        -0.9238790273666382
      ],
      "plane_d": -527.40283203125,
      "bbox_min": [
        -3543.0,
        -4986.00048828125,
        896.1798706054688
      ],
      "bbox_max": [
        -3541.72705078125,
        -4982.00048828125,
        896.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810856103897095,
        -0.6785982251167297,
        -0.6785981059074402
      ],
      "plane_d": -3770.873779296875,
      "bbox_min": [
        -3543.0,
        -4986.74609375,
        896.1798706054688
      ],
      "bbox_max": [
        -3541.19970703125,
        -4984.94580078125,
        896.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238819479942322,
        -0.0,
        -0.38267767429351807
      ],
      "plane_d": -2929.189697265625,
      "bbox_min": [
        -3542.1513671875,
        -4989.00048828125,
        883.451904296875
      ],
      "bbox_max": [
        -3534.333740234375,
        -4982.00048828125,
        896.3556518554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786021590232849,
        -0.6785959601402283,
        -0.28108125925064087
      ],
      "plane_d": -5535.00390625,
      "bbox_min": [
        -3540.28857421875,
        -4989.00048828125,
        883.451904296875
      ],
      "bbox_max": [
        -3534.333740234375,
        -4986.00048828125,
        892.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826846778392792,
        -0.0,
        -0.9238790273666382
      ],
      "plane_d": -527.40283203125,
      "bbox_min": [
        -3542.1513671875,
        -4982.52783203125,
        896.1798706054688
      ],
      "bbox_max": [
        -3541.72705078125,
        -4982.00048828125,
        896.3556518554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810855507850647,
        0.678598165512085,
        -0.6785981059074402
      ],
      "plane_d": 2993.39404296875,
      "bbox_min": [
        -3543.0,
        -4982.35205078125,
        896.1798706054688
      ],
      "bbox_max": [
        -3539.60595703125,
        -4979.00048828125,
        899.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28108733892440796,
        0.6785978078842163,
        0.6785978078842163
      ],
      "plane_d": 3768.53271484375,
      "bbox_min": [
        -3531.50537109375,
        -4982.00048828125,
        886.9016723632812
      ],
      "bbox_max": [
        -3527.884033203125,
        -4979.00048828125,
        890.5230102539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2894.3955078125,
      "bbox_min": [
        -3529.384033203125,
        -4986.00048828125,
        885.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        890.5230102539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -888.70703125,
      "bbox_min": [
        -3529.384033203125,
        -4986.00048828125,
        888.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4982.00048828125,
        890.5230102539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826879560947418,
        0.0,
        0.9238776564598083
      ],
      "plane_d": 527.9183959960938,
      "bbox_min": [
        -3529.384033203125,
        -4986.00048828125,
        888.70703125
      ],
      "bbox_max": [
        -3525.0,
        -4982.00048828125,
        890.5230102539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28108733892440796,
        0.6785978078842163,
        0.6785978078842163
      ],
      "plane_d": 3768.53271484375,
      "bbox_min": [
        -3529.384033203125,
        -4983.81640625,
        885.70703125
      ],
      "bbox_max": [
        -3525.0,
        -4979.00048828125,
        890.5230102539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826879560947418,
        0.0,
        0.9238776564598083
      ],
      "plane_d": 527.9183959960938,
      "bbox_min": [
        -3529.384033203125,
        -4986.00048828125,
        888.70703125
      ],
      "bbox_max": [
        -3525.0,
        -4984.1845703125,
        890.5230102539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.353544682264328,
        -0.6123774647712708,
        0.7071067690849304
      ],
      "plane_d": -4932.3271484375,
      "bbox_min": [
        -3537.842041015625,
        -5012.2333984375,
        878.70703125
      ],
      "bbox_max": [
        -3516.387451171875,
        -4995.30517578125,
        889.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660295605659485,
        -0.49999281764030457,
        -1.1789526070060674e-05
      ],
      "plane_d": 561.25634765625,
      "bbox_min": [
        -3534.5009765625,
        -4999.26953125,
        878.70703125
      ],
      "bbox_max": [
        -3532.342041015625,
        -4995.30517578125,
        882.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3535401523113251,
        0.6123790740966797,
        -0.707107663154602
      ],
      "plane_d": 4931.3203125,
      "bbox_min": [
        -3534.5009765625,
        -4998.044921875,
        878.70703125
      ],
      "bbox_max": [
        -3532.342041015625,
        -4995.30517578125,
        882.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999952018260956,
        0.8660281896591187,
        5.559164151236473e-07
      ],
      "plane_d": 6092.66162109375,
      "bbox_min": [
        -3533.2080078125,
        -4995.80517578125,
        881.29296875
      ],
      "bbox_max": [
        -3532.342041015625,
        -4995.30517578125,
        882.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999936819076538,
        0.8660290837287903,
        0.0
      ],
      "plane_d": 6093.66162109375,
      "bbox_min": [
        -3537.842041015625,
        -5012.2333984375,
        878.7071533203125
      ],
      "bbox_max": [
        -3516.387451171875,
        -4995.30517578125,
        889.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3535531163215637,
        0.6123725771903992,
        0.7071068286895752
      ],
      "plane_d": 3682.582275390625,
      "bbox_min": [
        -3537.842041015625,
        -5012.2333984375,
        878.7071533203125
      ],
      "bbox_max": [
        -3516.387451171875,
        -4996.17138671875,
        889.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -5.946546934865182e-06,
        3.4331842471146956e-06,
        -1.0
      ],
      "plane_d": 888.7033081054688,
      "bbox_min": [
        -3537.842041015625,
        -5012.2333984375,
        878.7071533203125
      ],
      "bbox_max": [
        -3517.887451171875,
        -4996.67138671875,
        889.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660289645195007,
        0.49999386072158813,
        1.788538611435797e-05
      ],
      "plane_d": -562.254638671875,
      "bbox_min": [
        -3537.2080078125,
        -5002.7333984375,
        888.7071533203125
      ],
      "bbox_max": [
        -3534.342041015625,
        -4998.76953125,
        889.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866028368473053,
        -0.4999948740005493,
        -1.797587719920557e-05
      ],
      "plane_d": 561.247314453125,
      "bbox_min": [
        -3536.707763671875,
        -5002.7333984375,
        888.7071533203125
      ],
      "bbox_max": [
        -3534.342041015625,
        -4999.26953125,
        889.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.3214550563134253e-05,
        -7.629319952684455e-06,
        1.0
      ],
      "plane_d": -889.6985473632812,
      "bbox_min": [
        -3536.707763671875,
        -5001.8671875,
        889.7071533203125
      ],
      "bbox_max": [
        -3534.842041015625,
        -4999.63525390625,
        889.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660252690315247,
        0.5000002384185791,
        -1.7881401959130017e-07
      ],
      "plane_d": -561.193359375,
      "bbox_min": [
        -3537.842041015625,
        -5005.33154296875,
        878.7071533203125
      ],
      "bbox_max": [
        -3532.842041015625,
        -4996.67138671875,
        888.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660257458686829,
        0.49999937415122986,
        -6.702554742332723e-07
      ],
      "plane_d": -562.198974609375,
      "bbox_min": [
        -3535.7080078125,
        -5000.13525390625,
        885.7071533203125
      ],
      "bbox_max": [
        -3532.84228515625,
        -4996.17138671875,
        889.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3535594940185547,
        0.6123692393302917,
        0.7071065306663513
      ],
      "plane_d": 3681.58837890625,
      "bbox_min": [
        -3535.7080078125,
        -5000.13525390625,
        887.1217651367188
      ],
      "bbox_max": [
        -3532.84228515625,
        -4996.17138671875,
        889.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.3214550563134253e-05,
        -7.629319952684455e-06,
        1.0
      ],
      "plane_d": -889.6985473632812,
      "bbox_min": [
        -3535.7080078125,
        -5000.13525390625,
        889.7071533203125
      ],
      "bbox_max": [
        -3534.135009765625,
        -4998.41064453125,
        889.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660265803337097,
        -0.49999791383743286,
        -3.2095616120386694e-07
      ],
      "plane_d": 561.210205078125,
      "bbox_min": [
        -3533.708251953125,
        -4996.67138671875,
        881.7071533203125
      ],
      "bbox_max": [
        -3532.342041015625,
        -4995.30517578125,
        887.121826171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999952018260956,
        0.8660281896591187,
        5.559164151236473e-07
      ],
      "plane_d": 6092.66162109375,
      "bbox_min": [
        -3533.708251953125,
        -4996.67138671875,
        882.70703125
      ],
      "bbox_max": [
        -3532.342041015625,
        -4995.30517578125,
        887.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3535594940185547,
        0.6123692393302917,
        0.7071065306663513
      ],
      "plane_d": 3681.58837890625,
      "bbox_min": [
        -3533.708251953125,
        -4996.67138671875,
        886.121337890625
      ],
      "bbox_max": [
        -3532.342041015625,
        -4995.30517578125,
        887.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866030752658844,
        0.4999907612800598,
        1.0705408385547344e-05
      ],
      "plane_d": -562.269775390625,
      "bbox_min": [
        -3538.7080078125,
        -5005.33154296875,
        885.7071533203125
      ],
      "bbox_max": [
        -3535.841796875,
        -5001.3671875,
        889.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3535401225090027,
        -0.6123791933059692,
        0.7071076035499573
      ],
      "plane_d": -4943.220703125,
      "bbox_min": [
        -3538.707763671875,
        -5005.33154296875,
        887.1212768554688
      ],
      "bbox_max": [
        -3535.841796875,
        -5001.3671875,
        889.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.3214550563134253e-05,
        -7.629319952684455e-06,
        1.0
      ],
      "plane_d": -889.6985473632812,
      "bbox_min": [
        -3537.4150390625,
        -5003.09228515625,
        889.7071533203125
      ],
      "bbox_max": [
        -3535.841796875,
        -5001.3671875,
        889.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5684306025505066,
        0.8227311968803406
      ],
      "plane_d": -3538.888427734375,
      "bbox_min": [
        -3570.0,
        -4963.474609375,
        878.7069702148438
      ],
      "bbox_max": [
        -3554.185791015625,
        -4930.87451171875,
        888.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5323526859283447,
        -0.658180296421051,
        0.5323526859283447
      ],
      "plane_d": -5623.46142578125,
      "bbox_min": [
        -3570.0,
        -4953.900390625,
        878.7069702148438
      ],
      "bbox_max": [
        -3555.26318359375,
        -4930.87451171875,
        888.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7033959031105042,
        -0.10231489688158035,
        0.7033959031105042
      ],
      "plane_d": 1376.26513671875,
      "bbox_min": [
        -3570.0,
        -4953.900390625,
        878.7069702148438
      ],
      "bbox_max": [
        -3555.26318359375,
        -4930.87451171875,
        888.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.705345630645752,
        -0.07053456455469131,
        0.705345630645752
      ],
      "plane_d": -3490.61083984375,
      "bbox_min": [
        -3570.0,
        -4949.55908203125,
        878.7069702148438
      ],
      "bbox_max": [
        -3555.26318359375,
        -4930.87451171875,
        888.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.705345630645752,
        -0.07053456455469131,
        0.705345630645752
      ],
      "plane_d": 1538.5037841796875,
      "bbox_min": [
        -3570.0,
        -4949.55908203125,
        878.7069702148438
      ],
      "bbox_max": [
        -3555.26318359375,
        -4930.87451171875,
        888.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09950372576713562,
        0.9950372576713562
      ],
      "plane_d": -1374.93701171875,
      "bbox_min": [
        -3570.0,
        -4949.55908203125,
        878.7069702148438
      ],
      "bbox_max": [
        -3555.26318359375,
        -4930.87451171875,
        888.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3570.0,
      "bbox_min": [
        -3570.0,
        -4949.55908203125,
        878.7069702148438
      ],
      "bbox_max": [
        -3555.26318359375,
        -4930.87451171875,
        885.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8778926730155945,
        -0.4788573384284973,
        3.332963615321205e-06
      ],
      "plane_d": -5500.0537109375,
      "bbox_min": [
        -3570.0,
        -4949.55908203125,
        878.7069702148438
      ],
      "bbox_max": [
        -3555.26318359375,
        -4930.87451171875,
        885.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.705345630645752,
        0.07053456455469131,
        -0.705345630645752
      ],
      "plane_d": -1548.3785400390625,
      "bbox_min": [
        -3570.0,
        -4949.55908203125,
        878.7069702148438
      ],
      "bbox_max": [
        -3555.26318359375,
        -4930.87451171875,
        885.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3560.0,
      "bbox_min": [
        -3563.0,
        -4949.55908203125,
        878.7069702148438
      ],
      "bbox_max": [
        -3555.26318359375,
        -4930.87451171875,
        885.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.705345630645752,
        0.07053456455469131,
        -0.705345630645752
      ],
      "plane_d": 3480.73583984375,
      "bbox_min": [
        -3563.0,
        -4942.4921875,
        878.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4930.87451171875,
        881.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.532341718673706,
        0.6581981182098389,
        -0.532341718673706
      ],
      "plane_d": 5616.0478515625,
      "bbox_min": [
        -3562.0,
        -4942.4921875,
        878.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4940.87451171875,
        880.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.532341718673706,
        0.6581981182098389,
        -0.532341718673706
      ],
      "plane_d": 5616.0478515625,
      "bbox_min": [
        -3560.0,
        -4943.76904296875,
        878.70703125
      ],
      "bbox_max": [
        -3558.421142578125,
        -4940.87451171875,
        880.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7033984661102295,
        0.102279894053936,
        -0.7033984661102295
      ],
      "plane_d": -1386.29248046875,
      "bbox_min": [
        -3570.0,
        -4943.76953125,
        878.7069702148438
      ],
      "bbox_max": [
        -3568.0,
        -4940.87451171875,
        880.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1892.8492431640625,
      "bbox_min": [
        -3557.0,
        -4953.900390625,
        878.7071533203125
      ],
      "bbox_max": [
        -3555.60009765625,
        -4951.87451171875,
        880.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -3140.3369140625,
      "bbox_min": [
        -3562.39990234375,
        -4953.900390625,
        878.7071533203125
      ],
      "bbox_max": [
        -3561.0,
        -4951.87451171875,
        880.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4962.27392578125,
      "bbox_min": [
        -3563.7353515625,
        -4963.474609375,
        878.70703125
      ],
      "bbox_max": [
        -3554.185791015625,
        -4951.87451171875,
        881.1070556640625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -880.1070556640625,
      "bbox_min": [
        -3562.39990234375,
        -4962.2744140625,
        878.7071533203125
      ],
      "bbox_max": [
        -3555.60009765625,
        -4951.87451171875,
        880.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1892.8492431640625,
      "bbox_min": [
        -3557.0,
        -4962.2744140625,
        878.7071533203125
      ],
      "bbox_max": [
        -3555.60009765625,
        -4951.87451171875,
        880.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -881.1070556640625,
      "bbox_min": [
        -3563.7353515625,
        -4963.474609375,
        878.70703125
      ],
      "bbox_max": [
        -3554.185791015625,
        -4962.2744140625,
        881.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4963.474609375,
      "bbox_min": [
        -3563.7353515625,
        -4963.474609375,
        878.70703125
      ],
      "bbox_max": [
        -3554.185791015625,
        -4962.2744140625,
        881.1070556640625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071248292922974,
        0.0,
        0.707088828086853
      ],
      "plane_d": 1891.928955078125,
      "bbox_min": [
        -3563.7353515625,
        -4963.474609375,
        878.70703125
      ],
      "bbox_max": [
        -3554.185791015625,
        -4962.2744140625,
        881.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071248292922974,
        0.0,
        0.707088828086853
      ],
      "plane_d": -3141.385498046875,
      "bbox_min": [
        -3563.7353515625,
        -4963.474609375,
        878.7071533203125
      ],
      "bbox_max": [
        -3555.60009765625,
        -4962.2744140625,
        881.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 880.1070556640625,
      "bbox_min": [
        -3562.39990234375,
        -4963.474609375,
        878.7071533203125
      ],
      "bbox_max": [
        -3555.60009765625,
        -4962.2744140625,
        880.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 3140.3369140625,
      "bbox_min": [
        -3562.39990234375,
        -4963.474609375,
        878.7071533203125
      ],
      "bbox_max": [
        -3555.60009765625,
        -4962.2744140625,
        880.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -1892.8492431640625,
      "bbox_min": [
        -3557.0,
        -4963.474609375,
        878.7071533203125
      ],
      "bbox_max": [
        -3555.60009765625,
        -4962.2744140625,
        880.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660266399383545,
        -0.4999978244304657,
        -2.9626713171637675e-07
      ],
      "plane_d": 561.2109375,
      "bbox_min": [
        -3539.2080078125,
        -5006.19775390625,
        881.7071533203125
      ],
      "bbox_max": [
        -3537.842041015625,
        -5004.83154296875,
        887.121826171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49999502301216125,
        -0.8660283088684082,
        -5.131537363922689e-07
      ],
      "plane_d": -6104.662109375,
      "bbox_min": [
        -3539.2080078125,
        -5006.19775390625,
        882.7071533203125
      ],
      "bbox_max": [
        -3537.842041015625,
        -5004.83154296875,
        887.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3535401225090027,
        -0.6123791933059692,
        0.7071076035499573
      ],
      "plane_d": -4943.220703125,
      "bbox_min": [
        -3539.2080078125,
        -5006.19775390625,
        886.121337890625
      ],
      "bbox_max": [
        -3537.842041015625,
        -5004.83154296875,
        887.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857633113861084,
        -0.49515458941459656,
        0.13887907564640045
      ],
      "plane_d": -5594.671875,
      "bbox_min": [
        -3581.159912109375,
        -5023.9755859375,
        846.3814086914062
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4951545298099518,
        -0.857633113861084,
        0.13887937366962433
      ],
      "plane_d": -6109.056640625,
      "bbox_min": [
        -3581.159912109375,
        -5023.9755859375,
        846.3814086914062
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9903093576431274,
        0.0,
        0.13887919485569
      ],
      "plane_d": -3599.802490234375,
      "bbox_min": [
        -3581.159912109375,
        -5023.9755859375,
        846.3814086914062
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857633113861084,
        0.49515441060066223,
        0.1388797163963318
      ],
      "plane_d": -658.97216796875,
      "bbox_min": [
        -3581.159912109375,
        -5023.9755859375,
        846.3814086914062
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.580791366810445e-07,
        -0.9903091192245483,
        0.13888080418109894
      ],
      "plane_d": -5005.12353515625,
      "bbox_min": [
        -3581.159912109375,
        -5023.9755859375,
        846.3814086914062
      ],
      "bbox_max": [
        -3514.400146484375,
        -4930.87451171875,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7894070744514465,
        -0.4557642936706543,
        0.41123637557029724
      ],
      "plane_d": -5393.3828125,
      "bbox_min": [
        -3581.159912109375,
        -5023.9755859375,
        846.3814086914062
      ],
      "bbox_max": [
        -3514.400146484375,
        -4930.87451171875,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9115286469459534,
        0.0,
        0.41123658418655396
      ],
      "plane_d": -3557.2080078125,
      "bbox_min": [
        -3581.159912109375,
        -5023.9755859375,
        846.3814086914062
      ],
      "bbox_max": [
        -3514.400146484375,
        -4930.87451171875,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.455764502286911,
        -0.7894071340560913,
        0.4112360179424286
      ],
      "plane_d": -5866.84765625,
      "bbox_min": [
        -3581.159912109375,
        -5023.9755859375,
        846.3814086914062
      ],
      "bbox_max": [
        -3514.400146484375,
        -4930.87451171875,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4962.27392578125,
      "bbox_min": [
        -3581.159912109375,
        -5023.9755859375,
        855.2828369140625
      ],
      "bbox_max": [
        -3514.400146484375,
        -4930.87451171875,
        878.7071533203125
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.5684306025505066,
        -0.8227311968803406
      ],
      "plane_d": 3530.6611328125,
      "bbox_min": [
        -3581.159912109375,
        -4962.2744140625,
        855.2828369140625
      ],
      "bbox_max": [
        -3551.3876953125,
        -4930.87451171875,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5323566198348999,
        0.6581739187240601,
        -0.5323566198348999
      ],
      "plane_d": 5615.994140625,
      "bbox_min": [
        -3568.4208984375,
        -4962.2744140625,
        870.1070556640625
      ],
      "bbox_max": [
        -3554.0,
        -4939.42724609375,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7033962607383728,
        0.10231061279773712,
        -0.7033962607383728
      ],
      "plane_d": -1386.1348876953125,
      "bbox_min": [
        -3568.4208984375,
        -4962.2744140625,
        870.1070556640625
      ],
      "bbox_max": [
        -3554.0,
        -4939.42724609375,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3554.0,
      "bbox_min": [
        -3568.4208984375,
        -4962.2744140625,
        870.1070556640625
      ],
      "bbox_max": [
        -3554.0,
        -4943.76904296875,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 3130.4375,
      "bbox_min": [
        -3568.4208984375,
        -4962.2744140625,
        870.1070556640625
      ],
      "bbox_max": [
        -3554.0,
        -4943.76904296875,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8778966069221497,
        0.47885027527809143,
        -0.0
      ],
      "plane_d": 5491.2509765625,
      "bbox_min": [
        -3568.4208984375,
        -4962.2744140625,
        870.1070556640625
      ],
      "bbox_max": [
        -3554.0,
        -4943.76904296875,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.0,
        0.7071068286895752
      ],
      "plane_d": 1892.8492431640625,
      "bbox_min": [
        -3568.4208984375,
        -4962.2744140625,
        870.1070556640625
      ],
      "bbox_max": [
        -3554.0,
        -4943.76953125,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -3140.3369140625,
      "bbox_min": [
        -3568.4208984375,
        -4962.2744140625,
        870.1070556640625
      ],
      "bbox_max": [
        -3557.0,
        -4943.76953125,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3564.0,
      "bbox_min": [
        -3565.764404296875,
        -4958.46728515625,
        870.1070556640625
      ],
      "bbox_max": [
        -3557.0,
        -4948.6396484375,
        877.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 870.1070556640625,
      "bbox_min": [
        -3559.72900390625,
        -4956.5869140625,
        870.1070556640625
      ],
      "bbox_max": [
        -3557.0,
        -4951.87451171875,
        870.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.877892792224884,
        -0.4788573682308197,
        9.826446330407634e-06
      ],
      "plane_d": -5500.06005859375,
      "bbox_min": [
        -3565.764404296875,
        -4951.87451171875,
        873.7749633789062
      ],
      "bbox_max": [
        -3564.0,
        -4948.6396484375,
        877.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.877892792224884,
        -0.4788573682308197,
        9.826446330407634e-06
      ],
      "plane_d": -5500.06005859375,
      "bbox_min": [
        -3568.4208984375,
        -4951.87451171875,
        875.342041015625
      ],
      "bbox_max": [
        -3562.39990234375,
        -4943.76953125,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5323650240898132,
        -0.6581605076789856,
        0.5323649048805237
      ],
      "plane_d": -5623.41796875,
      "bbox_min": [
        -3565.26318359375,
        -4951.87451171875,
        877.1070556640625
      ],
      "bbox_max": [
        -3562.39990234375,
        -4949.55859375,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7033973932266235,
        -0.10229448229074478,
        0.7033973932266235
      ],
      "plane_d": 1376.3699951171875,
      "bbox_min": [
        -3555.60009765625,
        -4951.87451171875,
        877.1070556640625
      ],
      "bbox_max": [
        -3554.0,
        -4949.55908203125,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.705345630645752,
        0.07053456455469131,
        -0.705345630645752
      ],
      "plane_d": 3480.73583984375,
      "bbox_min": [
        -3563.0,
        -4940.87451171875,
        877.70703125
      ],
      "bbox_max": [
        -3562.0,
        -4939.42724609375,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.705345630645752,
        0.07053456455469131,
        -0.705345630645752
      ],
      "plane_d": 3480.73583984375,
      "bbox_min": [
        -3563.0,
        -4940.87451171875,
        877.70703125
      ],
      "bbox_max": [
        -3562.144775390625,
        -4930.87451171875,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49515417218208313,
        -0.8576332926750183,
        0.1388794481754303
      ],
      "plane_d": -2578.68017578125,
      "bbox_min": [
        -3581.159912109375,
        -4932.0283203125,
        876.48291015625
      ],
      "bbox_max": [
        -3579.077392578125,
        -4930.87451171875,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7894072532653809,
        0.4557639956474304,
        0.41123640537261963
      ],
      "plane_d": -850.326171875,
      "bbox_min": [
        -3562.977294921875,
        -5023.9755859375,
        855.35302734375
      ],
      "bbox_max": [
        -3514.400146484375,
        -4962.2744140625,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3553.0,
      "bbox_min": [
        -3562.977294921875,
        -5023.9755859375,
        870.9790649414062
      ],
      "bbox_max": [
        -3526.03515625,
        -4962.2744140625,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4963.474609375,
      "bbox_min": [
        -3562.977294921875,
        -4963.474609375,
        870.9790649414062
      ],
      "bbox_max": [
        -3553.0,
        -4962.2744140625,
        878.7071533203125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -1892.8492431640625,
      "bbox_min": [
        -3562.977294921875,
        -4963.474609375,
        870.9790649414062
      ],
      "bbox_max": [
        -3553.0,
        -4962.2744140625,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.0,
        0.7071068286895752
      ],
      "plane_d": 1891.849365234375,
      "bbox_min": [
        -3554.185791015625,
        -4963.474609375,
        877.521240234375
      ],
      "bbox_max": [
        -3553.0,
        -4962.2744140625,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071188688278198,
        0.0,
        -0.7070947885513306
      ],
      "plane_d": 3129.469970703125,
      "bbox_min": [
        -3562.977294921875,
        -4963.474609375,
        870.9790649414062
      ],
      "bbox_max": [
        -3553.0,
        -4962.2744140625,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3554.0,
      "bbox_min": [
        -3562.977294921875,
        -4963.474609375,
        871.635009765625
      ],
      "bbox_max": [
        -3554.0,
        -4962.2744140625,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -3130.4375,
      "bbox_min": [
        -3562.977294921875,
        -4963.474609375,
        871.635009765625
      ],
      "bbox_max": [
        -3554.0,
        -4962.2744140625,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 3140.3369140625,
      "bbox_min": [
        -3562.977294921875,
        -4963.474609375,
        878.1297607421875
      ],
      "bbox_max": [
        -3562.39990234375,
        -4962.2744140625,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866028368473053,
        -0.4999948740005493,
        -1.7927490262081847e-05
      ],
      "plane_d": 561.2470703125,
      "bbox_min": [
        -3537.9150390625,
        -5023.9755859375,
        876.6172485351562
      ],
      "bbox_max": [
        -3526.03515625,
        -4997.544921875,
        878.7071533203125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.3214550563134253e-05,
        7.629319952684455e-06,
        -1.0
      ],
      "plane_d": 877.6986083984375,
      "bbox_min": [
        -3537.9150390625,
        -5003.9580078125,
        877.7071533203125
      ],
      "bbox_max": [
        -3533.635009765625,
        -4997.544921875,
        878.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660289645195007,
        0.49999386072158813,
        1.7823032976593822e-05
      ],
      "plane_d": -562.254150390625,
      "bbox_min": [
        -3537.9150390625,
        -5003.9580078125,
        877.7071533203125
      ],
      "bbox_max": [
        -3533.635009765625,
        -4997.544921875,
        878.7071533203125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3535401523113251,
        0.6123790740966797,
        -0.707107663154602
      ],
      "plane_d": 4931.3203125,
      "bbox_min": [
        -3537.9150390625,
        -5003.9580078125,
        877.7071533203125
      ],
      "bbox_max": [
        -3533.635009765625,
        -4997.544921875,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35355934500694275,
        -0.6123694181442261,
        -0.7071064114570618
      ],
      "plane_d": -3693.48828125,
      "bbox_min": [
        -3537.9150390625,
        -5003.9580078125,
        877.7071533203125
      ],
      "bbox_max": [
        -3536.549072265625,
        -5002.59228515625,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4951542913913727,
        0.8576332330703735,
        0.1388794630765915
      ],
      "plane_d": 2439.8330078125,
      "bbox_min": [
        -3527.91259765625,
        -5023.9755859375,
        876.6172485351562
      ],
      "bbox_max": [
        -3526.03515625,
        -5022.67724609375,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 878.70703125,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        883.7070922851562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5000002980232239,
        -0.8660252094268799,
        0.0
      ],
      "plane_d": -2480.6796875,
      "bbox_min": [
        -3601.944580078125,
        -5035.9755859375,
        878.70703125
      ],
      "bbox_max": [
        -3540.036865234375,
        -4939.0283203125,
        883.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45576414465904236,
        -0.7894073128700256,
        0.41123607754707336
      ],
      "plane_d": -2617.31640625,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.0193518796295393e-07,
        -0.9115290641784668,
        0.4112356901168823
      ],
      "plane_d": -4850.7373046875,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7894072532653809,
        0.4557639956474304,
        0.41123640537261963
      ],
      "plane_d": -850.326171875,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49515417218208313,
        -0.8576332926750183,
        0.1388794481754303
      ],
      "plane_d": -2578.68017578125,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4951542913913727,
        0.8576332330703735,
        0.1388794630765915
      ],
      "plane_d": 2439.8330078125,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7894081473350525,
        -0.45576465129852295,
        0.4112339913845062
      ],
      "plane_d": 234.976318359375,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        876.6228637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.019351595412445e-07,
        0.9115289449691772,
        0.41123586893081665
      ],
      "plane_d": 4235.38671875,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        876.6228637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7486927509307861,
        -0.0,
        0.6629171967506409
      ],
      "plane_d": 2142.08203125,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        876.6228637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37434688210487366,
        0.6483861207962036,
        0.6629176735877991
      ],
      "plane_d": 1370.085205078125,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        876.6228637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.4133904591726605e-07,
        -0.7486931085586548,
        0.6629167795181274
      ],
      "plane_d": -4258.439453125,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        876.6228637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.4133904591726605e-07,
        0.7486931085586548,
        0.6629167795181274
      ],
      "plane_d": 3204.5361328125,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        876.6228637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37434688210487366,
        -0.6483863592147827,
        0.66291743516922
      ],
      "plane_d": -2423.991455078125,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        876.6228637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37434613704681396,
        0.64838707447052,
        0.6629171371459961
      ],
      "plane_d": 4039.12548828125,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        876.6228637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6483879089355469,
        0.3743458390235901,
        0.6629165410995483
      ],
      "plane_d": 3650.2431640625,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        876.6228637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6483868956565857,
        -0.37434670329093933,
        0.6629170179367065
      ],
      "plane_d": -81.2451171875,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        876.6228637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6483868956565857,
        0.37434688210487366,
        0.6629169583320618
      ],
      "plane_d": -972.658203125,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        876.6228637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9115298986434937,
        -0.0,
        0.4112338125705719
      ],
      "plane_d": 2941.86279296875,
      "bbox_min": [
        -3613.2822265625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        876.6228637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45576462149620056,
        0.7894071340560913,
        0.41123586893081665
      ],
      "plane_d": 5251.4970703125,
      "bbox_min": [
        -3611.76220703125,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        876.6228637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8576340675354004,
        -0.4951527416706085,
        0.13887979090213776
      ],
      "plane_d": 520.13671875,
      "bbox_min": [
        -3611.76220703125,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        876.6228637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.7903956834052224e-07,
        0.9903091788291931,
        0.1388804018497467
      ],
      "plane_d": 4866.2763671875,
      "bbox_min": [
        -3609.244140625,
        -5036.8154296875,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        876.488525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3743467628955841,
        -0.6483868360519409,
        0.6629170775413513
      ],
      "plane_d": -5093.03076171875,
      "bbox_min": [
        -3609.244140625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7894070148468018,
        0.4557643234729767,
        0.4112364649772644
      ],
      "plane_d": 4778.03125,
      "bbox_min": [
        -3609.244140625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7486927509307861,
        0.0,
        0.6629171967506409
      ],
      "plane_d": -3195.986328125,
      "bbox_min": [
        -3596.152587890625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4987669289112091,
        -0.0,
        0.866736114025116
      ],
      "plane_d": 1074.107177734375,
      "bbox_min": [
        -3596.152587890625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4987669289112091,
        0.0,
        0.866736114025116
      ],
      "plane_d": -2482.027099609375,
      "bbox_min": [
        -3596.152587890625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.431944876909256,
        -0.24938276410102844,
        0.8667362928390503
      ],
      "plane_d": -407.0325927734375,
      "bbox_min": [
        -3596.152587890625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43194451928138733,
        0.24938321113586426,
        0.8667363524436951
      ],
      "plane_d": 2078.81591796875,
      "bbox_min": [
        -3596.152587890625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4319451153278351,
        -0.24938353896141052,
        0.8667359948158264
      ],
      "plane_d": -3486.73974609375,
      "bbox_min": [
        -3587.785400390625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4319448471069336,
        0.24938279390335083,
        0.8667363524436951
      ],
      "plane_d": -1000.8876953125,
      "bbox_min": [
        -3587.785400390625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24938291311264038,
        -0.4319455325603485,
        0.8667359352111816
      ],
      "plane_d": -1967.744873046875,
      "bbox_min": [
        -3587.785400390625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24938368797302246,
        0.43194469809532166,
        0.8667361736297607
      ],
      "plane_d": 2337.88671875,
      "bbox_min": [
        -3587.785400390625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24938353896141052,
        -0.43194466829299927,
        0.8667361736297607
      ],
      "plane_d": -3745.80615234375,
      "bbox_min": [
        -3581.3427734375,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24938294291496277,
        0.4319455921649933,
        0.8667359352111816
      ],
      "plane_d": 559.8253784179688,
      "bbox_min": [
        -3581.3427734375,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0813224804451238e-07,
        -0.4987664520740509,
        0.8667364120483398
      ],
      "plane_d": -3189.81298828125,
      "bbox_min": [
        -3581.3427734375,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4987664222717285,
        0.8667364120483398
      ],
      "plane_d": 1781.891845703125,
      "bbox_min": [
        -3581.3427734375,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6483864784240723,
        -0.37434637546539307,
        0.6629176139831543
      ],
      "plane_d": -4704.14453125,
      "bbox_min": [
        -3581.3427734375,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17608360946178436,
        -0.0,
        0.9843752384185791
      ],
      "plane_d": -178.18994140625,
      "bbox_min": [
        -3581.3427734375,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08804155141115189,
        -0.15249302983283997,
        0.9843752384185791
      ],
      "plane_d": -1252.07861328125,
      "bbox_min": [
        -3581.3427734375,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.152492955327034,
        -0.08804158866405487,
        0.9843752384185791
      ],
      "plane_d": -701.0881958007812,
      "bbox_min": [
        -3581.3427734375,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15249283611774445,
        0.088041752576828,
        0.9843752384185791
      ],
      "plane_d": 176.51089477539062,
      "bbox_min": [
        -3581.3427734375,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08804184198379517,
        0.15249276161193848,
        0.9843752384185791
      ],
      "plane_d": 267.9717102050781,
      "bbox_min": [
        -3578.570556640625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.817482507884051e-08,
        -0.17608366906642914,
        0.9843751788139343
      ],
      "plane_d": -1683.5159912109375,
      "bbox_min": [
        -3578.570556640625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.17608365416526794,
        0.9843751788139343
      ],
      "plane_d": 71.6861572265625,
      "bbox_min": [
        -3578.570556640625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08804181963205338,
        -0.15249280631542206,
        0.9843752384185791
      ],
      "plane_d": -1879.8017578125,
      "bbox_min": [
        -3578.570556640625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08804155141115189,
        0.15249302983283997,
        0.9843752384185791
      ],
      "plane_d": -359.7511901855469,
      "bbox_min": [
        -3578.570556640625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.455764502286911,
        -0.7894071340560913,
        0.4112360179424286
      ],
      "plane_d": -5866.84765625,
      "bbox_min": [
        -3578.570556640625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15249285101890564,
        -0.088041752576828,
        0.9843752384185791
      ],
      "plane_d": -1788.3408203125,
      "bbox_min": [
        -3578.570556640625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.152492955327034,
        0.08804161101579666,
        0.9843752384185791
      ],
      "plane_d": -910.7415161132812,
      "bbox_min": [
        -3578.570556640625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17608360946178436,
        0.0,
        0.9843752384185791
      ],
      "plane_d": -1433.639892578125,
      "bbox_min": [
        -3578.570556640625,
        -5021.29150390625,
        818.70703125
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857633113861084,
        0.49515441060066223,
        0.1388797163963318
      ],
      "plane_d": -658.97216796875,
      "bbox_min": [
        -3578.570556640625,
        -5021.29150390625,
        843.43994140625
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        863.121826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.580791366810445e-07,
        -0.9903091192245483,
        0.13888080418109894
      ],
      "plane_d": -5005.12353515625,
      "bbox_min": [
        -3578.570556640625,
        -4995.6845703125,
        843.43994140625
      ],
      "bbox_max": [
        -3521.321044921875,
        -4933.078125,
        862.9923706054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9115286469459534,
        0.0,
        0.41123658418655396
      ],
      "plane_d": -3557.2080078125,
      "bbox_min": [
        -3521.946044921875,
        -4995.6845703125,
        843.43994140625
      ],
      "bbox_max": [
        -3521.321044921875,
        -4991.8408203125,
        844.8253173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 878.70703125,
      "bbox_min": [
        -3618.054931640625,
        -5067.609375,
        846.3855590820312
      ],
      "bbox_max": [
        -3511.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -993.70703125,
      "bbox_min": [
        -3618.054931640625,
        -5067.609375,
        878.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2834.29150390625,
      "bbox_min": [
        -3618.054931640625,
        -5067.609375,
        878.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 988.70703125,
      "bbox_min": [
        -3618.054931640625,
        -5002.00048828125,
        922.5809326171875
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4214.1494140625,
      "bbox_min": [
        -3618.0517578125,
        -5002.00048828125,
        988.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3198.743896484375,
      "bbox_min": [
        -3618.0517578125,
        -5002.00048828125,
        988.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4966.0,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -1842.82275390625,
      "bbox_min": [
        -3618.0517578125,
        -5002.00048828125,
        988.70703125
      ],
      "bbox_max": [
        -3594.85205078125,
        -4966.0,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3618.0517578125,
      "bbox_min": [
        -3618.0517578125,
        -5002.00048828125,
        988.70703125
      ],
      "bbox_max": [
        -3615.8779296875,
        -4966.0,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660262823104858,
        -0.4999984800815582,
        0.0
      ],
      "plane_d": 648.45263671875,
      "bbox_min": [
        -3618.0517578125,
        -5002.00048828125,
        989.941650390625
      ],
      "bbox_max": [
        -3615.8779296875,
        -4966.0,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        0.49999839067459106,
        0.0
      ],
      "plane_d": 5632.43798828125,
      "bbox_min": [
        -3618.0517578125,
        -5002.00048828125,
        989.9419555664062
      ],
      "bbox_max": [
        -3615.8779296875,
        -4998.2353515625,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10923247784376144,
        -0.0,
        -0.9940162301063538
      ],
      "plane_d": 600.1822509765625,
      "bbox_min": [
        -3530.0,
        -5002.00048828125,
        989.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4966.0,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3530.0,
      "bbox_min": [
        -3530.0,
        -5002.00048828125,
        989.941650390625
      ],
      "bbox_max": [
        -3511.800048828125,
        -4966.0,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.934380518127e-06,
        1.0,
        0.0
      ],
      "plane_d": 4969.77587890625,
      "bbox_min": [
        -3530.0,
        -5002.00048828125,
        989.941650390625
      ],
      "bbox_max": [
        -3511.800048828125,
        -4966.0,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4998.2353515625,
      "bbox_min": [
        -3530.0,
        -5002.00048828125,
        989.9418334960938
      ],
      "bbox_max": [
        -3511.800048828125,
        -4998.2353515625,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253286361694,
        0.5000001192092896,
        0.0
      ],
      "plane_d": -542.189697265625,
      "bbox_min": [
        -3513.973876953125,
        -5002.00048828125,
        989.94189453125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4998.2353515625,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866025447845459,
        -0.4999999403953552,
        -0.0
      ],
      "plane_d": -5526.1904296875,
      "bbox_min": [
        -3513.973876953125,
        -4969.765625,
        989.941650390625
      ],
      "bbox_max": [
        -3511.800048828125,
        -4966.0,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10923245549201965,
        -0.9940162301063538
      ],
      "plane_d": 445.17333984375,
      "bbox_min": [
        -3618.0517578125,
        -4971.00048828125,
        988.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -5.35958520231361e-07,
        -1.0,
        -0.0
      ],
      "plane_d": -4930.87646484375,
      "bbox_min": [
        -3615.95068359375,
        -4966.1259765625,
        989.70703125
      ],
      "bbox_max": [
        -3513.901123046875,
        -4930.87451171875,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002980232239,
        -0.8660252094268799,
        0.0
      ],
      "plane_d": -2480.6796875,
      "bbox_min": [
        -3615.95068359375,
        -4966.1259765625,
        989.70703125
      ],
      "bbox_max": [
        -3513.901123046875,
        -4930.87451171875,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.866025447845459,
        0.0
      ],
      "plane_d": -6045.607421875,
      "bbox_min": [
        -3615.95068359375,
        -4966.1259765625,
        989.70703125
      ],
      "bbox_max": [
        -3513.901123046875,
        -4930.87451171875,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4949.07470703125,
      "bbox_min": [
        -3615.95068359375,
        -4966.1259765625,
        989.70703125
      ],
      "bbox_max": [
        -3513.901123046875,
        -4930.87451171875,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3550.69091796875,
      "bbox_min": [
        -3606.106201171875,
        -4949.07470703125,
        989.70703125
      ],
      "bbox_max": [
        -3523.745849609375,
        -4930.87451171875,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        3.3535743568791077e-06,
        0.0
      ],
      "plane_d": -3579.144287109375,
      "bbox_min": [
        -3606.106201171875,
        -4949.07470703125,
        989.70703125
      ],
      "bbox_max": [
        -3579.160888671875,
        -4930.87451171875,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660262823104858,
        -0.4999984800815582,
        0.0
      ],
      "plane_d": 648.45263671875,
      "bbox_min": [
        -3606.106201171875,
        -4949.07470703125,
        991.2713012695312
      ],
      "bbox_max": [
        -3603.81689453125,
        -4945.109375,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660262823104858,
        -0.4999984800815582,
        0.0
      ],
      "plane_d": 648.45263671875,
      "bbox_min": [
        -3615.95068359375,
        -4966.1259765625,
        991.70703125
      ],
      "bbox_max": [
        -3606.106201171875,
        -4949.07470703125,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002980232239,
        -0.8660252094268799,
        0.0
      ],
      "plane_d": -2480.6796875,
      "bbox_min": [
        -3618.0517578125,
        -4971.00048828125,
        988.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        993.580810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.866025447845459,
        0.0
      ],
      "plane_d": -6045.607421875,
      "bbox_min": [
        -3618.0517578125,
        -4971.00048828125,
        988.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        993.580810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -5.35958520231361e-07,
        -1.0,
        -0.0
      ],
      "plane_d": -4930.87646484375,
      "bbox_min": [
        -3618.0517578125,
        -4971.00048828125,
        988.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        993.580810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866025447845459,
        -0.4999999403953552,
        -0.0
      ],
      "plane_d": -5526.1904296875,
      "bbox_min": [
        -3618.0517578125,
        -4971.00048828125,
        988.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4945.109375,
        993.580810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.934380518127e-06,
        1.0,
        0.0
      ],
      "plane_d": 4969.77587890625,
      "bbox_min": [
        -3513.93603515625,
        -4969.765625,
        989.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4969.765625,
        989.9417724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002980232239,
        -0.8660252094268799,
        0.0
      ],
      "plane_d": -2480.6796875,
      "bbox_min": [
        -3618.054931640625,
        -4997.00048828125,
        922.5809326171875
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        988.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.866025447845459,
        0.0
      ],
      "plane_d": -6045.607421875,
      "bbox_min": [
        -3618.054931640625,
        -4997.00048828125,
        922.5809326171875
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        988.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -5.35958520231361e-07,
        -1.0,
        -0.0
      ],
      "plane_d": -4930.87646484375,
      "bbox_min": [
        -3618.054931640625,
        -4997.00048828125,
        922.5809326171875
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        988.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.866025447845459,
        -0.4999999403953552,
        -0.0
      ],
      "plane_d": -5526.1904296875,
      "bbox_min": [
        -3618.054931640625,
        -4997.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        988.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3618.0517578125,
      "bbox_min": [
        -3618.054931640625,
        -4997.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4930.87451171875,
        988.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.785787655585793e-12,
        1.984843038371764e-06,
        1.0
      ],
      "plane_d": -948.697265625,
      "bbox_min": [
        -3618.054931640625,
        -4988.5009765625,
        938.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4930.87451171875,
        980.20703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -3193.0869140625,
      "bbox_min": [
        -3595.88330078125,
        -4957.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3519.95751953125,
        -4930.87451171875,
        948.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        2.8069919153494993e-06,
        0.7071067690849304
      ],
      "plane_d": 1848.59814453125,
      "bbox_min": [
        -3570.0,
        -4957.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3519.95751953125,
        -4930.87451171875,
        948.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.984843038371764e-06,
        -0.0
      ],
      "plane_d": 3560.009765625,
      "bbox_min": [
        -3570.0,
        -4954.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4930.87451171875,
        945.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.984843493119115e-06,
        -0.0
      ],
      "plane_d": -3570.009765625,
      "bbox_min": [
        -3570.0,
        -4954.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4930.87451171875,
        945.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3183.1875,
      "bbox_min": [
        -3570.0,
        -4950.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4930.87451171875,
        941.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -2.8069925974705257e-06,
        -0.7071067690849304
      ],
      "plane_d": -1858.49755859375,
      "bbox_min": [
        -3570.0,
        -4950.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3563.0,
        -4930.87451171875,
        941.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.785788522947531e-12,
        -1.984843493119115e-06,
        -1.0
      ],
      "plane_d": 938.697265625,
      "bbox_min": [
        -3567.0,
        -4947.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3563.0,
        -4930.87451171875,
        938.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35355323553085327,
        0.612372100353241,
        0.7071071267127991
      ],
      "plane_d": 1119.368408203125,
      "bbox_min": [
        -3523.1103515625,
        -4957.00048828125,
        944.7528076171875
      ],
      "bbox_max": [
        -3519.95751953125,
        -4953.04638671875,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000007152557373,
        0.8660249710083008,
        0.0
      ],
      "plane_d": 2528.73046875,
      "bbox_min": [
        -3523.1103515625,
        -4954.00048828125,
        944.7528076171875
      ],
      "bbox_max": [
        -3521.45751953125,
        -4953.04638671875,
        945.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        -0.866025984287262,
        0.0
      ],
      "plane_d": -2485.6865234375,
      "bbox_min": [
        -3595.88330078125,
        -4944.85693359375,
        938.70703125
      ],
      "bbox_max": [
        -3584.722900390625,
        -4935.52685546875,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123673915863037,
        0.3535606563091278,
        0.7071075439453125
      ],
      "plane_d": 3272.98974609375,
      "bbox_min": [
        -3595.88330078125,
        -4944.85693359375,
        938.70703125
      ],
      "bbox_max": [
        -3584.722900390625,
        -4935.52685546875,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123717427253723,
        -0.3535531759262085,
        0.7071075439453125
      ],
      "plane_d": -4617.47265625,
      "bbox_min": [
        -3595.88330078125,
        -4944.85693359375,
        938.70703125
      ],
      "bbox_max": [
        -3584.722900390625,
        -4935.52685546875,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123717427253723,
        0.3535531759262085,
        -0.7071075439453125
      ],
      "plane_d": 4607.5732421875,
      "bbox_min": [
        -3595.88330078125,
        -4944.85693359375,
        938.70703125
      ],
      "bbox_max": [
        -3584.722900390625,
        -4935.52685546875,
        945.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123673915863037,
        -0.3535606563091278,
        -0.7071075439453125
      ],
      "plane_d": -3282.889404296875,
      "bbox_min": [
        -3595.88330078125,
        -4944.85693359375,
        938.70703125
      ],
      "bbox_max": [
        -3584.722900390625,
        -4935.52685546875,
        945.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.051776729989797e-06,
        -5.2857803893857636e-06,
        -1.0
      ],
      "plane_d": 938.6918334960938,
      "bbox_min": [
        -3595.88330078125,
        -4944.85693359375,
        938.70703125
      ],
      "bbox_max": [
        -3584.722900390625,
        -4935.52685546875,
        945.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660222291946411,
        0.5000054836273193,
        -0.0
      ],
      "plane_d": 5574.4052734375,
      "bbox_min": [
        -3595.88330078125,
        -4944.85693359375,
        941.70703125
      ],
      "bbox_max": [
        -3584.722900390625,
        -4935.52685546875,
        945.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660222291946411,
        -0.5000054836273193,
        -0.0
      ],
      "plane_d": -5584.4052734375,
      "bbox_min": [
        -3595.88330078125,
        -4944.85693359375,
        941.70703125
      ],
      "bbox_max": [
        -3593.38330078125,
        -4940.52685546875,
        945.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        2.6541457032180915e-07,
        0.7071067690849304
      ],
      "plane_d": -3211.470458984375,
      "bbox_min": [
        -3618.054931640625,
        -4988.5009765625,
        951.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4930.87451171875,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        2.388730308666709e-06,
        0.7071067690849304
      ],
      "plane_d": 1830.211181640625,
      "bbox_min": [
        -3570.0,
        -4988.5009765625,
        964.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4930.87451171875,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -2.6541448505668086e-07,
        -0.7071067690849304
      ],
      "plane_d": 3201.571044921875,
      "bbox_min": [
        -3570.0,
        -4951.20068359375,
        964.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4930.87451171875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -2.3887312181614107e-06,
        -0.7071067690849304
      ],
      "plane_d": -1840.110595703125,
      "bbox_min": [
        -3570.0,
        -4951.20068359375,
        964.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4930.87451171875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.5796428755202614e-12,
        1.8767638039207668e-06,
        1.0
      ],
      "plane_d": -974.69775390625,
      "bbox_min": [
        -3570.0,
        -4951.20068359375,
        964.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4930.87451171875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.501411020399246e-06,
        -0.0
      ],
      "plane_d": 3560.00732421875,
      "bbox_min": [
        -3570.0,
        -4951.20068359375,
        964.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4930.87451171875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.5014115888334345e-06,
        -0.0
      ],
      "plane_d": -3570.00732421875,
      "bbox_min": [
        -3570.0,
        -4951.20068359375,
        964.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4930.87451171875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.5796441765628684e-12,
        -1.8767644860417931e-06,
        -1.0
      ],
      "plane_d": 964.69775390625,
      "bbox_min": [
        -3570.0,
        -4951.20068359375,
        964.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4930.87451171875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4951.20068359375,
      "bbox_min": [
        -3570.0,
        -4951.20068359375,
        964.7070922851562
      ],
      "bbox_max": [
        -3560.0,
        -4951.20068359375,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2829.6953125,
      "bbox_min": [
        -3542.893310546875,
        -4988.5009765625,
        971.95703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -980.20703125,
      "bbox_min": [
        -3542.893310546875,
        -4988.5009765625,
        971.95703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        980.20703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4979.00048828125,
      "bbox_min": [
        -3542.893310546875,
        -4988.5009765625,
        971.95703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4208.84619140625,
      "bbox_min": [
        -3542.893310546875,
        -4988.5009765625,
        971.95703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4218.74560546875,
      "bbox_min": [
        -3542.893310546875,
        -4988.5009765625,
        971.95703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810840606689453,
        0.6785976886749268,
        0.6785992383956909
      ],
      "plane_d": 1722.8172607421875,
      "bbox_min": [
        -3542.893310546875,
        -4987.25048828125,
        971.95703125
      ],
      "bbox_max": [
        -3532.0,
        -4979.00048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268306851387024,
        0.9238796830177307,
        0.0
      ],
      "plane_d": 3248.36083984375,
      "bbox_min": [
        -3542.893310546875,
        -4987.25048828125,
        971.95703125
      ],
      "bbox_max": [
        -3532.0,
        -4979.00048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28108450770378113,
        0.6785973906517029,
        -0.6785993576049805
      ],
      "plane_d": 3046.364013671875,
      "bbox_min": [
        -3542.893310546875,
        -4987.25048828125,
        971.95703125
      ],
      "bbox_max": [
        -3532.0,
        -4979.00048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785984635353088,
        0.28108397126197815,
        0.6785984635353088
      ],
      "plane_d": -1665.989013671875,
      "bbox_min": [
        -3542.893310546875,
        -4987.25048828125,
        974.8075561523438
      ],
      "bbox_max": [
        -3539.778076171875,
        -4983.10107421875,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923879861831665,
        0.38268256187438965,
        0.0
      ],
      "plane_d": -1365.3436279296875,
      "bbox_min": [
        -3542.893310546875,
        -4985.50048828125,
        974.8075561523438
      ],
      "bbox_max": [
        -3541.8994140625,
        -4983.10107421875,
        977.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28108537197113037,
        -0.6785986423492432,
        0.6785977482795715
      ],
      "plane_d": -3055.865966796875,
      "bbox_min": [
        -3541.868408203125,
        -4988.5009765625,
        978.9568481445312
      ],
      "bbox_max": [
        -3532.0,
        -4986.00048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785984635353088,
        0.28108397126197815,
        0.6785984635353088
      ],
      "plane_d": -1665.989013671875,
      "bbox_min": [
        -3541.868408203125,
        -4988.5009765625,
        978.9568481445312
      ],
      "bbox_max": [
        -3540.100341796875,
        -4986.00048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2833.584228515625,
      "bbox_min": [
        -3618.054931640625,
        -4983.00048828125,
        970.7070922851562
      ],
      "bbox_max": [
        -3603.054931640625,
        -4979.00048828125,
        974.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -974.70703125,
      "bbox_min": [
        -3618.054931640625,
        -4983.00048828125,
        970.7070922851562
      ],
      "bbox_max": [
        -3603.054931640625,
        -4979.00048828125,
        974.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3603.054931640625,
      "bbox_min": [
        -3603.054931640625,
        -4983.00048828125,
        970.7070922851562
      ],
      "bbox_max": [
        -3603.054931640625,
        -4979.00048828125,
        974.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3535533845424652,
        0.6123724579811096,
        0.7071067690849304
      ],
      "plane_d": 3631.06298828125,
      "bbox_min": [
        -3613.47265625,
        -4966.82763671875,
        951.70703125
      ],
      "bbox_max": [
        -3582.222900390625,
        -4935.52685546875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3535533845424652,
        -0.6123724579811096,
        0.7071067690849304
      ],
      "plane_d": -4993.9501953125,
      "bbox_min": [
        -3613.47265625,
        -4966.82763671875,
        951.70703125
      ],
      "bbox_max": [
        -3599.812255859375,
        -4953.16748046875,
        961.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999701976776,
        0.8660253882408142,
        -0.0
      ],
      "plane_d": 6093.80517578125,
      "bbox_min": [
        -3613.47265625,
        -4966.82763671875,
        951.70703125
      ],
      "bbox_max": [
        -3599.812255859375,
        -4953.16748046875,
        961.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -961.70703125,
      "bbox_min": [
        -3613.47265625,
        -4966.82763671875,
        951.70703125
      ],
      "bbox_max": [
        -3599.812255859375,
        -4953.16748046875,
        961.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3535533845424652,
        0.6123724579811096,
        -0.7071067690849304
      ],
      "plane_d": 4984.05078125,
      "bbox_min": [
        -3613.47265625,
        -4966.82763671875,
        951.70703125
      ],
      "bbox_max": [
        -3599.812255859375,
        -4953.16748046875,
        961.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999999701976776,
        -0.8660253882408142,
        -0.0
      ],
      "plane_d": -6103.80517578125,
      "bbox_min": [
        -3613.47265625,
        -4966.82763671875,
        951.70703125
      ],
      "bbox_max": [
        -3599.812255859375,
        -4955.765625,
        961.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        -0.5000000596046448,
        0.0
      ],
      "plane_d": 638.44482421875,
      "bbox_min": [
        -3613.47265625,
        -4966.82763671875,
        951.70703125
      ],
      "bbox_max": [
        -3599.812255859375,
        -4955.765625,
        961.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 951.70703125,
      "bbox_min": [
        -3613.47265625,
        -4963.00048828125,
        951.70703125
      ],
      "bbox_max": [
        -3602.637451171875,
        -4955.765625,
        954.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3535533845424652,
        -0.6123724579811096,
        -0.7071067690849304
      ],
      "plane_d": -3640.962158203125,
      "bbox_min": [
        -3613.47265625,
        -4963.00048828125,
        951.70703125
      ],
      "bbox_max": [
        -3610.63720703125,
        -4959.2294921875,
        954.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123685836791992,
        0.35355857014656067,
        0.7071075439453125
      ],
      "plane_d": 3254.59912109375,
      "bbox_min": [
        -3595.88330078125,
        -4949.18701171875,
        964.70703125
      ],
      "bbox_max": [
        -3582.222900390625,
        -4935.52685546875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123723983764648,
        0.35355204343795776,
        -0.7071075439453125
      ],
      "plane_d": 4625.955078125,
      "bbox_min": [
        -3595.88330078125,
        -4949.18701171875,
        964.70703125
      ],
      "bbox_max": [
        -3582.222900390625,
        -4935.52685546875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123723983764648,
        -0.35355204343795776,
        0.7071075439453125
      ],
      "plane_d": -4635.8544921875,
      "bbox_min": [
        -3595.88330078125,
        -4949.18701171875,
        964.70703125
      ],
      "bbox_max": [
        -3582.222900390625,
        -4935.52685546875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123685836791992,
        -0.35355857014656067,
        -0.7071075439453125
      ],
      "plane_d": -3264.49853515625,
      "bbox_min": [
        -3595.88330078125,
        -4949.18701171875,
        964.70703125
      ],
      "bbox_max": [
        -3582.222900390625,
        -4935.52685546875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.6703087314672302e-06,
        4.625064775609644e-06,
        1.0
      ],
      "plane_d": -974.6937866210938,
      "bbox_min": [
        -3595.88330078125,
        -4949.18701171875,
        964.70703125
      ],
      "bbox_max": [
        -3582.222900390625,
        -4935.52685546875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.6703087314672302e-06,
        -4.625064775609644e-06,
        -1.0
      ],
      "plane_d": 964.6937866210938,
      "bbox_min": [
        -3595.88330078125,
        -4949.18701171875,
        964.70703125
      ],
      "bbox_max": [
        -3582.222900390625,
        -4935.52685546875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660235404968262,
        0.5000032186508179,
        -0.0
      ],
      "plane_d": 5574.3984375,
      "bbox_min": [
        -3595.88330078125,
        -4949.18701171875,
        964.7070922851562
      ],
      "bbox_max": [
        -3582.222900390625,
        -4935.52685546875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660235404968262,
        -0.5000032186508179,
        -0.0
      ],
      "plane_d": -5584.39892578125,
      "bbox_min": [
        -3595.88330078125,
        -4949.18701171875,
        964.7070922851562
      ],
      "bbox_max": [
        -3582.222900390625,
        -4940.52685546875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        -0.866025984287262,
        0.0
      ],
      "plane_d": -2490.6865234375,
      "bbox_min": [
        -3590.88330078125,
        -4949.18701171875,
        964.7070922851562
      ],
      "bbox_max": [
        -3582.222900390625,
        -4944.18701171875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4989.00048828125,
      "bbox_min": [
        -3618.054931640625,
        -5067.609375,
        878.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        993.70703125
      ],
      "face_count": 18
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3618.0517578125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        878.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        980.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 908.70703125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        878.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        980.20703125
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4979.00048828125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        980.20703125
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2883.08203125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4979.00048828125,
        980.20703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4165.359375,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4979.00048828125,
        980.20703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2873.182373046875,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4979.00048828125,
        980.20703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4175.2587890625,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        925.7070922851562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -918.70703125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        920.7072143554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -3.2697405458748108e-06
      ],
      "plane_d": 3560.003173828125,
      "bbox_min": [
        -3560.0,
        -4989.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        918.7073974609375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        5.086263172415784e-06
      ],
      "plane_d": -3570.0048828125,
      "bbox_min": [
        -3570.0,
        -4986.00048828125,
        918.70703125
      ],
      "bbox_max": [
        -3570.0,
        -4982.00048828125,
        920.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        5.086263172415784e-06
      ],
      "plane_d": -3570.0048828125,
      "bbox_min": [
        -3570.0,
        -4986.00048828125,
        918.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4984.00048828125,
        922.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -3.2697405458748108e-06
      ],
      "plane_d": 3560.003173828125,
      "bbox_min": [
        -3560.0,
        -4986.00048828125,
        918.7073974609375
      ],
      "bbox_max": [
        -3560.0,
        -4984.0009765625,
        922.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -972.70703125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        915.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4979.00048828125,
        980.20703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2834.99853515625,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        915.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4979.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 962.70703125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        915.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4979.00048828125,
        972.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4203.54296875,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2844.898193359375,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4213.4423828125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 970.20703125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.00048828125,
        972.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4208.84619140625,
      "bbox_min": [
        -3603.054931640625,
        -4988.50048828125,
        970.20703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4979.50048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2839.5947265625,
      "bbox_min": [
        -3603.054931640625,
        -4988.50048828125,
        970.20703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4980.75048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826829493045807,
        0.0,
        0.9238797426223755
      ],
      "plane_d": 458.520751953125,
      "bbox_min": [
        -3603.054931640625,
        -4987.25048828125,
        970.20703125
      ],
      "bbox_max": [
        -3532.0,
        -4980.75048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.281084805727005,
        0.6785988807678223,
        0.6785977482795715
      ],
      "plane_d": 1716.24658203125,
      "bbox_min": [
        -3603.054931640625,
        -4987.25048828125,
        970.20703125
      ],
      "bbox_max": [
        -3540.46435546875,
        -4980.75048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810850441455841,
        0.6785982847213745,
        0.6785982847213745
      ],
      "plane_d": 3717.56787109375,
      "bbox_min": [
        -3583.15576171875,
        -4987.25048828125,
        970.20703125
      ],
      "bbox_max": [
        -3540.46435546875,
        -4980.75048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6863874197006226,
        0.26908883452415466,
        0.6756207942962646
      ],
      "plane_d": -1773.247802734375,
      "bbox_min": [
        -3583.15576171875,
        -4987.25048828125,
        970.20703125
      ],
      "bbox_max": [
        -3580.217529296875,
        -4983.01513671875,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6822128295898438,
        0.26300427317619324,
        0.6822128295898438
      ],
      "plane_d": -1795.044189453125,
      "bbox_min": [
        -3581.88671875,
        -4986.8662109375,
        971.8411254882812
      ],
      "bbox_max": [
        -3580.217529296875,
        -4984.783203125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3603.054931640625,
      "bbox_min": [
        -3603.054931640625,
        -4987.25048828125,
        970.20703125
      ],
      "bbox_max": [
        -3603.054931640625,
        -4980.75048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28108450770378113,
        0.6785973906517029,
        -0.6785993576049805
      ],
      "plane_d": 3046.364013671875,
      "bbox_min": [
        -3542.600341796875,
        -4987.25048828125,
        970.20703125
      ],
      "bbox_max": [
        -3532.0,
        -4980.75048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785982251167297,
        0.28108522295951843,
        -0.6785982251167297
      ],
      "plane_d": -342.43408203125,
      "bbox_min": [
        -3542.600341796875,
        -4987.25048828125,
        970.20703125
      ],
      "bbox_max": [
        -3539.778076171875,
        -4983.45458984375,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28108423948287964,
        -0.6785984039306641,
        0.6785984039306641
      ],
      "plane_d": -3046.7041015625,
      "bbox_min": [
        -3603.054931640625,
        -4988.50048828125,
        970.20703125
      ],
      "bbox_max": [
        -3532.0,
        -4986.00048828125,
        971.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785984635353088,
        -0.28108394145965576,
        -0.6785984635353088
      ],
      "plane_d": 1656.48876953125,
      "bbox_min": [
        -3537.135986328125,
        -4988.50048828125,
        970.20703125
      ],
      "bbox_max": [
        -3536.763427734375,
        -4988.05078125,
        970.4703369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.281084805727005,
        0.6785988807678223,
        0.6785977482795715
      ],
      "plane_d": 1716.24658203125,
      "bbox_min": [
        -3603.054931640625,
        -4982.00048828125,
        970.20703125
      ],
      "bbox_max": [
        -3540.46435546875,
        -4979.50048828125,
        971.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810850441455841,
        0.6785982847213745,
        0.6785982847213745
      ],
      "plane_d": 3717.56787109375,
      "bbox_min": [
        -3546.5,
        -4982.00048828125,
        970.20703125
      ],
      "bbox_max": [
        -3540.46435546875,
        -4979.50048828125,
        971.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3603.054931640625,
      "bbox_min": [
        -3603.054931640625,
        -4982.00048828125,
        970.20703125
      ],
      "bbox_max": [
        -3603.054931640625,
        -4979.50048828125,
        971.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.281084805727005,
        0.6785988807678223,
        0.6785977482795715
      ],
      "plane_d": 1716.24658203125,
      "bbox_min": [
        -3584.823974609375,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3535.328369140625,
        -4979.00048828125,
        970.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238799214363098,
        0.0,
        0.38268253207206726
      ],
      "plane_d": 2897.8076171875,
      "bbox_min": [
        -3584.823974609375,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3535.328369140625,
        -4979.00048828125,
        970.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9310113191604614,
        0.36499032378196716,
        0.0
      ],
      "plane_d": -1516.5748291015625,
      "bbox_min": [
        -3584.823974609375,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3535.328369140625,
        -4979.00048828125,
        970.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28108423948287964,
        -0.6785984039306641,
        0.6785984039306641
      ],
      "plane_d": -3046.7041015625,
      "bbox_min": [
        -3584.823974609375,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3535.328369140625,
        -4979.00048828125,
        970.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810850441455841,
        0.6785982847213745,
        0.6785982847213745
      ],
      "plane_d": 3717.56787109375,
      "bbox_min": [
        -3584.823974609375,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3535.328369140625,
        -4979.00048828125,
        970.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785959005355835,
        0.6786007881164551,
        0.2810845673084259
      ],
      "plane_d": 5509.2470703125,
      "bbox_min": [
        -3584.823974609375,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3535.328369140625,
        -4979.00048828125,
        970.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785967946052551,
        -0.6786004900932312,
        0.28108322620391846
      ],
      "plane_d": -1255.04052734375,
      "bbox_min": [
        -3584.823974609375,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3535.328369140625,
        -4982.00048828125,
        970.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6863874197006226,
        0.26908889412879944,
        -0.6756207942962646
      ],
      "plane_d": -465.6416015625,
      "bbox_min": [
        -3584.823974609375,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3538.0146484375,
        -4982.00048828125,
        970.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6863874197006226,
        0.26908883452415466,
        0.6756207942962646
      ],
      "plane_d": -1773.247802734375,
      "bbox_min": [
        -3584.823974609375,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3538.0146484375,
        -4982.00048828125,
        970.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6822128295898438,
        0.26300427317619324,
        -0.6822128295898438
      ],
      "plane_d": -474.6800537109375,
      "bbox_min": [
        -3581.886962890625,
        -4986.86669921875,
        962.70703125
      ],
      "bbox_max": [
        -3580.217529296875,
        -4984.783203125,
        963.5730590820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4204.95703125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        964.70703125
      ],
      "bbox_max": [
        -3603.054931640625,
        -4979.00048828125,
        970.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2843.48388671875,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        964.70703125
      ],
      "bbox_max": [
        -3603.054931640625,
        -4979.00048828125,
        970.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 964.70703125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        964.70703125
      ],
      "bbox_max": [
        -3603.054931640625,
        -4979.00048828125,
        970.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3603.054931640625,
      "bbox_min": [
        -3603.054931640625,
        -4989.00048828125,
        964.70703125
      ],
      "bbox_max": [
        -3603.054931640625,
        -4979.00048828125,
        970.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2839.5947265625,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        969.7066650390625
      ],
      "bbox_max": [
        -3511.80517578125,
        -4986.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4214.85693359375,
      "bbox_min": [
        -3618.054931640625,
        -4988.50048828125,
        971.4569091796875
      ],
      "bbox_max": [
        -3541.8681640625,
        -4986.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810835838317871,
        -0.6785980463027954,
        0.6785991191864014
      ],
      "plane_d": -3039.1162109375,
      "bbox_min": [
        -3603.054931640625,
        -4988.2509765625,
        971.4569091796875
      ],
      "bbox_max": [
        -3541.8681640625,
        -4986.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6822128295898438,
        0.26300427317619324,
        0.6822128295898438
      ],
      "plane_d": -1795.044189453125,
      "bbox_min": [
        -3603.054931640625,
        -4988.2509765625,
        971.4569091796875
      ],
      "bbox_max": [
        -3580.686767578125,
        -4986.00048828125,
        972.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6951999068260193,
        -0.25515511631965637,
        0.6720066666603088
      ],
      "plane_d": 560.72021484375,
      "bbox_min": [
        -3577.5322265625,
        -4988.25048828125,
        972.1860961914062
      ],
      "bbox_max": [
        -3577.020751953125,
        -4987.611328125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6822128295898438,
        0.26300427317619324,
        0.6822128295898438
      ],
      "plane_d": -1795.044189453125,
      "bbox_min": [
        -3581.80419921875,
        -4988.50048828125,
        972.457275390625
      ],
      "bbox_max": [
        -3581.4580078125,
        -4988.0009765625,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4214.85693359375,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        969.7066650390625
      ],
      "bbox_max": [
        -3532.0,
        -4987.25048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810835838317871,
        -0.6785980463027954,
        0.6785991191864014
      ],
      "plane_d": -3039.1162109375,
      "bbox_min": [
        -3603.054931640625,
        -4989.00048828125,
        969.7066650390625
      ],
      "bbox_max": [
        -3532.0,
        -4987.25048828125,
        972.4573974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6822128295898438,
        0.26300427317619324,
        0.6822128295898438
      ],
      "plane_d": -1795.044189453125,
      "bbox_min": [
        -3583.596435546875,
        -4989.00048828125,
        970.9540405273438
      ],
      "bbox_max": [
        -3581.80419921875,
        -4987.4091796875,
        972.457275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3603.054931640625,
      "bbox_min": [
        -3603.054931640625,
        -4989.00048828125,
        969.7066650390625
      ],
      "bbox_max": [
        -3603.054931640625,
        -4987.25048828125,
        972.4570922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810846269130707,
        -0.6785991787910461,
        -0.6785975694656372
      ],
      "plane_d": -1732.324951171875,
      "bbox_min": [
        -3577.382568359375,
        -4989.00048828125,
        970.20703125
      ],
      "bbox_max": [
        -3532.0,
        -4987.25048828125,
        972.4573974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785982251167297,
        0.28108522295951843,
        -0.6785982251167297
      ],
      "plane_d": -342.43408203125,
      "bbox_min": [
        -3577.382568359375,
        -4989.00048828125,
        970.20703125
      ],
      "bbox_max": [
        -3541.135986328125,
        -4987.25048828125,
        972.4573974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6951999068260193,
        -0.25515511631965637,
        0.6720066666603088
      ],
      "plane_d": 560.72021484375,
      "bbox_min": [
        -3577.382568359375,
        -4989.00048828125,
        970.74267578125
      ],
      "bbox_max": [
        -3576.000244140625,
        -4987.9794921875,
        972.457275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785984635353088,
        -0.28108394145965576,
        -0.6785984635353088
      ],
      "plane_d": 1656.48876953125,
      "bbox_min": [
        -3537.343017578125,
        -4989.00048828125,
        970.20703125
      ],
      "bbox_max": [
        -3536.0,
        -4988.23681640625,
        971.55029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810846269130707,
        -0.6785991787910461,
        -0.6785975694656372
      ],
      "plane_d": -1732.324951171875,
      "bbox_min": [
        -3582.84326171875,
        -4989.00048828125,
        971.70703125
      ],
      "bbox_max": [
        -3532.0,
        -4988.25048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6951999068260193,
        -0.25515511631965637,
        0.6720066666603088
      ],
      "plane_d": 560.72021484375,
      "bbox_min": [
        -3582.84326171875,
        -4989.00048828125,
        971.707275390625
      ],
      "bbox_max": [
        -3542.84326171875,
        -4988.25048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6822128295898438,
        0.26300427317619324,
        0.6822128295898438
      ],
      "plane_d": -1795.044189453125,
      "bbox_min": [
        -3582.84326171875,
        -4989.00048828125,
        971.707275390625
      ],
      "bbox_max": [
        -3581.650634765625,
        -4988.2509765625,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785982251167297,
        0.28108522295951843,
        -0.6785982251167297
      ],
      "plane_d": -342.43408203125,
      "bbox_min": [
        -3543.843017578125,
        -4989.00048828125,
        971.7073364257812
      ],
      "bbox_max": [
        -3542.84326171875,
        -4988.2509765625,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785967946052551,
        -0.6786004900932312,
        0.28108322620391846
      ],
      "plane_d": -1255.04052734375,
      "bbox_min": [
        -3584.823974609375,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3535.328369140625,
        -4986.00048828125,
        965.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810850143432617,
        -0.6785970330238342,
        -0.67859947681427
      ],
      "plane_d": -1725.7353515625,
      "bbox_min": [
        -3584.823974609375,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3542.328369140625,
        -4986.00048828125,
        965.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6863874197006226,
        0.26908889412879944,
        -0.6756207942962646
      ],
      "plane_d": -465.6416015625,
      "bbox_min": [
        -3584.823974609375,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3580.686767578125,
        -4986.00048828125,
        965.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6822128295898438,
        0.26300427317619324,
        -0.6822128295898438
      ],
      "plane_d": -474.6800537109375,
      "bbox_min": [
        -3583.596435546875,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3580.686767578125,
        -4986.00048828125,
        964.4600219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.281084805727005,
        -0.6785982847213745,
        -0.6785982847213745
      ],
      "plane_d": -3727.0673828125,
      "bbox_min": [
        -3577.89892578125,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3542.328369140625,
        -4986.00048828125,
        965.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6951999664306641,
        -0.25515511631965637,
        -0.6720066070556641
      ],
      "plane_d": 1861.33154296875,
      "bbox_min": [
        -3577.89892578125,
        -4989.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3576.000244140625,
        -4987.611328125,
        964.67138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785959005355835,
        0.6786007881164551,
        0.2810845673084259
      ],
      "plane_d": 5509.2470703125,
      "bbox_min": [
        -3546.5,
        -4982.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3535.328369140625,
        -4979.00048828125,
        965.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810836732387543,
        0.6785985231399536,
        -0.6785985231399536
      ],
      "plane_d": 3037.20654296875,
      "bbox_min": [
        -3546.5,
        -4982.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3542.328369140625,
        -4979.00048828125,
        965.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786001324653625,
        0.6785966753959656,
        -0.2810843586921692
      ],
      "plane_d": 1245.510498046875,
      "bbox_min": [
        -3544.5,
        -4981.171875,
        962.70703125
      ],
      "bbox_max": [
        -3542.328369140625,
        -4979.00048828125,
        964.2425537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -3.2697405458748108e-06
      ],
      "plane_d": 3560.003173828125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        915.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071083188056946,
        0.7071052193641663,
        -3.0827477530692704e-06
      ],
      "plane_d": 6040.107421875,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        915.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        5.086263172415784e-06
      ],
      "plane_d": -3570.0048828125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        915.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        948.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071052193641663,
        -0.7071083188056946,
        3.0827343380224193e-06
      ],
      "plane_d": -6050.0107421875,
      "bbox_min": [
        -3570.0,
        -4989.00048828125,
        922.7069702148438
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        947.8787231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        -3.5965310871688416e-06
      ],
      "plane_d": -1008.331298828125,
      "bbox_min": [
        -3570.0,
        -4989.00048828125,
        922.7069702148438
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        947.8787231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9238830208778381,
        0.38267502188682556
      ],
      "plane_d": -4967.70751953125,
      "bbox_min": [
        -3570.0,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        947.8787231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785997152328491,
        -0.6785997152328491,
        0.28107795119285583
      ],
      "plane_d": -1230.97119140625,
      "bbox_min": [
        -3570.0,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        947.8787231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786002516746521,
        -0.6786002516746521,
        0.28107550740242004
      ],
      "plane_d": -6069.3896484375,
      "bbox_min": [
        -3570.0,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        947.8787231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3826836347579956,
        0.9238794445991516
      ],
      "plane_d": -2781.107666015625,
      "bbox_min": [
        -3570.0,
        -4985.48583984375,
        943.071044921875
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        947.8787231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785976886749268,
        -0.2810850143432617,
        0.6785988211631775
      ],
      "plane_d": 375.091796875,
      "bbox_min": [
        -3570.0,
        -4985.48583984375,
        943.071044921875
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        947.8787231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.678597629070282,
        -0.2810845971107483,
        0.6785991191864014
      ],
      "plane_d": -4463.3076171875,
      "bbox_min": [
        -3570.0,
        -4985.48583984375,
        943.071044921875
      ],
      "bbox_max": [
        -3567.0,
        -4979.00048828125,
        947.8787231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.678597629070282,
        -0.2810845971107483,
        0.6785991191864014
      ],
      "plane_d": -4463.3076171875,
      "bbox_min": [
        -3570.0,
        -4982.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3567.0,
        -4979.00048828125,
        947.8787231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785988211631775,
        0.28108540177345276,
        -0.6785975098609924
      ],
      "plane_d": -384.595458984375,
      "bbox_min": [
        -3570.0,
        -4980.5361328125,
        938.7072143554688
      ],
      "bbox_max": [
        -3567.82861328125,
        -4979.00048828125,
        940.8787231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2851.968994140625,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3593.0,
        -4979.00048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4196.4716796875,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3593.0,
        -4979.00048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -948.70703125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3593.0,
        -4979.00048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826829493045807,
        -0.0,
        0.9238797426223755
      ],
      "plane_d": 503.080810546875,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3593.0,
        -4979.00048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238799214363098,
        -0.0,
        0.38268253207206726
      ],
      "plane_d": 2961.0390625,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3593.0,
        -4979.00048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.281083881855011,
        0.67859947681427,
        0.6785975098609924
      ],
      "plane_d": 3750.300048828125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3593.0,
        -4979.00048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810845673084259,
        -0.6785996556282043,
        0.678597092628479
      ],
      "plane_d": -3013.978271484375,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3593.0,
        -4979.00048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785985231399536,
        0.6785985231399536,
        0.2810839116573334
      ],
      "plane_d": 5555.689453125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3593.0,
        -4979.00048828125,
        945.1923217773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.678598165512085,
        -0.678598165512085,
        0.2810854911804199
      ],
      "plane_d": -1208.582275390625,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3593.0,
        -4979.00048828125,
        945.1923217773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 936.70703125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3593.0,
        -4979.00048828125,
        941.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4186.572265625,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3600.0,
        -4979.00048828125,
        941.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2861.86865234375,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3600.0,
        -4982.00048828125,
        941.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 938.70703125,
      "bbox_min": [
        -3618.054931640625,
        -4986.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3603.0,
        -4982.00048828125,
        938.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826822340488434,
        -0.0,
        -0.9238800406455994
      ],
      "plane_d": -512.3167114257812,
      "bbox_min": [
        -3605.0,
        -4986.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3603.0,
        -4982.00048828125,
        938.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28108397126197815,
        -0.6785978078842163,
        -0.6785991787910461
      ],
      "plane_d": -3759.791015625,
      "bbox_min": [
        -3605.0,
        -4989.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3600.0,
        -4984.0,
        941.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238800406455994,
        -0.0,
        -0.3826822340488434
      ],
      "plane_d": -2970.278564453125,
      "bbox_min": [
        -3605.0,
        -4986.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3603.0,
        -4984.0,
        938.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238800406455994,
        -0.0,
        -0.3826822340488434
      ],
      "plane_d": -2970.278564453125,
      "bbox_min": [
        -3603.585693359375,
        -4986.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3603.0,
        -4984.8291015625,
        938.1212158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238800406455994,
        -0.0,
        -0.3826822340488434
      ],
      "plane_d": -2970.278564453125,
      "bbox_min": [
        -3605.0,
        -4984.0,
        936.70703125
      ],
      "bbox_max": [
        -3603.0,
        -4982.00048828125,
        938.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238800406455994,
        -0.0,
        -0.3826822340488434
      ],
      "plane_d": -2970.278564453125,
      "bbox_min": [
        -3603.585693359375,
        -4983.17236328125,
        936.70703125
      ],
      "bbox_max": [
        -3603.0,
        -4982.00048828125,
        938.1212158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785951852798462,
        0.6786072850227356,
        -0.2810707092285156
      ],
      "plane_d": 6059.9013671875,
      "bbox_min": [
        -3563.0,
        -4982.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        940.8787231445312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6785986423492432,
        0.28108450770378113,
        -0.6785981059074402
      ],
      "plane_d": 4453.8095703125,
      "bbox_min": [
        -3562.17138671875,
        -4980.5361328125,
        938.7072143554688
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        940.8787231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2859.040283203125,
      "bbox_min": [
        -3546.5,
        -4989.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4189.40087890625,
      "bbox_min": [
        -3546.5,
        -4989.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 942.70703125,
      "bbox_min": [
        -3546.5,
        -4989.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238799214363098,
        0.0,
        -0.3826824724674225
      ],
      "plane_d": -2908.577392578125,
      "bbox_min": [
        -3546.5,
        -4989.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268283009529114,
        0.0,
        -0.9238798022270203
      ],
      "plane_d": -480.11370849609375,
      "bbox_min": [
        -3546.5,
        -4989.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4199.30029296875,
      "bbox_min": [
        -3546.5,
        -4989.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2849.140869140625,
      "bbox_min": [
        -3544.5,
        -4989.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4979.00048828125,
        959.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -952.70703125,
      "bbox_min": [
        -3542.843017578125,
        -4989.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4979.00048828125,
        954.7067260742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810837924480438,
        0.6785994172096252,
        -0.678597629070282
      ],
      "plane_d": 3028.13525390625,
      "bbox_min": [
        -3542.843017578125,
        -4989.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3530.5,
        -4979.00048828125,
        952.706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810843586921692,
        -0.6785995960235596,
        -0.6785972118377686
      ],
      "plane_d": -3736.147705078125,
      "bbox_min": [
        -3542.843017578125,
        -4989.00048828125,
        942.70703125
      ],
      "bbox_max": [
        -3530.5,
        -4979.00048828125,
        952.706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785982251167297,
        -0.6785982251167297,
        -0.28108519315719604
      ],
      "plane_d": -5519.8662109375,
      "bbox_min": [
        -3542.843017578125,
        -4989.00048828125,
        946.8075561523438
      ],
      "bbox_max": [
        -3538.278076171875,
        -4979.00048828125,
        952.706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785985231399536,
        0.6785985231399536,
        -0.281083881855011
      ],
      "plane_d": 1244.400634765625,
      "bbox_min": [
        -3542.8427734375,
        -4982.00048828125,
        946.8075561523438
      ],
      "bbox_max": [
        -3538.278076171875,
        -4979.00048828125,
        952.7064208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826822340488434,
        0.0,
        0.9238800406455994
      ],
      "plane_d": 470.87255859375,
      "bbox_min": [
        -3533.67138671875,
        -4986.00048828125,
        952.70703125
      ],
      "bbox_max": [
        -3530.5,
        -4982.00048828125,
        954.7067260742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785985231399536,
        0.6785985231399536,
        -0.281083881855011
      ],
      "plane_d": 1244.400634765625,
      "bbox_min": [
        -3544.5,
        -4984.00048828125,
        949.7067260742188
      ],
      "bbox_max": [
        -3530.5,
        -4979.00048828125,
        959.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1016.46630859375,
      "bbox_min": [
        -3544.5,
        -4984.00048828125,
        949.70703125
      ],
      "bbox_max": [
        -3530.5,
        -4979.00048828125,
        959.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238800406455994,
        0.0,
        0.3826822340488434
      ],
      "plane_d": 2899.33935546875,
      "bbox_min": [
        -3534.5,
        -4984.00048828125,
        953.4880981445312
      ],
      "bbox_max": [
        -3532.385498046875,
        -4982.00048828125,
        956.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826822340488434,
        0.0,
        0.9238800406455994
      ],
      "plane_d": 470.87255859375,
      "bbox_min": [
        -3533.328369140625,
        -4983.17236328125,
        953.4880981445312
      ],
      "bbox_max": [
        -3532.385498046875,
        -4982.00048828125,
        953.8786010742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810857892036438,
        0.6785972118377686,
        0.6785989999771118
      ],
      "plane_d": 3726.63916015625,
      "bbox_min": [
        -3537.5,
        -4982.78173828125,
        949.70703125
      ],
      "bbox_max": [
        -3530.5,
        -4979.00048828125,
        959.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826822340488434,
        0.0,
        0.9238800406455994
      ],
      "plane_d": 470.87255859375,
      "bbox_min": [
        -3533.328369140625,
        -4982.78173828125,
        952.70703125
      ],
      "bbox_max": [
        -3530.5,
        -4982.00048828125,
        953.8786010742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 6022.0751953125,
      "bbox_min": [
        -3537.5,
        -4982.00048828125,
        956.70703125
      ],
      "bbox_max": [
        -3534.5,
        -4979.00048828125,
        959.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 6022.0751953125,
      "bbox_min": [
        -3546.5,
        -4989.00048828125,
        949.70703125
      ],
      "bbox_max": [
        -3530.5,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1026.365966796875,
      "bbox_min": [
        -3546.5,
        -4989.00048828125,
        949.70703125
      ],
      "bbox_max": [
        -3530.5,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3534.5,
      "bbox_min": [
        -3546.5,
        -4989.00048828125,
        953.8786010742188
      ],
      "bbox_max": [
        -3533.328369140625,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785967946052551,
        -0.6786004900932312,
        0.28108322620391846
      ],
      "plane_d": -1255.04052734375,
      "bbox_min": [
        -3546.5,
        -4989.00048828125,
        956.70703125
      ],
      "bbox_max": [
        -3534.5,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238799214363098,
        0.0,
        0.38268253207206726
      ],
      "plane_d": 2897.8076171875,
      "bbox_min": [
        -3546.5,
        -4989.00048828125,
        956.70703125
      ],
      "bbox_max": [
        -3534.5,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -6031.974609375,
      "bbox_min": [
        -3546.5,
        -4989.00048828125,
        956.70703125
      ],
      "bbox_max": [
        -3541.5,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3544.5,
      "bbox_min": [
        -3546.5,
        -4986.00048828125,
        956.70703125
      ],
      "bbox_max": [
        -3541.5,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1016.46630859375,
      "bbox_min": [
        -3544.5,
        -4982.00048828125,
        956.70703125
      ],
      "bbox_max": [
        -3541.5,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786001324653625,
        0.6785966753959656,
        -0.2810843586921692
      ],
      "plane_d": 1245.510498046875,
      "bbox_min": [
        -3544.5,
        -4982.00048828125,
        960.70703125
      ],
      "bbox_max": [
        -3541.5,
        -4979.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238800406455994,
        0.0,
        -0.3826822340488434
      ],
      "plane_d": -2907.047119140625,
      "bbox_min": [
        -3546.5,
        -4986.00048828125,
        960.70703125
      ],
      "bbox_max": [
        -3544.5,
        -4981.171875,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786001324653625,
        0.6785966753959656,
        -0.2810843586921692
      ],
      "plane_d": 1245.510498046875,
      "bbox_min": [
        -3545.328125,
        -4982.00048828125,
        960.70703125
      ],
      "bbox_max": [
        -3544.5,
        -4981.171875,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810836732387543,
        0.6785985231399536,
        -0.6785985231399536
      ],
      "plane_d": 3037.20654296875,
      "bbox_min": [
        -3545.328125,
        -4982.00048828125,
        962.1212158203125
      ],
      "bbox_max": [
        -3544.5,
        -4981.171875,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826822340488434,
        0.0,
        -0.9238800406455994
      ],
      "plane_d": -467.7567138671875,
      "bbox_min": [
        -3546.5,
        -4985.4150390625,
        962.1212158203125
      ],
      "bbox_max": [
        -3545.085693359375,
        -4981.51513671875,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810836732387543,
        0.6785985231399536,
        -0.6785985231399536
      ],
      "plane_d": 3037.20654296875,
      "bbox_min": [
        -3546.5,
        -4982.00048828125,
        962.1212158203125
      ],
      "bbox_max": [
        -3545.085693359375,
        -4981.51513671875,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826822340488434,
        0.0,
        -0.9238800406455994
      ],
      "plane_d": -467.7567138671875,
      "bbox_min": [
        -3546.5,
        -4986.00048828125,
        962.1212158203125
      ],
      "bbox_max": [
        -3545.085693359375,
        -4984.82861328125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238800406455994,
        0.0,
        0.3826822340488434
      ],
      "plane_d": 2899.33935546875,
      "bbox_min": [
        -3534.5,
        -4986.00048828125,
        953.4879760742188
      ],
      "bbox_max": [
        -3532.38525390625,
        -4984.82861328125,
        956.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826822340488434,
        0.0,
        0.9238800406455994
      ],
      "plane_d": 470.87255859375,
      "bbox_min": [
        -3533.328369140625,
        -4986.00048828125,
        953.4879760742188
      ],
      "bbox_max": [
        -3532.38525390625,
        -4984.82861328125,
        953.8786010742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810842990875244,
        -0.6785968542098999,
        0.678600013256073
      ],
      "plane_d": -3037.623046875,
      "bbox_min": [
        -3535.44970703125,
        -4989.00048828125,
        949.70703125
      ],
      "bbox_max": [
        -3530.5,
        -4985.21923828125,
        953.8786010742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826822340488434,
        0.0,
        0.9238800406455994
      ],
      "plane_d": 470.87255859375,
      "bbox_min": [
        -3533.328369140625,
        -4986.00048828125,
        952.70703125
      ],
      "bbox_max": [
        -3530.5,
        -4985.21923828125,
        953.8786010742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3603.054931640625,
      "bbox_min": [
        -3603.054931640625,
        -4982.00048828125,
        971.4570922851562
      ],
      "bbox_max": [
        -3603.054931640625,
        -4980.25048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3603.054931640625,
      "bbox_min": [
        -3603.054931640625,
        -4980.75048828125,
        969.7072143554688
      ],
      "bbox_max": [
        -3603.054931640625,
        -4979.00048828125,
        971.95703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4218.74560546875,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        972.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4981.00048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2839.5947265625,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        972.70703125
      ],
      "bbox_max": [
        -3511.80517578125,
        -4981.00048828125,
        978.9568481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -974.70703125,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        972.70703125
      ],
      "bbox_max": [
        -3535.620849609375,
        -4981.00048828125,
        978.9568481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4214.85693359375,
      "bbox_min": [
        -3618.054931640625,
        -4989.00048828125,
        972.70703125
      ],
      "bbox_max": [
        -3535.620849609375,
        -4981.00048828125,
        974.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268306851387024,
        0.9238796830177307,
        0.0
      ],
      "plane_d": 3248.36083984375,
      "bbox_min": [
        -3541.8994140625,
        -4983.10107421875,
        973.20703125
      ],
      "bbox_max": [
        -3538.034912109375,
        -4981.50048828125,
        974.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923879861831665,
        0.38268256187438965,
        0.0
      ],
      "plane_d": -1365.3436279296875,
      "bbox_min": [
        -3544.343017578125,
        -4989.00048828125,
        972.70703125
      ],
      "bbox_max": [
        -3543.1005859375,
        -4986.00048828125,
        974.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785982251167297,
        0.28108522295951843,
        -0.6785982251167297
      ],
      "plane_d": -342.43408203125,
      "bbox_min": [
        -3544.343017578125,
        -4989.00048828125,
        972.70703125
      ],
      "bbox_max": [
        -3543.42919921875,
        -4987.5009765625,
        973.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923879861831665,
        0.38268256187438965,
        0.0
      ],
      "plane_d": -1365.3436279296875,
      "bbox_min": [
        -3544.343017578125,
        -4989.00048828125,
        974.70703125
      ],
      "bbox_max": [
        -3541.65673828125,
        -4983.00048828125,
        978.9568481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785982251167297,
        0.28108522295951843,
        -0.6785982251167297
      ],
      "plane_d": -342.43408203125,
      "bbox_min": [
        -3544.343017578125,
        -4989.00048828125,
        972.70703125
      ],
      "bbox_max": [
        -3543.635986328125,
        -4988.50048828125,
        973.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28108537197113037,
        -0.6785986423492432,
        0.6785977482795715
      ],
      "plane_d": -3055.865966796875,
      "bbox_min": [
        -3537.343017578125,
        -4989.00048828125,
        977.20703125
      ],
      "bbox_max": [
        -3532.0,
        -4987.25048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785981059074402,
        -0.28108593821525574,
        0.6785981059074402
      ],
      "plane_d": 332.9296875,
      "bbox_min": [
        -3537.343017578125,
        -4989.00048828125,
        978.8639526367188
      ],
      "bbox_max": [
        -3536.0,
        -4988.2373046875,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 998.435302734375,
      "bbox_min": [
        -3570.0,
        -4982.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        911.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071175575256348,
        0.7070959806442261,
        2.157951530534774e-05
      ],
      "plane_d": 6040.0712890625,
      "bbox_min": [
        -3563.0,
        -4982.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4979.00048828125,
        911.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071175575256348,
        -0.7070959806442261,
        2.157951530534774e-05
      ],
      "plane_d": -1008.26171875,
      "bbox_min": [
        -3570.0,
        -4989.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4986.00048828125,
        911.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -6050.005859375,
      "bbox_min": [
        -3570.0,
        -4989.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3567.0,
        -4986.00048828125,
        911.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660262823104858,
        -0.4999984800815582,
        0.0
      ],
      "plane_d": 648.45263671875,
      "bbox_min": [
        -3618.0517578125,
        -4979.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        961.4722290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002980232239,
        -0.8660252094268799,
        0.0
      ],
      "plane_d": -2480.6796875,
      "bbox_min": [
        -3611.441162109375,
        -4979.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        961.4722290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.785788522947531e-12,
        -1.984843493119115e-06,
        -1.0
      ],
      "plane_d": 938.697265625,
      "bbox_min": [
        -3611.441162109375,
        -4979.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        961.4722290039062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3183.1875,
      "bbox_min": [
        -3611.441162109375,
        -4979.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4947.00048828125,
        961.4722290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -2.8069925974705257e-06,
        -0.7071067690849304
      ],
      "plane_d": -1858.49755859375,
      "bbox_min": [
        -3611.441162109375,
        -4979.00048828125,
        938.7070922851562
      ],
      "bbox_max": [
        -3560.0,
        -4947.00048828125,
        958.5340576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.984843038371764e-06,
        -0.0
      ],
      "plane_d": 3560.009765625,
      "bbox_min": [
        -3570.0,
        -4979.00048828125,
        941.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4950.00048828125,
        948.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -1.984843493119115e-06,
        -0.0
      ],
      "plane_d": -3570.009765625,
      "bbox_min": [
        -3570.0,
        -4979.00048828125,
        941.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4950.00048828125,
        948.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        2.8069919153494993e-06,
        0.7071067690849304
      ],
      "plane_d": 1848.59814453125,
      "bbox_min": [
        -3570.0,
        -4979.00048828125,
        944.8787231445312
      ],
      "bbox_max": [
        -3560.0,
        -4954.00048828125,
        948.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -3193.0869140625,
      "bbox_min": [
        -3570.0,
        -4979.00048828125,
        944.8787231445312
      ],
      "bbox_max": [
        -3560.0,
        -4954.00048828125,
        948.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.785787655585793e-12,
        1.984843038371764e-06,
        1.0
      ],
      "plane_d": -948.697265625,
      "bbox_min": [
        -3570.0,
        -4979.00048828125,
        944.8787231445312
      ],
      "bbox_max": [
        -3560.0,
        -4957.00048828125,
        948.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785976886749268,
        -0.2810850143432617,
        0.6785988211631775
      ],
      "plane_d": 375.091796875,
      "bbox_min": [
        -3570.0,
        -4979.00048828125,
        944.8787231445312
      ],
      "bbox_max": [
        -3560.0,
        -4977.00048828125,
        948.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.678597629070282,
        -0.2810845971107483,
        0.6785991191864014
      ],
      "plane_d": -4463.3076171875,
      "bbox_min": [
        -3570.0,
        -4979.00048828125,
        944.8787231445312
      ],
      "bbox_max": [
        -3563.0,
        -4977.00048828125,
        948.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3826836347579956,
        0.9238794445991516
      ],
      "plane_d": -2781.107666015625,
      "bbox_min": [
        -3567.0,
        -4979.00048828125,
        947.8787231445312
      ],
      "bbox_max": [
        -3563.0,
        -4977.00048828125,
        948.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3535533845424652,
        -0.6123724579811096,
        -0.7071067690849304
      ],
      "plane_d": -3640.962158203125,
      "bbox_min": [
        -3611.441162109375,
        -4979.00048828125,
        938.7071533203125
      ],
      "bbox_max": [
        -3567.0,
        -4960.00048828125,
        958.5340576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 951.70703125,
      "bbox_min": [
        -3611.441162109375,
        -4966.82763671875,
        951.70703125
      ],
      "bbox_max": [
        -3601.107177734375,
        -4960.00048828125,
        958.5340576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999999701976776,
        -0.8660253882408142,
        -0.0
      ],
      "plane_d": -6103.80517578125,
      "bbox_min": [
        -3611.441162109375,
        -4966.82763671875,
        951.70703125
      ],
      "bbox_max": [
        -3601.107177734375,
        -4960.00048828125,
        958.5340576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        -0.5000000596046448,
        0.0
      ],
      "plane_d": 638.44482421875,
      "bbox_min": [
        -3604.812255859375,
        -4966.82763671875,
        951.70703125
      ],
      "bbox_max": [
        -3601.107177734375,
        -4960.00048828125,
        958.5340576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3535533845424652,
        0.6123724579811096,
        -0.7071067690849304
      ],
      "plane_d": 4984.05078125,
      "bbox_min": [
        -3602.637451171875,
        -4960.765625,
        951.70703125
      ],
      "bbox_max": [
        -3601.107177734375,
        -4960.00048828125,
        952.1170654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785988211631775,
        0.28108540177345276,
        -0.6785975098609924
      ],
      "plane_d": -384.595458984375,
      "bbox_min": [
        -3570.0,
        -4979.00048828125,
        938.7071533203125
      ],
      "bbox_max": [
        -3567.0,
        -4977.00048828125,
        941.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3570.0,
      "bbox_min": [
        -3570.0,
        -4979.00048828125,
        940.8787231445312
      ],
      "bbox_max": [
        -3570.0,
        -4977.00048828125,
        941.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866025447845459,
        -0.4999999403953552,
        -0.0
      ],
      "plane_d": -5526.1904296875,
      "bbox_min": [
        -3563.0,
        -4979.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4952.13720703125,
        961.4722290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000007152557373,
        -0.8660249710083008,
        0.0
      ],
      "plane_d": -2538.73046875,
      "bbox_min": [
        -3563.0,
        -4979.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3516.45751953125,
        -4953.04638671875,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.607248792533937e-07,
        3.814703006810305e-07,
        1.0
      ],
      "plane_d": -948.7028198242188,
      "bbox_min": [
        -3563.0,
        -4979.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3517.95751953125,
        -4953.04638671875,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35355323553085327,
        0.612372100353241,
        0.7071071267127991
      ],
      "plane_d": 1119.368408203125,
      "bbox_min": [
        -3563.0,
        -4979.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3518.291748046875,
        -4953.04638671875,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35355344414711,
        -0.6123724579811096,
        -0.7071067690849304
      ],
      "plane_d": -1129.269287109375,
      "bbox_min": [
        -3563.0,
        -4979.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3518.291748046875,
        -4953.04638671875,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000007152557373,
        0.8660249710083008,
        0.0
      ],
      "plane_d": 2528.73046875,
      "bbox_min": [
        -3563.0,
        -4979.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3521.45751953125,
        -4953.04638671875,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3535541892051697,
        0.612371563911438,
        -0.7071071267127991
      ],
      "plane_d": 2453.96630859375,
      "bbox_min": [
        -3562.98974609375,
        -4979.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3523.302978515625,
        -4954.11181640625,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        -0.5000000596046448,
        -0.0
      ],
      "plane_d": -5546.19482421875,
      "bbox_min": [
        -3561.5849609375,
        -4979.00048828125,
        938.70703125
      ],
      "bbox_max": [
        -3533.77783203125,
        -4963.04638671875,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785986423492432,
        0.28108450770378113,
        -0.6785981059074402
      ],
      "plane_d": 4453.8095703125,
      "bbox_min": [
        -3561.5849609375,
        -4979.00048828125,
        939.293701171875
      ],
      "bbox_max": [
        -3560.0,
        -4977.00048828125,
        941.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3560.0,
      "bbox_min": [
        -3560.0,
        -4979.00048828125,
        940.8787231445312
      ],
      "bbox_max": [
        -3560.0,
        -4977.00048828125,
        941.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785986423492432,
        0.28108450770378113,
        -0.6785981059074402
      ],
      "plane_d": 4453.8095703125,
      "bbox_min": [
        -3562.98974609375,
        -4979.00048828125,
        938.7071533203125
      ],
      "bbox_max": [
        -3560.982666015625,
        -4977.00048828125,
        940.7244873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785986423492432,
        0.28108450770378113,
        -0.6785981059074402
      ],
      "plane_d": 4453.8095703125,
      "bbox_min": [
        -3563.0,
        -4977.02490234375,
        938.7071533203125
      ],
      "bbox_max": [
        -3562.947265625,
        -4977.00048828125,
        938.7598876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -5.35958520231361e-07,
        -1.0,
        -0.0
      ],
      "plane_d": -4930.87646484375,
      "bbox_min": [
        -3602.34326171875,
        -4979.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3536.6162109375,
        -4930.87451171875,
        938.7072143554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.0517796858475776e-06,
        5.285785846353974e-06,
        1.0
      ],
      "plane_d": -918.69189453125,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3577.974365234375,
        -4935.52685546875,
        918.7071533203125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6123723387718201,
        0.35355210304260254,
        -0.7071075439453125
      ],
      "plane_d": 4586.35693359375,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3577.974365234375,
        -4935.52685546875,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660231232643127,
        0.5000039935112,
        -0.0
      ],
      "plane_d": 5574.4013671875,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3577.974365234375,
        -4935.52685546875,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810858488082886,
        -0.6785958409309387,
        0.6786003112792969
      ],
      "plane_d": -5001.10107421875,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3577.974365234375,
        -4939.02685546875,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826834261417389,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": -3215.1005859375,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3577.974365234375,
        -4939.02685546875,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 1409.41943359375,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3577.974365234375,
        -4939.02685546875,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785951852798462,
        -0.2810831367969513,
        0.6786020994186401
      ],
      "plane_d": 413.828369140625,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3577.974365234375,
        -4939.02685546875,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785951256752014,
        -0.28108349442481995,
        -0.6786020398139954
      ],
      "plane_d": 1653.91357421875,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3577.974365234375,
        -4939.02685546875,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28108325600624084,
        -0.6785954833030701,
        0.6786018013954163
      ],
      "plane_d": -2982.913330078125,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3577.974365234375,
        -4939.02685546875,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826838731765747,
        0.0,
        0.9238793253898621
      ],
      "plane_d": -2222.609619140625,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3577.974365234375,
        -4939.02685546875,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4967.0263671875,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3577.974365234375,
        -4939.02685546875,
        918.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2810833752155304,
        -0.6785953640937805,
        -0.6786018013954163
      ],
      "plane_d": -1742.82568359375,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3577.974365234375,
        -4939.02685546875,
        918.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.694584310054779,
        0.18733786046504974,
        0.6945913434028625
      ],
      "plane_d": 2777.421875,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3577.974365234375,
        -4939.02685546875,
        918.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.694584310054779,
        0.18733784556388855,
        -0.6945914030075073
      ],
      "plane_d": 4046.727783203125,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3577.974365234375,
        -4939.02685546875,
        918.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238796234130859,
        0.0,
        0.3826831579208374
      ],
      "plane_d": -3675.878173828125,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3584.974365234375,
        -4939.02685546875,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786015629768372,
        -0.6785946488380432,
        0.2810857594013214
      ],
      "plane_d": -6068.5419921875,
      "bbox_min": [
        -3602.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3584.974365234375,
        -4939.02685546875,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123680472373962,
        -0.35355958342552185,
        -0.7071075439453125
      ],
      "plane_d": -3304.099609375,
      "bbox_min": [
        -3602.34326171875,
        -4960.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3584.974365234375,
        -4939.02685546875,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660231232643127,
        -0.5000039935112,
        -0.0
      ],
      "plane_d": -5584.4013671875,
      "bbox_min": [
        -3595.88330078125,
        -4960.0263671875,
        911.70703125
      ],
      "bbox_max": [
        -3584.974365234375,
        -4940.087890625,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123723387718201,
        -0.35355210304260254,
        0.7071075439453125
      ],
      "plane_d": -4596.2568359375,
      "bbox_min": [
        -3595.88330078125,
        -4957.5751953125,
        915.70703125
      ],
      "bbox_max": [
        -3584.974365234375,
        -4940.087890625,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6944004893302917,
        -0.18872195482254028,
        0.6944004893302917
      ],
      "plane_d": -4062.47607421875,
      "bbox_min": [
        -3588.383056640625,
        -4957.5751953125,
        915.7071533203125
      ],
      "bbox_max": [
        -3584.974365234375,
        -4952.01708984375,
        918.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6785974502563477,
        0.28108885884284973,
        0.6785974502563477
      ],
      "plane_d": -1663.391357421875,
      "bbox_min": [
        -3587.52685546875,
        -4957.5751953125,
        916.1547241210938
      ],
      "bbox_max": [
        -3584.974365234375,
        -4955.00048828125,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810854911804199,
        0.6785970330238342,
        0.6785992980003357
      ],
      "plane_d": 1733.328369140625,
      "bbox_min": [
        -3591.83154296875,
        -4960.0263671875,
        911.7071533203125
      ],
      "bbox_max": [
        -3586.040771484375,
        -4953.51708984375,
        918.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238772988319397,
        0.3826887607574463,
        0.0
      ],
      "plane_d": -1418.625,
      "bbox_min": [
        -3590.66015625,
        -4957.0263671875,
        911.7071533203125
      ],
      "bbox_max": [
        -3587.974365234375,
        -4953.51708984375,
        915.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4957.0263671875,
      "bbox_min": [
        -3590.66015625,
        -4957.0263671875,
        914.8619384765625
      ],
      "bbox_max": [
        -3590.0,
        -4957.0263671875,
        915.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785974502563477,
        0.28108885884284973,
        0.6785974502563477
      ],
      "plane_d": -1663.391357421875,
      "bbox_min": [
        -3588.567626953125,
        -4958.55419921875,
        912.867431640625
      ],
      "bbox_max": [
        -3586.040771484375,
        -4953.51708984375,
        918.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238772988319397,
        0.3826887607574463,
        0.0
      ],
      "plane_d": -1418.625,
      "bbox_min": [
        -3588.567626953125,
        -4956.43310546875,
        914.5202026367188
      ],
      "bbox_max": [
        -3587.974365234375,
        -4955.00048828125,
        915.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9640443325042725,
        -0.2657414972782135,
        0.0
      ],
      "plane_d": -4775.7158203125,
      "bbox_min": [
        -3588.383056640625,
        -4955.00048828125,
        914.6839599609375
      ],
      "bbox_max": [
        -3587.52685546875,
        -4953.51708984375,
        916.1547241210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6927580833435059,
        -0.19096069037914276,
        0.6954281330108643
      ],
      "plane_d": -4068.616943359375,
      "bbox_min": [
        -3588.383056640625,
        -4955.00048828125,
        915.7071533203125
      ],
      "bbox_max": [
        -3587.52685546875,
        -4953.51708984375,
        916.1547241210938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4957.0263671875,
      "bbox_min": [
        -3599.34326171875,
        -4960.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3584.974365234375,
        -4952.01708984375,
        915.4337158203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2810855805873871,
        0.6785961985588074,
        -0.6786001324653625
      ],
      "plane_d": 4991.60107421875,
      "bbox_min": [
        -3595.34326171875,
        -4960.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3585.8134765625,
        -4957.0263671875,
        911.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785982847213745,
        0.6785982847213745,
        -0.2810848355293274
      ],
      "plane_d": 6059.046875,
      "bbox_min": [
        -3595.34326171875,
        -4958.36962890625,
        908.70703125
      ],
      "bbox_max": [
        -3594.0,
        -4957.0263671875,
        909.6568603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28108400106430054,
        0.6785979866981506,
        -0.678598940372467
      ],
      "plane_d": 2973.420166015625,
      "bbox_min": [
        -3590.0,
        -4957.0263671875,
        908.7071533203125
      ],
      "bbox_max": [
        -3584.974365234375,
        -4952.01708984375,
        914.8619384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238772988319397,
        0.3826887607574463,
        0.0
      ],
      "plane_d": -1418.625,
      "bbox_min": [
        -3588.567626953125,
        -4956.43310546875,
        911.7071533203125
      ],
      "bbox_max": [
        -3588.17041015625,
        -4955.47412109375,
        913.3247680664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6944013237953186,
        -0.18871577084064484,
        -0.6944013237953186
      ],
      "plane_d": -2793.490234375,
      "bbox_min": [
        -3588.567626953125,
        -4957.0263671875,
        908.7071533203125
      ],
      "bbox_max": [
        -3584.974365234375,
        -4952.01708984375,
        912.5015869140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9640443325042725,
        -0.2657414972782135,
        0.0
      ],
      "plane_d": -4775.7158203125,
      "bbox_min": [
        -3588.383056640625,
        -4955.7841796875,
        911.7071533203125
      ],
      "bbox_max": [
        -3587.974365234375,
        -4953.51708984375,
        912.5015869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786010265350342,
        -0.6785941123962402,
        -0.28108838200569153
      ],
      "plane_d": -675.3642578125,
      "bbox_min": [
        -3595.34326171875,
        -4967.0263671875,
        908.70703125
      ],
      "bbox_max": [
        -3594.0,
        -4965.68310546875,
        909.6568603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123723387718201,
        -0.35355210304260254,
        0.7071075439453125
      ],
      "plane_d": -4596.2568359375,
      "bbox_min": [
        -3595.122802734375,
        -4944.71630859375,
        916.585205078125
      ],
      "bbox_max": [
        -3590.000244140625,
        -4939.02685546875,
        918.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -3171.873779296875,
      "bbox_min": [
        -3570.0,
        -4979.00048828125,
        908.70703125
      ],
      "bbox_max": [
        -3536.6162109375,
        -4930.87451171875,
        938.7072143554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.880510929948899e-12,
        2.0345053144410485e-06,
        1.0
      ],
      "plane_d": -918.697021484375,
      "bbox_min": [
        -3570.0,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3536.6162109375,
        -4930.87451171875,
        918.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -2.0345053144410485e-06,
        -0.0
      ],
      "plane_d": -3570.010009765625,
      "bbox_min": [
        -3570.0,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3536.6162109375,
        -4930.87451171875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        2.8772249152098084e-06,
        0.7071067690849304
      ],
      "plane_d": 1869.8115234375,
      "bbox_min": [
        -3570.0,
        -4977.01806640625,
        908.70703125
      ],
      "bbox_max": [
        -3536.6162109375,
        -4931.458984375,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -2.8772249152098084e-06,
        -0.7071067690849304
      ],
      "plane_d": -1879.7109375,
      "bbox_min": [
        -3570.0,
        -4945.87451171875,
        908.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4933.33984375,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4945.87451171875,
      "bbox_min": [
        -3570.0,
        -4945.87451171875,
        908.70703125
      ],
      "bbox_max": [
        -3560.0,
        -4942.62548828125,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        2.0345053144410485e-06,
        -0.0
      ],
      "plane_d": 3560.010009765625,
      "bbox_min": [
        -3560.0,
        -4945.87451171875,
        914.078857421875
      ],
      "bbox_max": [
        -3560.0,
        -4942.62548828125,
        915.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.271565793103946e-06,
        -1.0,
        -0.0
      ],
      "plane_d": -4977.0224609375,
      "bbox_min": [
        -3550.719970703125,
        -4977.01806640625,
        914.11865234375
      ],
      "bbox_max": [
        -3536.6162109375,
        -4953.95361328125,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071048021316528,
        0.003977695479989052,
        0.7070975303649902
      ],
      "plane_d": -3132.204833984375,
      "bbox_min": [
        -3550.719970703125,
        -4977.01806640625,
        914.11865234375
      ],
      "bbox_max": [
        -3538.896728515625,
        -4953.95361328125,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7174146175384521,
        0.013697143644094467,
        0.6965117454528809
      ],
      "plane_d": -3110.65380859375,
      "bbox_min": [
        -3541.918701171875,
        -4977.01806640625,
        914.11865234375
      ],
      "bbox_max": [
        -3540.24365234375,
        -4973.4384765625,
        917.3621215820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9998177886009216,
        0.01908888854086399,
        0.0
      ],
      "plane_d": -3446.267578125,
      "bbox_min": [
        -3541.918701171875,
        -4977.01806640625,
        914.11865234375
      ],
      "bbox_max": [
        -3541.860107421875,
        -4973.94921875,
        915.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999895691871643,
        -0.866025984287262,
        -0.0
      ],
      "plane_d": -6065.609375,
      "bbox_min": [
        -3550.719970703125,
        -4954.60205078125,
        918.0607299804688
      ],
      "bbox_max": [
        -3549.597900390625,
        -4953.95361328125,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123724579811096,
        0.3535518944263458,
        0.7071075439453125
      ],
      "plane_d": -1072.05078125,
      "bbox_min": [
        -3550.719970703125,
        -4954.27734375,
        918.0607299804688
      ],
      "bbox_max": [
        -3549.973388671875,
        -4953.95361328125,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785988211631775,
        0.28108540177345276,
        -0.6785975098609924
      ],
      "plane_d": -384.595458984375,
      "bbox_min": [
        -3567.82861328125,
        -4979.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3562.17138671875,
        -4977.00048828125,
        938.7072143554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785986423492432,
        0.28108450770378113,
        -0.6785981059074402
      ],
      "plane_d": 4453.8095703125,
      "bbox_min": [
        -3563.0,
        -4979.00048828125,
        937.878662109375
      ],
      "bbox_max": [
        -3562.17138671875,
        -4977.00048828125,
        938.7072143554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785951852798462,
        0.6786072850227356,
        -0.2810707092285156
      ],
      "plane_d": 6059.9013671875,
      "bbox_min": [
        -3563.0,
        -4979.00048828125,
        937.878662109375
      ],
      "bbox_max": [
        -3562.17138671875,
        -4978.41455078125,
        938.7072143554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9239004254341125,
        -0.3826330304145813
      ],
      "plane_d": 4958.515625,
      "bbox_min": [
        -3567.0,
        -4979.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3562.5146484375,
        -4978.41455078125,
        938.121337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786066293716431,
        0.6786066293716431,
        -0.28104469180107117
      ],
      "plane_d": 1221.449462890625,
      "bbox_min": [
        -3567.82861328125,
        -4979.00048828125,
        936.70703125
      ],
      "bbox_max": [
        -3567.0,
        -4978.41455078125,
        938.7072143554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5000002980232239,
        -0.8660252094268799,
        0.0
      ],
      "plane_d": -2480.6796875,
      "bbox_min": [
        -3604.0,
        -4989.00048828125,
        878.70703125
      ],
      "bbox_max": [
        -3545.28125,
        -4930.87451171875,
        908.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238764643669128,
        -0.0,
        -0.3826908469200134
      ],
      "plane_d": -2950.4853515625,
      "bbox_min": [
        -3604.0,
        -4989.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3545.28125,
        -4930.87451171875,
        908.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826831579208374,
        -0.0,
        -0.9238796234130859
      ],
      "plane_d": -533.13720703125,
      "bbox_min": [
        -3570.0,
        -4989.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3545.28125,
        -4979.00048828125,
        908.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785963773727417,
        0.6785963773727417,
        -0.2810942530632019
      ],
      "plane_d": 1213.61083984375,
      "bbox_min": [
        -3570.0,
        -4989.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3545.28125,
        -4979.00048828125,
        908.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785971522331238,
        -0.6785971522331238,
        -0.28109052777290344
      ],
      "plane_d": -5550.6484375,
      "bbox_min": [
        -3570.0,
        -4989.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3545.28125,
        -4979.00048828125,
        908.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810840308666229,
        -0.67859947681427,
        -0.6785974502563477
      ],
      "plane_d": -3775.091064453125,
      "bbox_min": [
        -3567.0,
        -4989.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3545.28125,
        -4979.00048828125,
        908.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810847759246826,
        0.6785996556282043,
        -0.6785969734191895
      ],
      "plane_d": 2989.18701171875,
      "bbox_min": [
        -3567.0,
        -4989.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3545.28125,
        -4979.00048828125,
        908.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4166.7734375,
      "bbox_min": [
        -3567.0,
        -4989.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3545.28125,
        -4979.00048828125,
        908.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2891.567138671875,
      "bbox_min": [
        -3567.0,
        -4989.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3545.28125,
        -4979.00048828125,
        908.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4979.00048828125,
      "bbox_min": [
        -3567.0,
        -4986.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3545.28125,
        -4979.00048828125,
        908.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -906.7071533203125,
      "bbox_min": [
        -3563.0,
        -4986.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3545.28125,
        -4979.00048828125,
        908.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2881.66748046875,
      "bbox_min": [
        -3562.171630859375,
        -4986.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3547.597900390625,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 896.7071533203125,
      "bbox_min": [
        -3558.0,
        -4986.00048828125,
        896.7071533203125
      ],
      "bbox_max": [
        -3556.83740234375,
        -4979.00048828125,
        899.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4156.8740234375,
      "bbox_min": [
        -3558.0,
        -4979.99951171875,
        898.7080688476562
      ],
      "bbox_max": [
        -3557.423828125,
        -4979.00048828125,
        899.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810819745063782,
        0.6785973310470581,
        0.6786004900932312
      ],
      "plane_d": 3765.56982421875,
      "bbox_min": [
        -3562.171630859375,
        -4982.00048828125,
        903.7071533203125
      ],
      "bbox_max": [
        -3558.0,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785787343978882,
        0.6786046028137207,
        0.28111693263053894
      ],
      "plane_d": 5541.095703125,
      "bbox_min": [
        -3562.171630859375,
        -4981.17236328125,
        905.1715698242188
      ],
      "bbox_max": [
        -3559.999755859375,
        -4979.00048828125,
        906.7071533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.678607702255249,
        0.678587019443512,
        0.2810894250869751
      ],
      "plane_d": 5541.13671875,
      "bbox_min": [
        -3563.0,
        -4986.00048828125,
        906.7071533203125
      ],
      "bbox_max": [
        -3558.0,
        -4979.00048828125,
        908.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826793134212494,
        -0.0,
        0.9238812327384949
      ],
      "plane_d": 523.88330078125,
      "bbox_min": [
        -3560.0,
        -4986.00048828125,
        906.7071533203125
      ],
      "bbox_max": [
        -3558.0,
        -4982.00048828125,
        908.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238600730895996,
        -0.0,
        0.3827303647994995
      ],
      "plane_d": 2941.152099609375,
      "bbox_min": [
        -3560.0,
        -4985.4150390625,
        907.2928466796875
      ],
      "bbox_max": [
        -3559.4140625,
        -4982.00048828125,
        908.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810819745063782,
        0.6785973310470581,
        0.6786004900932312
      ],
      "plane_d": 3765.56982421875,
      "bbox_min": [
        -3559.999755859375,
        -4983.1728515625,
        906.7071533203125
      ],
      "bbox_max": [
        -3558.0,
        -4981.17236328125,
        907.2928466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826793134212494,
        -0.0,
        0.9238812327384949
      ],
      "plane_d": 523.88330078125,
      "bbox_min": [
        -3559.4140625,
        -4983.1728515625,
        906.7071533203125
      ],
      "bbox_max": [
        -3558.0,
        -4982.00048828125,
        907.2928466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.678607702255249,
        -0.678587019443512,
        0.2810894250869751
      ],
      "plane_d": -1223.019775390625,
      "bbox_min": [
        -3563.0,
        -4989.00048828125,
        903.7071533203125
      ],
      "bbox_max": [
        -3558.0,
        -4984.0009765625,
        908.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238600730895996,
        -0.0,
        0.3827303647994995
      ],
      "plane_d": 2941.152099609375,
      "bbox_min": [
        -3560.0,
        -4986.00048828125,
        907.0977172851562
      ],
      "bbox_max": [
        -3558.94287109375,
        -4984.0009765625,
        908.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826793134212494,
        -0.0,
        0.9238812327384949
      ],
      "plane_d": 523.88330078125,
      "bbox_min": [
        -3559.4140625,
        -4986.00048828125,
        907.0977172851562
      ],
      "bbox_max": [
        -3558.94287109375,
        -4985.4150390625,
        907.2928466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810840904712677,
        -0.6785978078842163,
        0.6785990595817566
      ],
      "plane_d": -2998.6826171875,
      "bbox_min": [
        -3561.535400390625,
        -4989.00048828125,
        903.7071533203125
      ],
      "bbox_max": [
        -3558.0,
        -4985.60986328125,
        907.2928466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 904.70703125,
      "bbox_min": [
        -3604.0,
        -4967.0263671875,
        904.70703125
      ],
      "bbox_max": [
        -3574.894287109375,
        -4930.87451171875,
        908.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785981059074402,
        0.6785981059074402,
        0.2810858488082886
      ],
      "plane_d": 665.896728515625,
      "bbox_min": [
        -3604.0,
        -4967.0263671875,
        904.70703125
      ],
      "bbox_max": [
        -3574.894287109375,
        -4930.87451171875,
        908.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786015629768372,
        -0.6785946488380432,
        0.2810857594013214
      ],
      "plane_d": -6068.5419921875,
      "bbox_min": [
        -3604.0,
        -4967.0263671875,
        904.70703125
      ],
      "bbox_max": [
        -3590.0,
        -4957.0263671875,
        908.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238796234130859,
        0.0,
        0.3826831579208374
      ],
      "plane_d": -3675.878173828125,
      "bbox_min": [
        -3604.0,
        -4967.0263671875,
        904.70703125
      ],
      "bbox_max": [
        -3590.0,
        -4957.0263671875,
        908.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4957.0263671875,
      "bbox_min": [
        -3601.0,
        -4967.0263671875,
        904.70703125
      ],
      "bbox_max": [
        -3590.0,
        -4957.0263671875,
        908.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4967.0263671875,
      "bbox_min": [
        -3601.0,
        -4967.0263671875,
        904.70703125
      ],
      "bbox_max": [
        -3590.0,
        -4957.0263671875,
        908.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785982847213745,
        0.6785982847213745,
        -0.2810848355293274
      ],
      "plane_d": 6059.046875,
      "bbox_min": [
        -3597.0,
        -4967.0263671875,
        904.70703125
      ],
      "bbox_max": [
        -3590.0,
        -4957.0263671875,
        908.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786010265350342,
        -0.6785941123962402,
        -0.28108838200569153
      ],
      "plane_d": -675.3642578125,
      "bbox_min": [
        -3597.0,
        -4967.0263671875,
        904.70703125
      ],
      "bbox_max": [
        -3590.0,
        -4960.0263671875,
        908.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.0,
        -0.3826836943626404
      ],
      "plane_d": 3666.63916015625,
      "bbox_min": [
        -3594.0,
        -4964.0263671875,
        904.70703125
      ],
      "bbox_max": [
        -3590.4140625,
        -4960.0263671875,
        908.5355834960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826836943626404,
        0.0,
        -0.9238794445991516
      ],
      "plane_d": 2213.370361328125,
      "bbox_min": [
        -3592.82861328125,
        -4964.0263671875,
        907.5355224609375
      ],
      "bbox_max": [
        -3590.4140625,
        -4960.0263671875,
        908.5355834960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28108882904052734,
        -0.6785928606987,
        -0.6786020994186401
      ],
      "plane_d": -1742.793212890625,
      "bbox_min": [
        -3594.0,
        -4965.68310546875,
        907.5355224609375
      ],
      "bbox_max": [
        -3590.0,
        -4962.0263671875,
        908.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826836943626404,
        0.0,
        -0.9238794445991516
      ],
      "plane_d": 2213.370361328125,
      "bbox_min": [
        -3592.82861328125,
        -4964.0263671875,
        907.5355224609375
      ],
      "bbox_max": [
        -3590.0,
        -4962.0263671875,
        908.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -5.35958520231361e-07,
        -1.0,
        -0.0
      ],
      "plane_d": -4930.87646484375,
      "bbox_min": [
        -3579.160888671875,
        -4930.87451171875,
        905.0147705078125
      ],
      "bbox_max": [
        -3574.894287109375,
        -4930.87451171875,
        908.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3618.0517578125,
      "bbox_min": [
        -3618.0517578125,
        -5067.609375,
        878.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4989.00048828125,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.599609375,
      "bbox_min": [
        -3570.0,
        -5067.609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5042.41552734375,
        976.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6941619515419006,
        -0.19046860933303833,
        -0.6941619515419006
      ],
      "plane_d": 2171.408203125,
      "bbox_min": [
        -3570.0,
        -5067.609375,
        945.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5057.12646484375,
        951.1815185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6954105496406555,
        -0.1908418834209442,
        -0.6928083896636963
      ],
      "plane_d": 2172.690185546875,
      "bbox_min": [
        -3570.0,
        -5067.609375,
        948.58349609375
      ],
      "bbox_max": [
        -3566.990234375,
        -5057.12646484375,
        951.1815185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.2655699849128723,
        -0.9640915989875793
      ],
      "plane_d": -428.3804931640625,
      "bbox_min": [
        -3567.0,
        -5066.109375,
        948.70703125
      ],
      "bbox_max": [
        -3566.990234375,
        -5057.12646484375,
        951.1815185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6954106092453003,
        -0.19084195792675018,
        -0.6928083896636963
      ],
      "plane_d": -2785.587890625,
      "bbox_min": [
        -3563.009033203125,
        -5067.609375,
        948.58349609375
      ],
      "bbox_max": [
        -3560.0,
        -5057.12646484375,
        951.1815185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.2655699849128723,
        -0.9640915989875793
      ],
      "plane_d": -428.3804931640625,
      "bbox_min": [
        -3563.009033203125,
        -5066.109375,
        948.70703125
      ],
      "bbox_max": [
        -3563.0,
        -5057.12646484375,
        951.1815185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.2655699849128723,
        -0.9640915989875793
      ],
      "plane_d": -428.3804931640625,
      "bbox_min": [
        -3567.0,
        -5066.109375,
        948.70703125
      ],
      "bbox_max": [
        -3563.0,
        -5057.12646484375,
        951.1815185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1054.72021484375,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5042.41552734375,
        976.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 6096.3916015625,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5042.41552734375,
        976.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9238904714584351,
        0.382656991481781
      ],
      "plane_d": 4306.8671875,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5042.41552734375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786113381385803,
        0.28106939792633057,
        0.6785916686058044
      ],
      "plane_d": 3201.490478515625,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5042.41552734375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786320805549622,
        0.6785681247711182,
        0.28107649087905884
      ],
      "plane_d": 5583.912109375,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5042.41552734375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786267757415771,
        0.6785820722579956,
        0.28105515241622925
      ],
      "plane_d": 745.37451171875,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5042.41552734375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38266900181770325,
        0.9238856434822083
      ],
      "plane_d": 1063.1539306640625,
      "bbox_min": [
        -3570.0,
        -5051.6708984375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5042.41552734375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.678613543510437,
        0.2810787558555603,
        0.6785854697227478
      ],
      "plane_d": -1636.963134765625,
      "bbox_min": [
        -3570.0,
        -5051.6708984375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5042.41552734375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3570.0,
      "bbox_min": [
        -3570.0,
        -5051.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5042.41552734375,
        948.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3560.0,
      "bbox_min": [
        -3570.0,
        -5051.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5042.41552734375,
        948.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 3193.087158203125,
      "bbox_min": [
        -3570.0,
        -5044.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3566.216796875,
        -5042.41552734375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1858.48388671875,
      "bbox_min": [
        -3570.0,
        -5044.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3566.216796875,
        -5042.41552734375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -938.70703125,
      "bbox_min": [
        -3567.0,
        -5044.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3566.216796875,
        -5044.1474609375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 948.70703125,
      "bbox_min": [
        -3567.0,
        -5044.599609375,
        948.70703125
      ],
      "bbox_max": [
        -3566.216796875,
        -5044.1474609375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000002384185791,
        0.8660252690315247,
        0.0
      ],
      "plane_d": 2586.9326171875,
      "bbox_min": [
        -3618.0517578125,
        -5048.18896484375,
        878.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4989.00048828125,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.678613543510437,
        0.2810787558555603,
        0.6785854697227478
      ],
      "plane_d": -1636.963134765625,
      "bbox_min": [
        -3564.92578125,
        -5048.18896484375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5042.5009765625,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3560.0,
      "bbox_min": [
        -3564.92578125,
        -5048.18896484375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5042.5009765625,
        948.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -3183.187744140625,
      "bbox_min": [
        -3564.92578125,
        -5046.45703125,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5042.5009765625,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -1848.58447265625,
      "bbox_min": [
        -3564.92578125,
        -5046.45703125,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5042.5009765625,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38266900181770325,
        0.9238856434822083
      ],
      "plane_d": 1063.1539306640625,
      "bbox_min": [
        -3564.92578125,
        -5046.45703125,
        938.70703125
      ],
      "bbox_max": [
        -3563.0,
        -5044.23291015625,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 948.70703125,
      "bbox_min": [
        -3563.634765625,
        -5044.599609375,
        948.70703125
      ],
      "bbox_max": [
        -3563.0,
        -5044.23291015625,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        0.49999839067459106,
        0.0
      ],
      "plane_d": 5632.43798828125,
      "bbox_min": [
        -3618.0517578125,
        -5045.34521484375,
        878.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4989.00048828125,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253286361694,
        0.5000001192092896,
        0.0
      ],
      "plane_d": -542.189697265625,
      "bbox_min": [
        -3613.402587890625,
        -5045.34521484375,
        878.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4989.00048828125,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5037.12646484375,
      "bbox_min": [
        -3613.402587890625,
        -5045.34521484375,
        878.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4989.00048828125,
        993.70703125
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -938.70703125,
      "bbox_min": [
        -3570.0,
        -5045.34521484375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5037.12646484375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 948.70703125,
      "bbox_min": [
        -3570.0,
        -5045.34521484375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5037.12646484375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -3183.187744140625,
      "bbox_min": [
        -3570.0,
        -5045.34521484375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5037.12646484375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -1848.58447265625,
      "bbox_min": [
        -3570.0,
        -5045.34521484375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5037.12646484375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1858.48388671875,
      "bbox_min": [
        -3570.0,
        -5045.34521484375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5037.12646484375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 3193.087158203125,
      "bbox_min": [
        -3570.0,
        -5045.34521484375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5037.12646484375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3560.0,
      "bbox_min": [
        -3570.0,
        -5045.34521484375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5037.12646484375,
        945.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3570.0,
      "bbox_min": [
        -3570.0,
        -5045.34521484375,
        938.70703125
      ],
      "bbox_max": [
        -3563.634765625,
        -5037.12646484375,
        945.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38266900181770325,
        0.9238856434822083
      ],
      "plane_d": 1063.1539306640625,
      "bbox_min": [
        -3566.216796875,
        -5045.34521484375,
        938.70703125
      ],
      "bbox_max": [
        -3563.634765625,
        -5044.599609375,
        939.0157470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -3.353575039000134e-06,
        0.0
      ],
      "plane_d": 3550.674072265625,
      "bbox_min": [
        -3579.160888671875,
        -5037.12646484375,
        989.70703125
      ],
      "bbox_max": [
        -3550.69091796875,
        -5018.92626953125,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -3579.160888671875,
      "bbox_min": [
        -3579.160888671875,
        -5037.12646484375,
        989.70703125
      ],
      "bbox_max": [
        -3579.160888671875,
        -5018.92626953125,
        993.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -2.15791899904616e-07,
        0.7071067690849304
      ],
      "plane_d": 1830.09912109375,
      "bbox_min": [
        -3613.402587890625,
        -5037.12646484375,
        878.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4989.00048828125,
        989.9418334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        1.942126800713595e-06,
        -0.7071067690849304
      ],
      "plane_d": 3201.48291015625,
      "bbox_min": [
        -3613.402587890625,
        -5037.12646484375,
        878.70703125
      ],
      "bbox_max": [
        -3533.976806640625,
        -4989.00048828125,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.220703097715159e-06,
        0.0
      ],
      "plane_d": -3569.865966796875,
      "bbox_min": [
        -3613.402587890625,
        -5037.12451171875,
        918.70703125
      ],
      "bbox_max": [
        -3559.85986328125,
        -4989.00048828125,
        974.7070922851562
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        1.220703097715159e-06,
        0.0
      ],
      "plane_d": 3559.865966796875,
      "bbox_min": [
        -3569.860107421875,
        -5037.12451171875,
        957.7067260742188
      ],
      "bbox_max": [
        -3559.85986328125,
        -4999.00048828125,
        974.7070922851562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        2.9103830890414573e-12,
        -1.5258789289873675e-06,
        1.0
      ],
      "plane_d": -974.7147216796875,
      "bbox_min": [
        -3569.860107421875,
        -5037.12451171875,
        957.7067260742188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        2.15791899904616e-07,
        -0.7071067690849304
      ],
      "plane_d": -1839.9986572265625,
      "bbox_min": [
        -3569.860107421875,
        -5037.12451171875,
        957.7067260742188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.9103830890414573e-12,
        1.5258789289873675e-06,
        -1.0
      ],
      "plane_d": 964.7147216796875,
      "bbox_min": [
        -3569.860107421875,
        -5037.12451171875,
        962.7070922851562
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.373046875,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.130800554477901e-07,
        0.37385931611061096,
        0.9274854063987732
      ],
      "plane_d": 969.8002319335938,
      "bbox_min": [
        -3569.860107421875,
        -5012.12451171875,
        964.7066650390625
      ],
      "bbox_max": [
        -3559.860107421875,
        -5000.2236328125,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6771323680877686,
        0.27510860562324524,
        0.6825006008148193
      ],
      "plane_d": 3126.16845703125,
      "bbox_min": [
        -3569.860107421875,
        -5012.12451171875,
        964.7066650390625
      ],
      "bbox_max": [
        -3559.860107421875,
        -5000.2236328125,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6771314740180969,
        0.27510881423950195,
        0.6825013756752014
      ],
      "plane_d": -1701.592529296875,
      "bbox_min": [
        -3569.860107421875,
        -5012.12451171875,
        964.7066650390625
      ],
      "bbox_max": [
        -3559.860107421875,
        -5000.2236328125,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6804428696632385,
        0.2720201313495636,
        0.6804428696632385
      ],
      "plane_d": 3124.4892578125,
      "bbox_min": [
        -3569.860107421875,
        -5012.12451171875,
        964.7066650390625
      ],
      "bbox_max": [
        -3559.860107421875,
        -5000.2236328125,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6804430484771729,
        0.2720193564891815,
        0.6804430484771729
      ],
      "plane_d": -1726.8829345703125,
      "bbox_min": [
        -3569.860107421875,
        -5012.12451171875,
        964.7066650390625
      ],
      "bbox_max": [
        -3559.860107421875,
        -5000.2236328125,
        974.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3163420362616307e-06,
        0.9201897978782654,
        0.3914725184440613
      ],
      "plane_d": 4223.494140625,
      "bbox_min": [
        -3569.860107421875,
        -5005.01708984375,
        964.7066650390625
      ],
      "bbox_max": [
        -3559.860107421875,
        -5000.2236328125,
        970.987060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6800235509872437,
        0.6746742129325867,
        0.2870238423347473
      ],
      "plane_d": 5519.45703125,
      "bbox_min": [
        -3569.860107421875,
        -5005.01708984375,
        964.7066650390625
      ],
      "bbox_max": [
        -3559.860107421875,
        -5000.2236328125,
        970.987060546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6800232529640198,
        0.6746742129325867,
        0.28702449798583984
      ],
      "plane_d": 671.079833984375,
      "bbox_min": [
        -3569.860107421875,
        -5005.01708984375,
        964.70751953125
      ],
      "bbox_max": [
        -3566.860107421875,
        -5000.22412109375,
        970.987060546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        6.565583703377342e-07,
        -0.34422567486763,
        -0.9388869404792786
      ],
      "plane_d": -819.5487060546875,
      "bbox_min": [
        -3566.860107421875,
        -5012.12451171875,
        962.7070922851562
      ],
      "bbox_max": [
        -3562.860107421875,
        -4999.373046875,
        964.7073974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3163420362616307e-06,
        0.9201897978782654,
        0.3914725184440613
      ],
      "plane_d": 4223.494140625,
      "bbox_min": [
        -3566.860107421875,
        -5000.22412109375,
        962.7071533203125
      ],
      "bbox_max": [
        -3562.860107421875,
        -4999.373046875,
        964.7073974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2978983932043775e-06,
        -0.9072967171669006,
        -0.42049095034599304
      ],
      "plane_d": -4140.2041015625,
      "bbox_min": [
        -3566.068603515625,
        -5009.966796875,
        962.7070922851562
      ],
      "bbox_max": [
        -3563.65087890625,
        -5009.40673828125,
        963.916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3163420362616307e-06,
        0.9201897978782654,
        0.3914725184440613
      ],
      "plane_d": 4223.494140625,
      "bbox_min": [
        -3569.860107421875,
        -5012.12451171875,
        957.7067260742188
      ],
      "bbox_max": [
        -3564.859619140625,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        7.993133408490394e-07
      ],
      "plane_d": -6064.0498046875,
      "bbox_min": [
        -3569.860107421875,
        -5012.12451171875,
        957.7067260742188
      ],
      "bbox_max": [
        -3564.859619140625,
        -5006.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2978983932043775e-06,
        -0.9072967171669006,
        -0.42049095034599304
      ],
      "plane_d": -4140.2041015625,
      "bbox_min": [
        -3566.860107421875,
        -5009.9111328125,
        960.7067260742188
      ],
      "bbox_max": [
        -3564.859619140625,
        -5009.00048828125,
        963.796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.593447371261216e-12,
        -1.0,
        -1.8840013353838003e-06
      ],
      "plane_d": -5008.99853515625,
      "bbox_min": [
        -3566.860107421875,
        -5009.00048828125,
        960.7067260742188
      ],
      "bbox_max": [
        -3565.73583984375,
        -5009.00048828125,
        961.8309326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6816345453262329,
        -0.6700694561004639,
        -0.2939068675041199
      ],
      "plane_d": -5505.01953125,
      "bbox_min": [
        -3569.860107421875,
        -5012.12451171875,
        961.8309326171875
      ],
      "bbox_max": [
        -3565.94873046875,
        -5006.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6719449758529663,
        -0.6719449758529663,
        -0.31141605973243713
      ],
      "plane_d": -5462.9765625,
      "bbox_min": [
        -3569.860107421875,
        -5010.63134765625,
        961.8309326171875
      ],
      "bbox_max": [
        -3565.94873046875,
        -5006.00048828125,
        964.1597290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2978983932043775e-06,
        -0.9072967171669006,
        -0.42049095034599304
      ],
      "plane_d": -4140.2041015625,
      "bbox_min": [
        -3566.860107421875,
        -5010.63134765625,
        961.8309326171875
      ],
      "bbox_max": [
        -3565.94873046875,
        -5009.00048828125,
        964.1597290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.565583703377342e-07,
        -0.34422567486763,
        -0.9388869404792786
      ],
      "plane_d": -819.5487060546875,
      "bbox_min": [
        -3566.860107421875,
        -5010.63134765625,
        963.916015625
      ],
      "bbox_max": [
        -3566.068603515625,
        -5009.966796875,
        964.1597290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6844790577888489,
        -0.25095170736312866,
        -0.6844790577888489
      ],
      "plane_d": -3038.92041015625,
      "bbox_min": [
        -3569.860107421875,
        -5012.12451171875,
        963.916015625
      ],
      "bbox_max": [
        -3566.3125,
        -5007.84521484375,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6753695011138916,
        -0.26809096336364746,
        -0.6870249509811401
      ],
      "plane_d": -3089.8408203125,
      "bbox_min": [
        -3569.860107421875,
        -5012.12451171875,
        963.916015625
      ],
      "bbox_max": [
        -3566.860107421875,
        -5007.84521484375,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6800232529640198,
        0.6746742129325867,
        0.28702449798583984
      ],
      "plane_d": 671.079833984375,
      "bbox_min": [
        -3568.9990234375,
        -5003.2900390625,
        961.8309326171875
      ],
      "bbox_max": [
        -3566.85009765625,
        -4999.00048828125,
        966.846435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3163420362616307e-06,
        0.9201897978782654,
        0.3914725184440613
      ],
      "plane_d": 4223.494140625,
      "bbox_min": [
        -3566.860107421875,
        -5000.22412109375,
        961.8309326171875
      ],
      "bbox_max": [
        -3566.85009765625,
        -4999.00048828125,
        964.7073974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35355421900749207,
        0.6123719215393066,
        0.7071067690849304
      ],
      "plane_d": 1133.60546875,
      "bbox_min": [
        -3613.402587890625,
        -5014.95263671875,
        918.70703125
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.607249360968126e-07,
        -3.8147015857248334e-07,
        1.0
      ],
      "plane_d": -928.7113037109375,
      "bbox_min": [
        -3613.402587890625,
        -5014.95263671875,
        918.70703125
      ],
      "bbox_max": [
        -3600.447998046875,
        -5001.29248046875,
        928.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500000536441803,
        0.8660250902175903,
        0.0
      ],
      "plane_d": 2528.87158203125,
      "bbox_min": [
        -3613.402587890625,
        -5014.95263671875,
        918.70703125
      ],
      "bbox_max": [
        -3600.447998046875,
        -5001.29248046875,
        928.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35355332493782043,
        -0.6123725175857544,
        0.7071067690849304
      ],
      "plane_d": -2449.830322265625,
      "bbox_min": [
        -3613.402587890625,
        -5014.95263671875,
        918.70703125
      ],
      "bbox_max": [
        -3600.447998046875,
        -5001.29248046875,
        928.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35355377197265625,
        0.6123722195625305,
        -0.7071067690849304
      ],
      "plane_d": 2439.927734375,
      "bbox_min": [
        -3613.402587890625,
        -5014.95263671875,
        918.70703125
      ],
      "bbox_max": [
        -3600.447998046875,
        -5001.29248046875,
        928.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866025447845459,
        0.4999999403953552,
        0.0
      ],
      "plane_d": 5622.4443359375,
      "bbox_min": [
        -3611.902587890625,
        -5014.95263671875,
        918.70703125
      ],
      "bbox_max": [
        -3600.447998046875,
        -5001.29248046875,
        928.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500000536441803,
        -0.8660250902175903,
        0.0
      ],
      "plane_d": -2538.87158203125,
      "bbox_min": [
        -3611.902587890625,
        -5014.95263671875,
        918.70703125
      ],
      "bbox_max": [
        -3601.859619140625,
        -5007.1337890625,
        925.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 918.70703125,
      "bbox_min": [
        -3611.902587890625,
        -5014.95263671875,
        918.70703125
      ],
      "bbox_max": [
        -3605.859619140625,
        -5007.1337890625,
        921.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35355380177497864,
        -0.6123722791671753,
        -0.7071067690849304
      ],
      "plane_d": -1143.50830078125,
      "bbox_min": [
        -3609.902587890625,
        -5014.95263671875,
        918.70703125
      ],
      "bbox_max": [
        -3605.859619140625,
        -5011.75244140625,
        921.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.38268330693244934,
        0.9238795638084412
      ],
      "plane_d": -2809.01953125,
      "bbox_min": [
        -3586.0,
        -5009.00048828125,
        945.5668334960938
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9238795638084412,
        0.3826833665370941
      ],
      "plane_d": -4990.740234375,
      "bbox_min": [
        -3586.0,
        -5009.00048828125,
        945.5668334960938
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785983443260193,
        -0.6785983443260193,
        0.2810845673084259
      ],
      "plane_d": -1237.042724609375,
      "bbox_min": [
        -3586.0,
        -5009.00048828125,
        945.5668334960938
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785983443260193,
        -0.6785983443260193,
        0.28108468651771545
      ],
      "plane_d": -6097.16455078125,
      "bbox_min": [
        -3586.0,
        -5009.00048828125,
        945.5668334960938
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785986423492432,
        -0.2810845673084259,
        0.6785980463027954
      ],
      "plane_d": -4494.67041015625,
      "bbox_min": [
        -3586.0,
        -5009.00048828125,
        945.5668334960938
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 960.70703125,
      "bbox_min": [
        -3586.0,
        -5009.00048828125,
        945.5668334960938
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3586.0,
      "bbox_min": [
        -3586.0,
        -5001.00048828125,
        960.70703125
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        972.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9310113191604614,
        0.36499032378196716,
        0.0
      ],
      "plane_d": -1516.5748291015625,
      "bbox_min": [
        -3586.0,
        -5001.00048828125,
        960.70703125
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -972.70703125,
      "bbox_min": [
        -3586.0,
        -5001.00048828125,
        960.70703125
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6822128295898438,
        0.26300427317619324,
        0.6822128295898438
      ],
      "plane_d": -1795.044189453125,
      "bbox_min": [
        -3586.0,
        -5001.00048828125,
        960.70703125
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6863874197006226,
        0.26908883452415466,
        0.6756207942962646
      ],
      "plane_d": -1773.247802734375,
      "bbox_min": [
        -3586.0,
        -5001.00048828125,
        960.70703125
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785985827445984,
        -0.28108444809913635,
        0.678598165512085
      ],
      "plane_d": 365.453369140625,
      "bbox_min": [
        -3586.0,
        -5001.00048828125,
        960.70703125
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6893670558929443,
        -0.22258958220481873,
        0.6893670558929443
      ],
      "plane_d": 685.525146484375,
      "bbox_min": [
        -3586.0,
        -5001.00048828125,
        960.70703125
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        972.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3576.0,
      "bbox_min": [
        -3586.0,
        -5001.00048828125,
        960.70703125
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        969.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6785984635353088,
        0.28108394145965576,
        -0.6785984635353088
      ],
      "plane_d": -374.95556640625,
      "bbox_min": [
        -3586.0,
        -4997.00048828125,
        960.70703125
      ],
      "bbox_max": [
        -3576.0,
        -4989.00048828125,
        965.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 962.70703125,
      "bbox_min": [
        -3583.0,
        -4997.00048828125,
        960.70703125
      ],
      "bbox_max": [
        -3576.0,
        -4989.00048828125,
        965.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6893670558929443,
        -0.22258958220481873,
        -0.6893670558929443
      ],
      "plane_d": 2019.73583984375,
      "bbox_min": [
        -3579.0,
        -4996.17236328125,
        962.70703125
      ],
      "bbox_max": [
        -3576.0,
        -4989.00048828125,
        965.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6951999664306641,
        -0.25515511631965637,
        -0.6720066070556641
      ],
      "plane_d": 1861.33154296875,
      "bbox_min": [
        -3579.0,
        -4996.17236328125,
        962.70703125
      ],
      "bbox_max": [
        -3576.0,
        -4989.00048828125,
        965.1184692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785984039306641,
        0.6785984039306641,
        -0.2810843586921692
      ],
      "plane_d": 6087.6640625,
      "bbox_min": [
        -3578.171630859375,
        -4996.17236328125,
        962.70703125
      ],
      "bbox_max": [
        -3576.0,
        -4994.00048828125,
        964.2425537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38268256187438965,
        -0.9238799214363098
      ],
      "plane_d": 2799.777099609375,
      "bbox_min": [
        -3583.0,
        -4997.00048828125,
        960.70703125
      ],
      "bbox_max": [
        -3576.0,
        -4992.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785984039306641,
        0.6785984039306641,
        -0.2810843586921692
      ],
      "plane_d": 6087.6640625,
      "bbox_min": [
        -3583.0,
        -4996.8291015625,
        960.70703125
      ],
      "bbox_max": [
        -3576.171630859375,
        -4993.41455078125,
        962.1212158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9238796830177307,
        -0.38268303871154785
      ],
      "plane_d": 4981.501953125,
      "bbox_min": [
        -3583.0,
        -4994.00048828125,
        960.70703125
      ],
      "bbox_max": [
        -3581.82861328125,
        -4993.41455078125,
        962.1212158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 962.70703125,
      "bbox_min": [
        -3583.0,
        -4992.00048828125,
        962.70703125
      ],
      "bbox_max": [
        -3581.757080078125,
        -4989.00048828125,
        962.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516226053237915,
        -0.30726921558380127,
        0.0
      ],
      "plane_d": 1869.1143798828125,
      "bbox_min": [
        -3576.000244140625,
        -4992.00048828125,
        964.67138671875
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        969.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6893670558929443,
        -0.22258958220481873,
        -0.6893670558929443
      ],
      "plane_d": 2019.73583984375,
      "bbox_min": [
        -3576.000244140625,
        -4992.00048828125,
        964.67138671875
      ],
      "bbox_max": [
        -3575.031494140625,
        -4989.00048828125,
        965.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810850143432617,
        -0.6785970330238342,
        -0.67859947681427
      ],
      "plane_d": -1725.7353515625,
      "bbox_min": [
        -3576.000244140625,
        -4989.73291015625,
        964.67138671875
      ],
      "bbox_max": [
        -3575.031494140625,
        -4989.00048828125,
        965.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        -0.923879086971283,
        0.0
      ],
      "plane_d": -3241.7099609375,
      "bbox_min": [
        -3575.267822265625,
        -4989.73291015625,
        965.0726928710938
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        969.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        -0.923879086971283,
        0.0
      ],
      "plane_d": -3241.7099609375,
      "bbox_min": [
        -3576.000244140625,
        -4989.73291015625,
        968.1757202148438
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        970.74267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        -0.923879086971283,
        0.0
      ],
      "plane_d": -3241.7099609375,
      "bbox_min": [
        -3575.01806640625,
        -4989.62939453125,
        968.4495849609375
      ],
      "bbox_max": [
        -3573.5,
        -4989.00048828125,
        969.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3582.0,
      "bbox_min": [
        -3582.0,
        -5009.00048828125,
        945.5668334960938
      ],
      "bbox_max": [
        -3577.999755859375,
        -4999.00048828125,
        949.5670776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -949.5670776367188,
      "bbox_min": [
        -3582.0,
        -5009.00048828125,
        945.5668334960938
      ],
      "bbox_max": [
        -3577.999755859375,
        -4999.00048828125,
        949.5670776367188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4211.22216796875,
      "bbox_min": [
        -3582.0,
        -5009.00048828125,
        945.5668334960938
      ],
      "bbox_max": [
        -3577.999755859375,
        -4999.00048828125,
        949.5670776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2865.503173828125,
      "bbox_min": [
        -3582.0,
        -5009.00048828125,
        945.5668334960938
      ],
      "bbox_max": [
        -3577.999755859375,
        -4999.00048828125,
        949.5670776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5009.00048828125,
      "bbox_min": [
        -3582.0,
        -5009.00048828125,
        945.5668334960938
      ],
      "bbox_max": [
        -3580.999755859375,
        -4999.00048828125,
        946.5670776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4999.00048828125,
      "bbox_min": [
        -3582.0,
        -4999.00048828125,
        945.5668334960938
      ],
      "bbox_max": [
        -3580.999755859375,
        -4999.00048828125,
        946.5670776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.1444102483437746e-06,
        -1.982174808290438e-06,
        1.0
      ],
      "plane_d": -918.7129516601562,
      "bbox_min": [
        -3613.402587890625,
        -5037.12646484375,
        878.70703125
      ],
      "bbox_max": [
        -3533.976806640625,
        -4998.79248046875,
        967.7070922851562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.1444102483437746e-06,
        1.982174808290438e-06,
        -1.0
      ],
      "plane_d": 908.7129516601562,
      "bbox_min": [
        -3613.402587890625,
        -5037.12451171875,
        878.70703125
      ],
      "bbox_max": [
        -3533.976806640625,
        -4998.79248046875,
        918.7070922851562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.612371027469635,
        -0.3535545766353607,
        0.707107424736023
      ],
      "plane_d": -4596.1650390625,
      "bbox_min": [
        -3569.860107421875,
        -5037.12451171875,
        908.70703125
      ],
      "bbox_max": [
        -3533.976806640625,
        -5010.1513671875,
        918.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123725771903992,
        0.3535517156124115,
        0.7071075439453125
      ],
      "plane_d": 3294.07861328125,
      "bbox_min": [
        -3552.636962890625,
        -5032.47216796875,
        908.70703125
      ],
      "bbox_max": [
        -3533.976806640625,
        -5010.1513671875,
        918.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123709678649902,
        0.35355451703071594,
        -0.7071075439453125
      ],
      "plane_d": 4586.26513671875,
      "bbox_min": [
        -3552.636962890625,
        -5032.47216796875,
        908.70703125
      ],
      "bbox_max": [
        -3533.976806640625,
        -5010.1513671875,
        918.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.612372636795044,
        -0.3535517752170563,
        -0.707107424736023
      ],
      "plane_d": -3303.978515625,
      "bbox_min": [
        -3552.636962890625,
        -5032.47216796875,
        908.70703125
      ],
      "bbox_max": [
        -3533.976806640625,
        -5010.1513671875,
        918.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253286361694,
        -0.5000001192092896,
        0.0
      ],
      "plane_d": -5584.25,
      "bbox_min": [
        -3552.636962890625,
        -5032.47216796875,
        908.7070922851562
      ],
      "bbox_max": [
        -3533.976806640625,
        -5010.1513671875,
        918.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253286361694,
        0.5000001192092896,
        0.0
      ],
      "plane_d": 5574.25,
      "bbox_min": [
        -3552.636962890625,
        -5027.47216796875,
        908.7070922851562
      ],
      "bbox_max": [
        -3533.976806640625,
        -5010.1513671875,
        918.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999985098838806,
        0.8660262823104858,
        0.0
      ],
      "plane_d": 2566.939453125,
      "bbox_min": [
        -3552.636962890625,
        -5015.1513671875,
        908.7070922851562
      ],
      "bbox_max": [
        -3543.976806640625,
        -5010.1513671875,
        918.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -3.236878001189325e-06,
        0.7071067690849304
      ],
      "plane_d": -3171.791015625,
      "bbox_min": [
        -3569.860107421875,
        -5037.12451171875,
        908.70703125
      ],
      "bbox_max": [
        -3559.85986328125,
        -5027.12451171875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        1.0789593716253876e-06,
        0.7071067690849304
      ],
      "plane_d": 1869.7037353515625,
      "bbox_min": [
        -3569.860107421875,
        -5037.12451171875,
        908.70703125
      ],
      "bbox_max": [
        -3559.85986328125,
        -5027.12451171875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        3.236878001189325e-06,
        -0.7071067690849304
      ],
      "plane_d": 3161.8916015625,
      "bbox_min": [
        -3569.860107421875,
        -5037.12451171875,
        908.70703125
      ],
      "bbox_max": [
        -3559.85986328125,
        -5027.12451171875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -1.0789593716253876e-06,
        -0.7071067690849304
      ],
      "plane_d": -1879.603271484375,
      "bbox_min": [
        -3569.860107421875,
        -5037.12451171875,
        908.70703125
      ],
      "bbox_max": [
        -3559.85986328125,
        -5027.12451171875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -3.051757857974735e-06,
        0.0
      ],
      "plane_d": -3569.875244140625,
      "bbox_min": [
        -3569.860107421875,
        -5037.12451171875,
        908.70703125
      ],
      "bbox_max": [
        -3559.85986328125,
        -5027.12451171875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        3.051757857974735e-06,
        0.0
      ],
      "plane_d": 3559.875244140625,
      "bbox_min": [
        -3569.860107421875,
        -5037.12451171875,
        908.70703125
      ],
      "bbox_max": [
        -3559.85986328125,
        -5027.12451171875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5027.12451171875,
      "bbox_min": [
        -3569.860107421875,
        -5027.12451171875,
        908.70703125
      ],
      "bbox_max": [
        -3559.860107421875,
        -5027.12451171875,
        918.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3535534739494324,
        0.6123723983764648,
        0.7071067690849304
      ],
      "plane_d": 1161.894775390625,
      "bbox_min": [
        -3613.402587890625,
        -5014.95263671875,
        878.70703125
      ],
      "bbox_max": [
        -3595.412109375,
        -4998.79248046875,
        888.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35355350375175476,
        -0.6123723983764648,
        0.7071067690849304
      ],
      "plane_d": -2421.544677734375,
      "bbox_min": [
        -3613.402587890625,
        -5014.95263671875,
        878.70703125
      ],
      "bbox_max": [
        -3595.412109375,
        -4998.79248046875,
        888.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35355350375175476,
        -0.6123723983764648,
        -0.7071067690849304
      ],
      "plane_d": -1171.794189453125,
      "bbox_min": [
        -3613.402587890625,
        -5014.95263671875,
        878.70703125
      ],
      "bbox_max": [
        -3595.412109375,
        -4998.79248046875,
        888.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3535534739494324,
        0.6123723983764648,
        -0.7071067690849304
      ],
      "plane_d": 2411.645263671875,
      "bbox_min": [
        -3613.402587890625,
        -5014.95263671875,
        878.70703125
      ],
      "bbox_max": [
        -3595.412109375,
        -4998.79248046875,
        888.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000001192092896,
        0.8660253286361694,
        0.0
      ],
      "plane_d": 2528.87451171875,
      "bbox_min": [
        -3613.402587890625,
        -5014.95263671875,
        878.70703125
      ],
      "bbox_max": [
        -3595.412109375,
        -4998.79248046875,
        888.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000001192092896,
        -0.8660253286361694,
        0.0
      ],
      "plane_d": -2538.87451171875,
      "bbox_min": [
        -3611.902587890625,
        -5014.95263671875,
        878.70703125
      ],
      "bbox_max": [
        -3595.412109375,
        -4998.79248046875,
        888.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -888.70703125,
      "bbox_min": [
        -3611.902587890625,
        -5012.3544921875,
        878.70703125
      ],
      "bbox_max": [
        -3595.412109375,
        -4998.79248046875,
        888.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.4999999701976776,
        0.0
      ],
      "plane_d": 5617.4443359375,
      "bbox_min": [
        -3600.412109375,
        -5007.45263671875,
        878.70703125
      ],
      "bbox_max": [
        -3595.412109375,
        -4998.79248046875,
        888.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123718023300171,
        0.35355305671691895,
        -0.7071075439453125
      ],
      "plane_d": 230.84130859375,
      "bbox_min": [
        -3608.859619140625,
        -5037.12646484375,
        918.70703125
      ],
      "bbox_max": [
        -3559.0,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0172544762099278e-06,
        -1.7619308891880792e-06,
        -1.0
      ],
      "plane_d": 923.6945190429688,
      "bbox_min": [
        -3595.761962890625,
        -5037.12646484375,
        923.70703125
      ],
      "bbox_max": [
        -3559.0,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2875.402587890625,
      "bbox_min": [
        -3595.761962890625,
        -5037.12646484375,
        923.70703125
      ],
      "bbox_max": [
        -3559.0,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -3.01440195471514e-06
      ],
      "plane_d": 3559.863037109375,
      "bbox_min": [
        -3582.0,
        -5012.12451171875,
        939.5670776367188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4201.32275390625,
      "bbox_min": [
        -3582.0,
        -5012.12451171875,
        939.5670776367188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 939.5670776367188,
      "bbox_min": [
        -3582.0,
        -5012.12451171875,
        939.5670776367188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.5934445523355674e-12,
        1.0,
        1.88399985745491e-06
      ],
      "plane_d": 4998.99853515625,
      "bbox_min": [
        -3582.0,
        -5012.12451171875,
        939.5670776367188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.38268399238586426,
        0.0,
        -0.9238793253898621
      ],
      "plane_d": 2234.993896484375,
      "bbox_min": [
        -3582.0,
        -5012.12451171875,
        939.5670776367188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238789677619934,
        0.0,
        -0.3826847970485687
      ],
      "plane_d": 3653.08349609375,
      "bbox_min": [
        -3582.0,
        -5012.12451171875,
        939.5670776367188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810850143432617,
        -0.6785980463027954,
        -0.6785984635353088
      ],
      "plane_d": -1755.437744140625,
      "bbox_min": [
        -3582.0,
        -5012.12451171875,
        939.5670776367188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28108513355255127,
        0.6785980463027954,
        -0.6785984039306641
      ],
      "plane_d": 5035.97265625,
      "bbox_min": [
        -3582.0,
        -5012.12451171875,
        939.5670776367188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785981059074402,
        0.6785981059074402,
        -0.28108569979667664
      ],
      "plane_d": 6077.57373046875,
      "bbox_min": [
        -3582.0,
        -5012.12451171875,
        939.5670776367188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785982847213745,
        -0.6785982847213745,
        -0.28108489513397217
      ],
      "plane_d": -713.837890625,
      "bbox_min": [
        -3582.0,
        -5012.12451171875,
        939.5670776367188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3582.0,
      "bbox_min": [
        -3582.0,
        -5012.12451171875,
        939.5670776367188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        -3.4636941563803703e-06
      ],
      "plane_d": -1022.572265625,
      "bbox_min": [
        -3582.0,
        -5012.12451171875,
        942.5670776367188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.593447371261216e-12,
        -1.0,
        -1.8840013353838003e-06
      ],
      "plane_d": -5008.99853515625,
      "bbox_min": [
        -3582.0,
        -5009.9111328125,
        942.5670776367188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        967.7066650390625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6766842603683472,
        0.6766842603683472,
        0.2901670038700104
      ],
      "plane_d": 5514.5849609375,
      "bbox_min": [
        -3580.999755859375,
        -5009.00048828125,
        946.5670776367188
      ],
      "bbox_max": [
        -3559.860107421875,
        -4999.00048828125,
        967.7066650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3163420362616307e-06,
        0.9201897978782654,
        0.3914725184440613
      ],
      "plane_d": 4223.494140625,
      "bbox_min": [
        -3580.999755859375,
        -5009.00048828125,
        946.5670776367188
      ],
      "bbox_max": [
        -3562.860107421875,
        -4999.00048828125,
        964.6958618164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        3.463691427896265e-06
      ],
      "plane_d": 1012.6728515625,
      "bbox_min": [
        -3580.999755859375,
        -5009.00048828125,
        946.5670776367188
      ],
      "bbox_max": [
        -3566.860107421875,
        -4999.00048828125,
        960.7067260742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        7.993133408490394e-07
      ],
      "plane_d": -6064.0498046875,
      "bbox_min": [
        -3576.860107421875,
        -5009.00048828125,
        946.5670776367188
      ],
      "bbox_max": [
        -3566.860107421875,
        -5002.00048828125,
        960.7067260742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        3.0143996809783857e-06
      ],
      "plane_d": -3569.863037109375,
      "bbox_min": [
        -3571.85986328125,
        -5006.00048828125,
        949.6251220703125
      ],
      "bbox_max": [
        -3569.860107421875,
        -5002.00048828125,
        957.7067260742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238812327384949,
        0.0,
        0.382679283618927
      ],
      "plane_d": -3662.3251953125,
      "bbox_min": [
        -3571.85986328125,
        -5006.00048828125,
        949.6251220703125
      ],
      "bbox_max": [
        -3569.860107421875,
        -5002.00048828125,
        951.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268160820007324,
        0.0,
        0.9238802790641785
      ],
      "plane_d": -2244.22509765625,
      "bbox_min": [
        -3571.85986328125,
        -5005.37353515625,
        949.6251220703125
      ],
      "bbox_max": [
        -3570.48681640625,
        -5002.626953125,
        950.19384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268160820007324,
        0.0,
        0.9238802790641785
      ],
      "plane_d": -2244.22509765625,
      "bbox_min": [
        -3572.0,
        -5006.00048828125,
        949.5670776367188
      ],
      "bbox_max": [
        -3570.48681640625,
        -5004.0,
        950.19384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268160820007324,
        0.0,
        0.9238802790641785
      ],
      "plane_d": -2244.22509765625,
      "bbox_min": [
        -3572.0,
        -5006.00048828125,
        949.5670776367188
      ],
      "bbox_max": [
        -3570.278076171875,
        -5005.37353515625,
        950.6980590820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238812327384949,
        0.0,
        0.382679283618927
      ],
      "plane_d": -3662.3251953125,
      "bbox_min": [
        -3570.48681640625,
        -5006.00048828125,
        950.19384765625
      ],
      "bbox_max": [
        -3570.278076171875,
        -5005.37353515625,
        950.6980590820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785989999771118,
        -0.6785989999771118,
        0.28108134865760803
      ],
      "plane_d": -6087.0771484375,
      "bbox_min": [
        -3570.48681640625,
        -5009.00048828125,
        948.072509765625
      ],
      "bbox_max": [
        -3566.860107421875,
        -5005.58251953125,
        951.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238812327384949,
        0.0,
        0.382679283618927
      ],
      "plane_d": -3662.3251953125,
      "bbox_min": [
        -3570.48681640625,
        -5006.00048828125,
        950.19384765625
      ],
      "bbox_max": [
        -3569.860107421875,
        -5005.58251953125,
        951.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -949.5670776367188,
      "bbox_min": [
        -3577.999755859375,
        -5006.00048828125,
        949.5670776367188
      ],
      "bbox_max": [
        -3570.48681640625,
        -5002.00048828125,
        950.19384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38268160820007324,
        0.0,
        0.9238802790641785
      ],
      "plane_d": -2244.22509765625,
      "bbox_min": [
        -3572.0,
        -5004.14013671875,
        949.5670776367188
      ],
      "bbox_max": [
        -3570.48681640625,
        -5002.00048828125,
        950.19384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28108468651771545,
        0.6785979866981506,
        0.6785987019538879
      ],
      "plane_d": 1745.938232421875,
      "bbox_min": [
        -3572.0,
        -5002.626953125,
        946.5670776367188
      ],
      "bbox_max": [
        -3566.860107421875,
        -4999.00048828125,
        951.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268160820007324,
        0.0,
        0.9238802790641785
      ],
      "plane_d": -2244.22509765625,
      "bbox_min": [
        -3572.0,
        -5002.626953125,
        949.5670776367188
      ],
      "bbox_max": [
        -3570.278076171875,
        -5002.00048828125,
        950.69775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238812327384949,
        0.0,
        0.382679283618927
      ],
      "plane_d": -3662.3251953125,
      "bbox_min": [
        -3570.48681640625,
        -5002.626953125,
        950.19384765625
      ],
      "bbox_max": [
        -3570.278076171875,
        -5002.00048828125,
        950.69775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785982251167297,
        0.6785982251167297,
        0.281085342168808
      ],
      "plane_d": 704.3369140625,
      "bbox_min": [
        -3570.48681640625,
        -5002.41845703125,
        948.072509765625
      ],
      "bbox_max": [
        -3566.860107421875,
        -4999.00048828125,
        951.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238812327384949,
        0.0,
        0.382679283618927
      ],
      "plane_d": -3662.3251953125,
      "bbox_min": [
        -3570.48681640625,
        -5002.41845703125,
        950.19384765625
      ],
      "bbox_max": [
        -3569.860107421875,
        -5002.00048828125,
        951.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6800235509872437,
        0.6746742129325867,
        0.2870238423347473
      ],
      "plane_d": 5519.45703125,
      "bbox_min": [
        -3562.870849609375,
        -5003.28857421875,
        961.8309326171875
      ],
      "bbox_max": [
        -3560.721923828125,
        -4999.00048828125,
        966.8448486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3163420362616307e-06,
        0.9201897978782654,
        0.3914725184440613
      ],
      "plane_d": 4223.494140625,
      "bbox_min": [
        -3562.870849609375,
        -5000.2236328125,
        961.8309326171875
      ],
      "bbox_max": [
        -3562.860107421875,
        -4999.00048828125,
        964.7066650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2978983932043775e-06,
        -0.9072967171669006,
        -0.42049095034599304
      ],
      "plane_d": -4140.2041015625,
      "bbox_min": [
        -3565.73583984375,
        -5009.9111328125,
        961.8309326171875
      ],
      "bbox_max": [
        -3562.860107421875,
        -5009.00048828125,
        963.7958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6816338896751404,
        -0.6700702905654907,
        -0.29390645027160645
      ],
      "plane_d": -645.162841796875,
      "bbox_min": [
        -3563.77099609375,
        -5012.12451171875,
        961.8309326171875
      ],
      "bbox_max": [
        -3559.860107421875,
        -5006.00048828125,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6719455718994141,
        -0.6719455718994141,
        -0.31141334772109985
      ],
      "plane_d": -672.20068359375,
      "bbox_min": [
        -3563.77099609375,
        -5010.630859375,
        961.8309326171875
      ],
      "bbox_max": [
        -3559.860107421875,
        -5006.00048828125,
        964.159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2978983932043775e-06,
        -0.9072967171669006,
        -0.42049095034599304
      ],
      "plane_d": -4140.2041015625,
      "bbox_min": [
        -3563.77099609375,
        -5010.630859375,
        961.8309326171875
      ],
      "bbox_max": [
        -3562.860107421875,
        -5009.00048828125,
        964.159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.565583703377342e-07,
        -0.34422567486763,
        -0.9388869404792786
      ],
      "plane_d": -819.5487060546875,
      "bbox_min": [
        -3563.65087890625,
        -5010.630859375,
        963.916015625
      ],
      "bbox_max": [
        -3562.860107421875,
        -5009.966796875,
        964.159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6844790577888489,
        -0.2509519159793854,
        -0.6844790577888489
      ],
      "plane_d": 1841.22265625,
      "bbox_min": [
        -3563.407470703125,
        -5012.12451171875,
        963.916015625
      ],
      "bbox_max": [
        -3559.860107421875,
        -5007.84521484375,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6753687858581543,
        -0.26809239387512207,
        -0.6870250701904297
      ],
      "plane_d": 1725.3448486328125,
      "bbox_min": [
        -3562.860107421875,
        -5012.12451171875,
        963.916015625
      ],
      "bbox_max": [
        -3559.860107421875,
        -5007.84521484375,
        967.7070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123719811439514,
        -0.3535527288913727,
        0.7071075439453125
      ],
      "plane_d": -240.73828125,
      "bbox_min": [
        -3595.761962890625,
        -5037.12646484375,
        923.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123701930046082,
        -0.3535558581352234,
        -0.7071075439453125
      ],
      "plane_d": 1072.630859375,
      "bbox_min": [
        -3595.761962890625,
        -5032.5419921875,
        923.70703125
      ],
      "bbox_max": [
        -3579.6015625,
        -5014.5517578125,
        933.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123701333999634,
        0.3535558581352234,
        0.7071074843406677
      ],
      "plane_d": -1082.5301513671875,
      "bbox_min": [
        -3595.761962890625,
        -5032.5419921875,
        923.70703125
      ],
      "bbox_max": [
        -3579.6015625,
        -5014.5517578125,
        933.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866024374961853,
        -0.5000017881393433,
        0.0
      ],
      "plane_d": 590.237548828125,
      "bbox_min": [
        -3595.761962890625,
        -5032.5419921875,
        923.70703125
      ],
      "bbox_max": [
        -3579.6015625,
        -5014.5517578125,
        933.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.271568180527538e-06,
        2.2024137251719367e-06,
        1.0
      ],
      "plane_d": -933.6913452148438,
      "bbox_min": [
        -3595.761962890625,
        -5031.0419921875,
        923.70703125
      ],
      "bbox_max": [
        -3579.6015625,
        -5014.5517578125,
        933.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866024374961853,
        0.500001847743988,
        0.0
      ],
      "plane_d": -600.2373046875,
      "bbox_min": [
        -3595.761962890625,
        -5027.5419921875,
        923.70703125
      ],
      "bbox_max": [
        -3579.6015625,
        -5014.5517578125,
        933.7069702148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999871850013733,
        0.8660261631011963,
        0.0
      ],
      "plane_d": 6136.859375,
      "bbox_min": [
        -3588.261962890625,
        -5019.5517578125,
        923.70703125
      ],
      "bbox_max": [
        -3579.6015625,
        -5014.5517578125,
        933.7069702148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -5.077012588117213e-07,
        0.7071067690849304
      ],
      "plane_d": 1848.5816650390625,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        948.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -5.077014293419779e-07,
        0.7071067690849304
      ],
      "plane_d": -3193.08935546875,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        948.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -6.847365014404916e-13,
        -7.179982617344649e-07,
        1.0
      ],
      "plane_d": -948.7106323242188,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        948.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.3826830983161926,
        0.9238796830177307
      ],
      "plane_d": 1047.065673828125,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        948.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9238795638084412,
        0.38268330693244934
      ],
      "plane_d": 4274.33203125,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        948.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6785983443260193,
        0.6785983443260193,
        0.2810845971107483
      ],
      "plane_d": 5557.3837890625,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        948.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6785983443260193,
        0.6785983443260193,
        0.2810845375061035
      ],
      "plane_d": 718.977294921875,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        948.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6785985827445984,
        0.28108441829681396,
        0.678598165512085
      ],
      "plane_d": 3186.9267578125,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        948.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6785985827445984,
        0.2810843288898468,
        0.6785982251167297
      ],
      "plane_d": -1651.4814453125,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        948.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 926.70703125,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        945.70703125
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.7071069478988647,
        0.7071065902709961,
        -0.0
      ],
      "plane_d": 6064.20849609375,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        945.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071069478988647,
        0.7071065902709961,
        0.0
      ],
      "plane_d": 1022.5361328125,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        945.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5013.50048828125,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        945.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3559.0,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        945.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3571.0,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        945.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 6065.20849609375,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        945.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5014.50048828125,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5013.50048828125,
        945.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1023.53759765625,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5014.50048828125,
        945.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3560.0,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5017.50048828125,
        945.70703125
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3570.0,
      "bbox_min": [
        -3571.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5017.50048828125,
        945.70703125
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.7071067690849304,
        5.077012588117213e-07,
        -0.7071067690849304
      ],
      "plane_d": 3183.18994140625,
      "bbox_min": [
        -3570.0,
        -5037.12646484375,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5021.50048828125,
        941.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        5.077014293419779e-07,
        -0.7071067690849304
      ],
      "plane_d": -1858.481201171875,
      "bbox_min": [
        -3570.0,
        -5037.12646484375,
        931.7072143554688
      ],
      "bbox_max": [
        -3563.0,
        -5021.50048828125,
        941.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        6.847362846000571e-13,
        7.179980343607895e-07,
        -1.0
      ],
      "plane_d": 938.7106323242188,
      "bbox_min": [
        -3567.0,
        -5037.12646484375,
        936.70703125
      ],
      "bbox_max": [
        -3563.0,
        -5024.50048828125,
        938.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.38268133997917175,
        0.923880398273468
      ],
      "plane_d": 1056.294921875,
      "bbox_min": [
        -3567.0,
        -5026.50048828125,
        936.70703125
      ],
      "bbox_max": [
        -3563.0,
        -5024.50048828125,
        938.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.923879861831665,
        -0.38268259167671204
      ],
      "plane_d": -4283.5732421875,
      "bbox_min": [
        -3566.414306640625,
        -5025.08642578125,
        936.70703125
      ],
      "bbox_max": [
        -3563.585693359375,
        -5024.50048828125,
        938.1212768554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 6075.1083984375,
      "bbox_min": [
        -3570.0,
        -5026.50048828125,
        931.7072143554688
      ],
      "bbox_max": [
        -3565.000244140625,
        -5021.50048828125,
        941.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6785978078842163,
        -0.2810850739479065,
        -0.6785987019538879
      ],
      "plane_d": -3196.42724609375,
      "bbox_min": [
        -3570.0,
        -5026.50048828125,
        936.70703125
      ],
      "bbox_max": [
        -3566.414306640625,
        -5021.50048828125,
        941.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.38268133997917175,
        -0.923880398273468
      ],
      "plane_d": -1056.294921875,
      "bbox_min": [
        -3567.0,
        -5026.50048828125,
        937.6499633789062
      ],
      "bbox_max": [
        -3566.414306640625,
        -5024.89111328125,
        938.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.923879861831665,
        -0.38268259167671204
      ],
      "plane_d": -4283.5732421875,
      "bbox_min": [
        -3567.0,
        -5025.08642578125,
        937.6499633789062
      ],
      "bbox_max": [
        -3566.414306640625,
        -5024.89111328125,
        938.1212768554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6785983443260193,
        -0.6785983443260193,
        -0.28108471632003784
      ],
      "plane_d": -5566.8837890625,
      "bbox_min": [
        -3570.0,
        -5025.08642578125,
        936.70703125
      ],
      "bbox_max": [
        -3566.609619140625,
        -5021.50048828125,
        940.2425537109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.923879861831665,
        -0.38268259167671204
      ],
      "plane_d": -4283.5732421875,
      "bbox_min": [
        -3567.0,
        -5025.08642578125,
        936.70703125
      ],
      "bbox_max": [
        -3566.609619140625,
        -5024.50048828125,
        938.1212768554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5024.50048828125,
      "bbox_min": [
        -3567.0,
        -5025.08642578125,
        934.7072143554688
      ],
      "bbox_max": [
        -3565.000244140625,
        -5024.50048828125,
        938.1212768554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.923879861831665,
        -0.38268259167671204
      ],
      "plane_d": -4283.5732421875,
      "bbox_min": [
        -3567.0,
        -5025.08642578125,
        936.70703125
      ],
      "bbox_max": [
        -3565.000244140625,
        -5024.50048828125,
        938.1212768554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071069478988647,
        -0.7071065902709961,
        0.0
      ],
      "plane_d": -6076.10791015625,
      "bbox_min": [
        -3570.0,
        -5026.50048828125,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5021.50048828125,
        941.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 6075.1083984375,
      "bbox_min": [
        -3570.0,
        -5026.50048828125,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5021.50048828125,
        941.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -927.70703125,
      "bbox_min": [
        -3570.0,
        -5025.50048828125,
        926.70703125
      ],
      "bbox_max": [
        -3566.000244140625,
        -5021.50048828125,
        927.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5025.50048828125,
      "bbox_min": [
        -3567.414306640625,
        -5025.50048828125,
        926.70703125
      ],
      "bbox_max": [
        -3566.000244140625,
        -5025.50048828125,
        927.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1033.43701171875,
      "bbox_min": [
        -3567.0,
        -5026.50048828125,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5021.50048828125,
        941.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5024.50048828125,
      "bbox_min": [
        -3567.0,
        -5025.50048828125,
        926.70703125
      ],
      "bbox_max": [
        -3563.0,
        -5024.50048828125,
        938.1212768554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -927.70703125,
      "bbox_min": [
        -3567.0,
        -5025.50048828125,
        926.70703125
      ],
      "bbox_max": [
        -3563.0,
        -5024.50048828125,
        938.1212768554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5025.50048828125,
      "bbox_min": [
        -3566.000244140625,
        -5025.50048828125,
        926.70703125
      ],
      "bbox_max": [
        -3563.999755859375,
        -5025.50048828125,
        927.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.923879861831665,
        -0.38268259167671204
      ],
      "plane_d": -4283.5732421875,
      "bbox_min": [
        -3565.000244140625,
        -5025.08642578125,
        936.70703125
      ],
      "bbox_max": [
        -3563.0,
        -5024.50048828125,
        938.1212768554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -927.70703125,
      "bbox_min": [
        -3563.999755859375,
        -5026.50048828125,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5021.50048828125,
        941.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071069478988647,
        -0.7071065902709961,
        0.0
      ],
      "plane_d": -1034.435302734375,
      "bbox_min": [
        -3563.999755859375,
        -5025.50048828125,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5022.91455078125,
        927.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5025.50048828125,
      "bbox_min": [
        -3563.999755859375,
        -5025.50048828125,
        926.70703125
      ],
      "bbox_max": [
        -3562.585693359375,
        -5025.50048828125,
        927.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785973906517029,
        -0.28108343482017517,
        -0.6785997748374939
      ],
      "plane_d": 1641.98291015625,
      "bbox_min": [
        -3563.585693359375,
        -5026.50048828125,
        936.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5021.50048828125,
        941.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.38268133997917175,
        -0.923880398273468
      ],
      "plane_d": -1056.294921875,
      "bbox_min": [
        -3563.585693359375,
        -5026.50048828125,
        937.64990234375
      ],
      "bbox_max": [
        -3563.0,
        -5024.89111328125,
        938.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.923879861831665,
        -0.38268259167671204
      ],
      "plane_d": -4283.5732421875,
      "bbox_min": [
        -3563.585693359375,
        -5025.08642578125,
        937.64990234375
      ],
      "bbox_max": [
        -3563.0,
        -5024.89111328125,
        938.1212768554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6785984635353088,
        -0.6785984635353088,
        -0.28108400106430054
      ],
      "plane_d": -728.478515625,
      "bbox_min": [
        -3563.390380859375,
        -5025.08642578125,
        936.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5021.50048828125,
        940.2425537109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -927.70703125,
      "bbox_min": [
        -3571.0,
        -5022.91455078125,
        926.70703125
      ],
      "bbox_max": [
        -3570.0,
        -5017.50048828125,
        927.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071069478988647,
        -0.7071065902709961,
        0.0
      ],
      "plane_d": -6076.10791015625,
      "bbox_min": [
        -3571.0,
        -5022.91455078125,
        926.70703125
      ],
      "bbox_max": [
        -3570.0,
        -5021.91455078125,
        927.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -927.70703125,
      "bbox_min": [
        -3560.0,
        -5022.91455078125,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5017.50048828125,
        927.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071069478988647,
        -0.7071065902709961,
        0.0
      ],
      "plane_d": -1034.435302734375,
      "bbox_min": [
        -3560.0,
        -5022.91455078125,
        926.70703125
      ],
      "bbox_max": [
        -3559.0,
        -5021.91455078125,
        927.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -927.70703125,
      "bbox_min": [
        -3568.414306640625,
        -5014.50048828125,
        927.70703125
      ],
      "bbox_max": [
        -3563.0,
        -5013.50048828125,
        927.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.866025447845459,
        0.4999999403953552,
        0.0
      ],
      "plane_d": 5622.4443359375,
      "bbox_min": [
        -3608.859619140625,
        -5013.484375,
        918.70703125
      ],
      "bbox_max": [
        -3599.7421875,
        -5001.29248046875,
        927.1187744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500000536441803,
        -0.8660250902175903,
        0.0
      ],
      "plane_d": -2538.87158203125,
      "bbox_min": [
        -3608.859619140625,
        -5013.484375,
        918.70703125
      ],
      "bbox_max": [
        -3599.7421875,
        -5001.29248046875,
        927.1187744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35355377197265625,
        0.6123722195625305,
        -0.7071067690849304
      ],
      "plane_d": 2439.927734375,
      "bbox_min": [
        -3608.859619140625,
        -5011.17529296875,
        918.70703125
      ],
      "bbox_max": [
        -3599.7421875,
        -5001.29248046875,
        927.1187744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35355332493782043,
        -0.6123725175857544,
        0.7071067690849304
      ],
      "plane_d": -2449.830322265625,
      "bbox_min": [
        -3605.860107421875,
        -5011.17529296875,
        921.70703125
      ],
      "bbox_max": [
        -3599.7421875,
        -5001.29248046875,
        927.1187744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500000536441803,
        0.8660250902175903,
        0.0
      ],
      "plane_d": 2528.87158203125,
      "bbox_min": [
        -3605.860107421875,
        -5001.93798828125,
        921.70703125
      ],
      "bbox_max": [
        -3604.7421875,
        -5001.29248046875,
        922.824951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -1819.2393798828125,
      "bbox_min": [
        -3546.0,
        -5014.83154296875,
        970.20703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4989.00048828125,
        989.9418334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -3198.390380859375,
      "bbox_min": [
        -3546.0,
        -5014.83154296875,
        970.20703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4989.00048828125,
        989.9418334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 970.20703125,
      "bbox_min": [
        -3546.0,
        -5014.83154296875,
        970.20703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4989.00048828125,
        989.9418334960938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3546.0,
      "bbox_min": [
        -3546.0,
        -5014.83154296875,
        970.20703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4989.00048828125,
        989.9418334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3536.0,
      "bbox_min": [
        -3546.0,
        -5014.83154296875,
        970.20703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4989.00048828125,
        989.9418334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3188.490966796875,
      "bbox_min": [
        -3546.0,
        -5009.00048828125,
        970.20703125
      ],
      "bbox_max": [
        -3536.0,
        -4989.00048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -980.20703125,
      "bbox_min": [
        -3546.0,
        -5009.00048828125,
        970.20703125
      ],
      "bbox_max": [
        -3536.0,
        -4989.00048828125,
        980.20703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": 1809.33984375,
      "bbox_min": [
        -3546.0,
        -5009.00048828125,
        970.20703125
      ],
      "bbox_max": [
        -3536.0,
        -4989.00048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5009.00048828125,
      "bbox_min": [
        -3546.0,
        -5009.00048828125,
        970.20703125
      ],
      "bbox_max": [
        -3536.0,
        -4989.00048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785984635353088,
        0.28108397126197815,
        0.6785984635353088
      ],
      "plane_d": -1665.989013671875,
      "bbox_min": [
        -3546.0,
        -4993.00048828125,
        970.20703125
      ],
      "bbox_max": [
        -3541.343017578125,
        -4989.00048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785982251167297,
        0.28108522295951843,
        -0.6785982251167297
      ],
      "plane_d": -342.43408203125,
      "bbox_min": [
        -3546.0,
        -4993.00048828125,
        970.20703125
      ],
      "bbox_max": [
        -3541.343017578125,
        -4989.00048828125,
        977.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923879861831665,
        0.38268256187438965,
        0.0
      ],
      "plane_d": -1365.3436279296875,
      "bbox_min": [
        -3546.0,
        -4993.00048828125,
        973.20703125
      ],
      "bbox_max": [
        -3544.343017578125,
        -4989.00048828125,
        977.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785981059074402,
        -0.28108593821525574,
        0.6785981059074402
      ],
      "plane_d": 332.9296875,
      "bbox_min": [
        -3539.0,
        -4993.00048828125,
        977.20703125
      ],
      "bbox_max": [
        -3536.0,
        -4989.00048828125,
        980.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785984635353088,
        -0.28108394145965576,
        -0.6785984635353088
      ],
      "plane_d": 1656.48876953125,
      "bbox_min": [
        -3539.0,
        -4993.00048828125,
        970.20703125
      ],
      "bbox_max": [
        -3536.0,
        -4989.00048828125,
        973.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999433755874634,
        0.8660286664962769,
        0.0
      ],
      "plane_d": 6093.66162109375,
      "bbox_min": [
        -3536.0,
        -5014.83154296875,
        971.55029296875
      ],
      "bbox_max": [
        -3511.800048828125,
        -4989.00048828125,
        989.9418334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3535535931587219,
        -0.6123723387718201,
        -0.7071067690849304
      ],
      "plane_d": -3624.95361328125,
      "bbox_min": [
        -3530.0478515625,
        -5014.83154296875,
        974.20703125
      ],
      "bbox_max": [
        -3516.387451171875,
        -5001.17138671875,
        984.2070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3535451889038086,
        -0.6123772263526917,
        0.7071067690849304
      ],
      "plane_d": -5009.75634765625,
      "bbox_min": [
        -3530.0478515625,
        -5014.83154296875,
        974.20703125
      ],
      "bbox_max": [
        -3516.387451171875,
        -5001.17138671875,
        984.2070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3535535931587219,
        0.6123722791671753,
        0.7071067690849304
      ],
      "plane_d": 3615.053955078125,
      "bbox_min": [
        -3530.0478515625,
        -5014.83154296875,
        974.20703125
      ],
      "bbox_max": [
        -3516.387451171875,
        -5001.17138671875,
        984.2070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3535451889038086,
        0.6123771667480469,
        -0.7071067690849304
      ],
      "plane_d": 4999.8564453125,
      "bbox_min": [
        -3530.0478515625,
        -5014.83154296875,
        974.20703125
      ],
      "bbox_max": [
        -3516.387451171875,
        -5001.17138671875,
        984.2070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999430775642395,
        -0.8660286664962769,
        0.0
      ],
      "plane_d": -6103.66162109375,
      "bbox_min": [
        -3530.0478515625,
        -5014.83154296875,
        974.20703125
      ],
      "bbox_max": [
        -3517.887451171875,
        -5001.17138671875,
        984.2070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.946554665570147e-06,
        -3.4331887945882045e-06,
        1.0
      ],
      "plane_d": -984.2033081054688,
      "bbox_min": [
        -3530.0478515625,
        -5012.2333984375,
        974.20703125
      ],
      "bbox_max": [
        -3517.887451171875,
        -5001.17138671875,
        984.2070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -5.946554665570147e-06,
        3.4331887945882045e-06,
        -1.0
      ],
      "plane_d": 974.2033081054688,
      "bbox_min": [
        -3530.0478515625,
        -5012.2333984375,
        974.20703125
      ],
      "bbox_max": [
        -3517.887451171875,
        -5001.17138671875,
        984.2070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        0.5000000596046448,
        0.0
      ],
      "plane_d": -552.195068359375,
      "bbox_min": [
        -3530.0478515625,
        -5009.83154296875,
        974.2070922851562
      ],
      "bbox_max": [
        -3525.0478515625,
        -5001.17138671875,
        984.2070922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10923247784376144,
        -0.0,
        -0.9940162301063538
      ],
      "plane_d": 600.1822509765625,
      "bbox_min": [
        -3536.0,
        -4998.2353515625,
        971.55029296875
      ],
      "bbox_max": [
        -3511.800048828125,
        -4989.00048828125,
        989.9418334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4998.2353515625,
      "bbox_min": [
        -3513.936767578125,
        -4998.2353515625,
        989.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4998.2353515625,
        989.9418334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785981059074402,
        -0.28108593821525574,
        0.6785981059074402
      ],
      "plane_d": 332.9296875,
      "bbox_min": [
        -3536.0,
        -4993.00048828125,
        971.55029296875
      ],
      "bbox_max": [
        -3532.0,
        -4989.00048828125,
        978.8639526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785984635353088,
        -0.28108394145965576,
        -0.6785984635353088
      ],
      "plane_d": 1656.48876953125,
      "bbox_min": [
        -3536.0,
        -4993.00048828125,
        971.55029296875
      ],
      "bbox_max": [
        -3534.343017578125,
        -4989.00048828125,
        973.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810846269130707,
        -0.6785991787910461,
        -0.6785975694656372
      ],
      "plane_d": -1732.324951171875,
      "bbox_min": [
        -3536.0,
        -4990.171875,
        971.55029296875
      ],
      "bbox_max": [
        -3534.343017578125,
        -4989.00048828125,
        973.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268303871154785,
        -0.9238796830177307,
        0.0
      ],
      "plane_d": -3257.599609375,
      "bbox_min": [
        -3534.828369140625,
        -4990.171875,
        972.236572265625
      ],
      "bbox_max": [
        -3532.0,
        -4989.00048828125,
        977.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268303871154785,
        -0.9238796830177307,
        0.0
      ],
      "plane_d": -3257.599609375,
      "bbox_min": [
        -3534.828369140625,
        -4990.171875,
        974.8641967773438
      ],
      "bbox_max": [
        -3532.0,
        -4989.00048828125,
        977.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660262823104858,
        -0.4999984800815582,
        0.0
      ],
      "plane_d": 648.45263671875,
      "bbox_min": [
        -3618.0517578125,
        -5054.62646484375,
        993.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3618.0517578125,
      "bbox_min": [
        -3618.0517578125,
        -5054.62646484375,
        993.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8401682376861572,
        -0.4850711226463318,
        -0.2425353229045868
      ],
      "plane_d": -5115.33251953125,
      "bbox_min": [
        -3618.0517578125,
        -5054.62646484375,
        993.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8401679992675781,
        0.4850712716579437,
        -0.24253566563129425
      ],
      "plane_d": -280.141357421875,
      "bbox_min": [
        -3618.0517578125,
        -5054.62646484375,
        993.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8401690125465393,
        -0.48506954312324524,
        -0.2425357550382614
      ],
      "plane_d": 874.953125,
      "bbox_min": [
        -3618.0517578125,
        -5054.62646484375,
        993.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8401692509651184,
        0.4850693941116333,
        -0.24253517389297485
      ],
      "plane_d": 5710.126953125,
      "bbox_min": [
        -3618.0517578125,
        -5054.62646484375,
        993.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        0.0,
        -0.24253562092781067
      ],
      "plane_d": 3755.8857421875,
      "bbox_min": [
        -3618.0517578125,
        -5054.62646484375,
        993.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.0,
        -0.24253562092781067
      ],
      "plane_d": -3161.08642578125,
      "bbox_min": [
        -3613.0517578125,
        -5054.62646484375,
        993.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866025447845459,
        -0.4999999403953552,
        -0.0
      ],
      "plane_d": -5526.1904296875,
      "bbox_min": [
        -3613.0517578125,
        -5054.62646484375,
        993.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253286361694,
        0.5000001192092896,
        0.0
      ],
      "plane_d": -542.189697265625,
      "bbox_min": [
        -3613.0517578125,
        -5054.62646484375,
        993.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.679792601156805e-07,
        1.0,
        0.0
      ],
      "plane_d": 5037.12744140625,
      "bbox_min": [
        -3613.0517578125,
        -5054.62646484375,
        993.70703125
      ],
      "bbox_max": [
        -3516.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1008.70703125,
      "bbox_min": [
        -3581.6611328125,
        -5054.62646484375,
        993.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -5037.12646484375,
        1008.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.679792601156805e-07,
        1.0,
        0.0
      ],
      "plane_d": 5052.12744140625,
      "bbox_min": [
        -3581.6611328125,
        -5054.62646484375,
        993.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -5037.12646484375,
        1008.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.679792601156805e-07,
        1.0,
        0.0
      ],
      "plane_d": 5054.62744140625,
      "bbox_min": [
        -3581.660888671875,
        -5054.62646484375,
        997.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -5052.12646484375,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1003.70703125,
      "bbox_min": [
        -3581.660888671875,
        -5054.62646484375,
        997.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -5052.12646484375,
        1003.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.1596301163763201e-07,
        0.4327313005924225,
        0.9015229344367981
      ],
      "plane_d": 1286.7579345703125,
      "bbox_min": [
        -3581.660888671875,
        -5054.62646484375,
        997.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -5052.12646484375,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071051597595215,
        0.7071083784103394,
        0.0
      ],
      "plane_d": 6105.01171875,
      "bbox_min": [
        -3581.660888671875,
        -5054.62646484375,
        997.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -5052.12646484375,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1063.443115234375,
      "bbox_min": [
        -3581.660888671875,
        -5054.62646484375,
        997.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -5052.12646484375,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.397142231464386,
        0.397142231464386,
        0.827379047870636
      ],
      "plane_d": -229.1983642578125,
      "bbox_min": [
        -3581.660888671875,
        -5054.62646484375,
        997.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -5052.12646484375,
        998.9070434570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3971363604068756,
        0.39714330434799194,
        0.8273813724517822
      ],
      "plane_d": 2602.348876953125,
      "bbox_min": [
        -3581.660888671875,
        -5054.62646484375,
        997.70703125
      ],
      "bbox_max": [
        -3579.160888671875,
        -5052.12646484375,
        998.9070434570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.4881248350538954e-07,
        0.9284766912460327,
        -0.3713906705379486
      ],
      "plane_d": 5063.55029296875,
      "bbox_min": [
        -3581.6611328125,
        -5052.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -5037.12646484375,
        1008.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        4.069012447871501e-06,
        6.467476294097496e-12
      ],
      "plane_d": 3581.681640625,
      "bbox_min": [
        -3581.6611328125,
        -5052.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -5037.12646484375,
        1008.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3548.19091796875,
      "bbox_min": [
        -3581.6611328125,
        -5052.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -5037.12646484375,
        1008.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3579.160888671875,
      "bbox_min": [
        -3581.6611328125,
        -5052.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -5037.12646484375,
        1008.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4327256977558136,
        1.760766281222459e-06,
        0.901525616645813
      ],
      "plane_d": 649.3453979492188,
      "bbox_min": [
        -3581.6611328125,
        -5052.12646484375,
        997.70703125
      ],
      "bbox_max": [
        -3579.160888671875,
        -5037.12646484375,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.10351571594947e-06,
        -2.4835281400847897e-11,
        -1.0
      ],
      "plane_d": 1003.6851806640625,
      "bbox_min": [
        -3581.6611328125,
        -5052.12646484375,
        1003.70703125
      ],
      "bbox_max": [
        -3579.160888671875,
        -5037.12646484375,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3550.69091796875,
      "bbox_min": [
        -3550.69091796875,
        -5052.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -5037.12646484375,
        1008.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4327313005924225,
        0.0,
        0.9015229344367981
      ],
      "plane_d": -2435.950927734375,
      "bbox_min": [
        -3550.69091796875,
        -5052.12646484375,
        997.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -5037.12646484375,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1003.70703125,
      "bbox_min": [
        -3550.69091796875,
        -5052.12646484375,
        1003.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -5037.12646484375,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48507094383239746,
        0.8401681780815125,
        -0.2425357848405838
      ],
      "plane_d": 6214.04052734375,
      "bbox_min": [
        -3613.0517578125,
        -5037.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3516.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.869884099254705e-07,
        0.9701424837112427,
        -0.24253560602664948
      ],
      "plane_d": 5132.59130859375,
      "bbox_min": [
        -3613.0517578125,
        -5037.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3516.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4850715100765228,
        0.8401678204536438,
        -0.24253585934638977
      ],
      "plane_d": 2755.552978515625,
      "bbox_min": [
        -3613.0517578125,
        -5037.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3516.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5,
        0.8660253882408142,
        0.0
      ],
      "plane_d": 6151.85986328125,
      "bbox_min": [
        -3613.0517578125,
        -5037.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3516.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000002384185791,
        0.8660252690315247,
        0.0
      ],
      "plane_d": 2586.9326171875,
      "bbox_min": [
        -3613.0517578125,
        -5037.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3516.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -5.35958520231361e-07,
        -1.0,
        -0.0
      ],
      "plane_d": -4930.87646484375,
      "bbox_min": [
        -3613.0517578125,
        -5032.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3516.800048828125,
        -4913.37451171875,
        1033.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1008.70703125,
      "bbox_min": [
        -3581.6611328125,
        -4930.87451171875,
        993.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -4913.37451171875,
        1008.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.35958520231361e-07,
        -1.0,
        0.0
      ],
      "plane_d": -4915.87255859375,
      "bbox_min": [
        -3581.6611328125,
        -4930.87451171875,
        993.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -4913.37451171875,
        1008.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.35958520231361e-07,
        -1.0,
        0.0
      ],
      "plane_d": -4913.37255859375,
      "bbox_min": [
        -3581.660888671875,
        -4915.87451171875,
        997.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -4913.37451171875,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1003.70703125,
      "bbox_min": [
        -3581.660888671875,
        -4915.87451171875,
        997.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -4913.37451171875,
        1003.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        2.3192602327526401e-07,
        -0.4327313005924225,
        0.9015229344367981
      ],
      "plane_d": -3026.707763671875,
      "bbox_min": [
        -3581.660888671875,
        -4915.87451171875,
        997.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -4913.37451171875,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071056962013245,
        -0.7071078419685364,
        1.123909783018462e-06
      ],
      "plane_d": -943.44189453125,
      "bbox_min": [
        -3581.660888671875,
        -4915.87451171875,
        997.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -4913.37451171875,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -5984.998046875,
      "bbox_min": [
        -3581.660888671875,
        -4915.87451171875,
        997.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -4913.37451171875,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.397142231464386,
        -0.397142231464386,
        0.827379047870636
      ],
      "plane_d": -4187.91259765625,
      "bbox_min": [
        -3581.660888671875,
        -4915.87451171875,
        997.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -4913.37451171875,
        998.9070434570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.397135853767395,
        -0.3971433937549591,
        0.8273815512657166
      ],
      "plane_d": -1356.37841796875,
      "bbox_min": [
        -3581.660888671875,
        -4915.87451171875,
        997.70703125
      ],
      "bbox_max": [
        -3579.160888671875,
        -4913.37451171875,
        998.9070434570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.976249670107791e-07,
        -0.9284766912460327,
        -0.3713906705379486
      ],
      "plane_d": -4191.50537109375,
      "bbox_min": [
        -3581.6611328125,
        -4930.87451171875,
        993.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -4915.87451171875,
        1008.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -4.069012447871501e-06,
        6.467476294097496e-12
      ],
      "plane_d": 3581.64111328125,
      "bbox_min": [
        -3581.6611328125,
        -4930.87451171875,
        993.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -4915.87451171875,
        1008.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3548.19091796875,
      "bbox_min": [
        -3581.6611328125,
        -4930.87451171875,
        993.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -4915.87451171875,
        1008.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -4.069014721608255e-06,
        1.52587890625e-05
      ],
      "plane_d": 3579.125732421875,
      "bbox_min": [
        -3581.6611328125,
        -4930.87451171875,
        993.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -4915.87451171875,
        1008.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4327256977558136,
        -1.7607671907171607e-06,
        0.901525616645813
      ],
      "plane_d": 649.3278198242188,
      "bbox_min": [
        -3581.6611328125,
        -4930.87451171875,
        997.70703125
      ],
      "bbox_max": [
        -3579.160888671875,
        -4915.87451171875,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.10351571594947e-06,
        2.4835295278635705e-11,
        -1.0
      ],
      "plane_d": 1003.6851806640625,
      "bbox_min": [
        -3581.6611328125,
        -4930.87451171875,
        1003.70703125
      ],
      "bbox_max": [
        -3579.160888671875,
        -4915.87451171875,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3550.69091796875,
      "bbox_min": [
        -3550.69091796875,
        -4930.87451171875,
        993.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -4915.87451171875,
        1008.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4327313005924225,
        0.0,
        0.9015229344367981
      ],
      "plane_d": -2435.950927734375,
      "bbox_min": [
        -3550.69091796875,
        -4930.87451171875,
        997.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -4915.87451171875,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1003.70703125,
      "bbox_min": [
        -3550.69091796875,
        -4930.87451171875,
        1003.70703125
      ],
      "bbox_max": [
        -3548.19091796875,
        -4915.87451171875,
        1003.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4850713908672333,
        -0.8401679396629333,
        -0.24253568053245544
      ],
      "plane_d": -2160.75341796875,
      "bbox_min": [
        -3613.0517578125,
        -5032.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3516.800048828125,
        -4930.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.8698838150376105e-07,
        -0.9701424837112427,
        -0.2425357848405838
      ],
      "plane_d": -4537.79150390625,
      "bbox_min": [
        -3613.0517578125,
        -5032.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3516.800048828125,
        -4930.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48507097363471985,
        -0.8401681780815125,
        -0.24253563582897186
      ],
      "plane_d": -5619.24072265625,
      "bbox_min": [
        -3613.0517578125,
        -5032.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3516.800048828125,
        -4930.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002980232239,
        -0.8660252094268799,
        0.0
      ],
      "plane_d": -2480.6796875,
      "bbox_min": [
        -3613.0517578125,
        -5032.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3516.800048828125,
        -4930.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.866025447845459,
        0.0
      ],
      "plane_d": -6045.607421875,
      "bbox_min": [
        -3613.0517578125,
        -5032.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3516.800048828125,
        -4930.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1033.70703125,
      "bbox_min": [
        -3613.0517578125,
        -5032.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3516.800048828125,
        -4935.87451171875,
        1033.70703125
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1013.70703125,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        993.70703125
      ],
      "bbox_max": [
        -3531.800048828125,
        -4950.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866025447845459,
        0.4999999701976776,
        -0.0
      ],
      "plane_d": 5546.1904296875,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3531.800048828125,
        -4950.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660251498222351,
        -0.5000004172325134,
        0.0
      ],
      "plane_d": 562.187255859375,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3531.800048828125,
        -4950.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660251498222351,
        0.5000004768371582,
        0.0
      ],
      "plane_d": -628.438720703125,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3531.800048828125,
        -4950.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253286361694,
        -0.5000001192092896,
        0.0
      ],
      "plane_d": -5612.44287109375,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3531.800048828125,
        -4950.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1488665424840292e-07,
        -1.0,
        0.0
      ],
      "plane_d": -5017.12548828125,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3531.800048828125,
        -4950.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1488665424840292e-07,
        1.0,
        0.0
      ],
      "plane_d": 4950.87353515625,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3531.800048828125,
        -4950.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500000536441803,
        0.8660250902175903,
        -0.0
      ],
      "plane_d": 6065.6083984375,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3531.800048828125,
        -4950.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        -0.866024911403656,
        0.0
      ],
      "plane_d": -2566.9287109375,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3531.800048828125,
        -4950.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000007152557373,
        -0.8660249710083008,
        0.0
      ],
      "plane_d": -6131.8603515625,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3531.800048828125,
        -4950.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        0.866024911403656,
        0.0
      ],
      "plane_d": 2500.6767578125,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3531.800048828125,
        -4950.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3531.800048828125,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3531.800048828125,
        -4950.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3598.0517578125,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3531.800048828125,
        -4950.87451171875,
        1033.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1028.70703125,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3531.800048828125,
        -4950.87451171875,
        1028.70703125
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -0.7808687686920166,
        -0.0,
        -0.6246950626373291
      ],
      "plane_d": -2119.929443359375,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3531.800048828125,
        -4950.87451171875,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6762519478797913,
        0.3904348611831665,
        -0.6246950626373291
      ],
      "plane_d": 198.94921875,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3533.800048828125,
        -4950.87451171875,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3904353976249695,
        0.6762515306472778,
        -0.6246951818466187
      ],
      "plane_d": 2642.37451171875,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3533.800048828125,
        -4950.87451171875,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7808688282966614,
        -0.6246950626373291
      ],
      "plane_d": 4555.66064453125,
      "bbox_min": [
        -3598.0517578125,
        -5017.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3533.800048828125,
        -4950.87451171875,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1023.70703125,
      "bbox_min": [
        -3577.2666015625,
        -5017.12646484375,
        1023.70703125
      ],
      "bbox_max": [
        -3556.585693359375,
        -5015.1259765625,
        1023.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -9.314054523201776e-07,
        -0.9486833810806274,
        -0.31622758507728577
      ],
      "plane_d": -4424.87548828125,
      "bbox_min": [
        -3598.0517578125,
        -5007.12646484375,
        1013.70703125
      ],
      "bbox_max": [
        -3533.800048828125,
        -4950.87451171875,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4743415415287018,
        0.8215841054916382,
        -0.3162272870540619
      ],
      "plane_d": 6089.13427734375,
      "bbox_min": [
        -3598.0517578125,
        -5000.9296875,
        1013.70703125
      ],
      "bbox_max": [
        -3533.800048828125,
        -4950.87451171875,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8215844631195068,
        0.4743407964706421,
        -0.31622734665870667
      ],
      "plane_d": 5596.3681640625,
      "bbox_min": [
        -3598.0517578125,
        -5000.9296875,
        1013.70703125
      ],
      "bbox_max": [
        -3534.954833984375,
        -4952.48583984375,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        -0.3162277638912201
      ],
      "plane_d": 3685.352294921875,
      "bbox_min": [
        -3598.0517578125,
        -5000.9296875,
        1013.70703125
      ],
      "bbox_max": [
        -3541.800048828125,
        -4952.48583984375,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3904353976249695,
        -0.6762517094612122,
        -0.6246950030326843
      ],
      "plane_d": -1314.7557373046875,
      "bbox_min": [
        -3598.0517578125,
        -5000.9296875,
        1013.70703125
      ],
      "bbox_max": [
        -3558.729248046875,
        -4952.48583984375,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1023.70703125,
      "bbox_min": [
        -3591.17578125,
        -4963.21484375,
        1023.70703125
      ],
      "bbox_max": [
        -3574.593017578125,
        -4952.48583984375,
        1023.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8215826749801636,
        0.4743436872959137,
        -0.3162277042865753
      ],
      "plane_d": -261.3857421875,
      "bbox_min": [
        -3596.4404296875,
        -4990.197265625,
        1013.70703125
      ],
      "bbox_max": [
        -3558.729248046875,
        -4960.87451171875,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4743443727493286,
        0.8215820789337158,
        -0.3162281811237335
      ],
      "plane_d": 2707.13037109375,
      "bbox_min": [
        -3588.0517578125,
        -4990.197265625,
        1013.70703125
      ],
      "bbox_max": [
        -3558.729248046875,
        -4960.87451171875,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.451243391187745e-07,
        0.9486833214759827,
        -0.3162277042865753
      ],
      "plane_d": 5031.60693359375,
      "bbox_min": [
        -3588.0517578125,
        -4990.197265625,
        1013.70703125
      ],
      "bbox_max": [
        -3558.729248046875,
        -4960.87451171875,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        -0.3162277638912201
      ],
      "plane_d": -3078.619140625,
      "bbox_min": [
        -3588.0517578125,
        -4990.197265625,
        1013.70703125
      ],
      "bbox_max": [
        -3583.0517578125,
        -4977.8037109375,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.0,
        -0.6246950030326843
      ],
      "plane_d": 3447.54931640625,
      "bbox_min": [
        -3596.4404296875,
        -4983.2685546875,
        1023.70703125
      ],
      "bbox_max": [
        -3584.783447265625,
        -4961.21484375,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1023.70703125,
      "bbox_min": [
        -3596.4404296875,
        -4973.0068359375,
        1023.70703125
      ],
      "bbox_max": [
        -3596.0517578125,
        -4971.66015625,
        1023.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6762518882751465,
        -0.39043477177619934,
        -0.6246951818466187
      ],
      "plane_d": 1128.670654296875,
      "bbox_min": [
        -3596.0517578125,
        -4976.73193359375,
        1023.70703125
      ],
      "bbox_max": [
        -3584.783447265625,
        -4961.21484375,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1023.70703125,
      "bbox_min": [
        -3596.0517578125,
        -4974.333984375,
        1023.70703125
      ],
      "bbox_max": [
        -3587.711669921875,
        -4961.21484375,
        1023.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6762509346008301,
        0.3904338479042053,
        -0.6246967911720276
      ],
      "plane_d": 5020.5185546875,
      "bbox_min": [
        -3598.0517578125,
        -4996.93017578125,
        1023.70703125
      ],
      "bbox_max": [
        -3588.783203125,
        -4972.33349609375,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1023.70703125,
      "bbox_min": [
        -3598.0517578125,
        -4990.04345703125,
        1023.70703125
      ],
      "bbox_max": [
        -3597.378173828125,
        -4988.876953125,
        1023.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.0,
        -0.6246950030326843
      ],
      "plane_d": 3447.54931640625,
      "bbox_min": [
        -3598.0517578125,
        -4992.03125,
        1023.70703125
      ],
      "bbox_max": [
        -3592.0517578125,
        -4972.33349609375,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1023.70703125,
      "bbox_min": [
        -3598.0517578125,
        -4990.80908203125,
        1023.70703125
      ],
      "bbox_max": [
        -3596.0517578125,
        -4972.33349609375,
        1023.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6762518882751465,
        -0.39043477177619934,
        -0.6246951818466187
      ],
      "plane_d": 1128.670654296875,
      "bbox_min": [
        -3596.0517578125,
        -4975.9697265625,
        1023.70703125
      ],
      "bbox_max": [
        -3594.89697265625,
        -4973.0068359375,
        1025.150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1023.70703125,
      "bbox_min": [
        -3596.0517578125,
        -4975.66015625,
        1023.70703125
      ],
      "bbox_max": [
        -3595.285888671875,
        -4973.0068359375,
        1023.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6762510538101196,
        -0.3904338479042053,
        -0.624696671962738
      ],
      "plane_d": -3692.89599609375,
      "bbox_min": [
        -3541.068359375,
        -4976.73193359375,
        1025.150390625
      ],
      "bbox_max": [
        -3534.954833984375,
        -4971.0712890625,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3904353976249695,
        -0.6762517094612122,
        -0.6246950030326843
      ],
      "plane_d": -1314.7557373046875,
      "bbox_min": [
        -3576.5927734375,
        -4975.9697265625,
        1023.70703125
      ],
      "bbox_max": [
        -3533.800048828125,
        -4950.87451171875,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7808688282966614,
        -0.6246950626373291
      ],
      "plane_d": -3228.040771484375,
      "bbox_min": [
        -3573.26611328125,
        -4975.9697265625,
        1023.70703125
      ],
      "bbox_max": [
        -3533.800048828125,
        -4950.87451171875,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3904351592063904,
        -0.6762527227401733,
        -0.6246940493583679
      ],
      "plane_d": -4098.50732421875,
      "bbox_min": [
        -3557.657470703125,
        -4975.9697265625,
        1023.70703125
      ],
      "bbox_max": [
        -3533.800048828125,
        -4952.87451171875,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1023.70703125,
      "bbox_min": [
        -3556.585693359375,
        -4963.21533203125,
        1023.70703125
      ],
      "bbox_max": [
        -3538.675537109375,
        -4952.87451171875,
        1023.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6762510538101196,
        -0.3904338479042053,
        -0.624696671962738
      ],
      "plane_d": -3692.89599609375,
      "bbox_min": [
        -3545.068359375,
        -4975.9697265625,
        1023.70703125
      ],
      "bbox_max": [
        -3533.800048828125,
        -4961.21484375,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1023.70703125,
      "bbox_min": [
        -3542.14013671875,
        -4974.33349609375,
        1023.70703125
      ],
      "bbox_max": [
        -3533.800048828125,
        -4961.21484375,
        1023.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1023.70703125,
      "bbox_min": [
        -3598.0517578125,
        -5015.1259765625,
        1023.70703125
      ],
      "bbox_max": [
        -3572.1943359375,
        -4989.65478515625,
        1028.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6762509346008301,
        0.3904338479042053,
        -0.6246967911720276
      ],
      "plane_d": 5020.5185546875,
      "bbox_min": [
        -3596.0517578125,
        -5006.7861328125,
        1023.70703125
      ],
      "bbox_max": [
        -3584.783447265625,
        -4990.80908203125,
        1028.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.0,
        -0.6246950030326843
      ],
      "plane_d": 3447.54931640625,
      "bbox_min": [
        -3596.0517578125,
        -4992.3408203125,
        1023.70703125
      ],
      "bbox_max": [
        -3594.89697265625,
        -4990.80908203125,
        1025.150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1023.70703125,
      "bbox_min": [
        -3534.954833984375,
        -4975.9697265625,
        1023.70703125
      ],
      "bbox_max": [
        -3533.800048828125,
        -4973.00732421875,
        1025.150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6762510538101196,
        -0.3904338479042053,
        -0.624696671962738
      ],
      "plane_d": -3692.89599609375,
      "bbox_min": [
        -3534.954833984375,
        -4975.9697265625,
        1023.70703125
      ],
      "bbox_max": [
        -3533.800048828125,
        -4974.33349609375,
        1025.150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1023.70703125,
      "bbox_min": [
        -3575.91943359375,
        -5015.12646484375,
        1023.70703125
      ],
      "bbox_max": [
        -3572.95654296875,
        -5013.9716796875,
        1025.1507568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.390435129404068,
        0.6762524247169495,
        -0.6246944069862366
      ],
      "plane_d": 5426.1240234375,
      "bbox_min": [
        -3574.593017578125,
        -5015.12646484375,
        1023.70703125
      ],
      "bbox_max": [
        -3572.95654296875,
        -5013.9716796875,
        1025.1507568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5000.50048828125,
      "bbox_min": [
        -3569.699951171875,
        -5002.00048828125,
        993.70703125
      ],
      "bbox_max": [
        -3560.10009765625,
        -4966.00048828125,
        1013.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5002.00048828125,
      "bbox_min": [
        -3569.699951171875,
        -5002.00048828125,
        993.70703125
      ],
      "bbox_max": [
        -3560.10009765625,
        -5000.50048828125,
        1013.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3560.10009765625,
      "bbox_min": [
        -3569.699951171875,
        -5002.00048828125,
        993.70703125
      ],
      "bbox_max": [
        -3560.10009765625,
        -5000.50048828125,
        1013.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3569.699951171875,
      "bbox_min": [
        -3569.699951171875,
        -5002.00048828125,
        993.70703125
      ],
      "bbox_max": [
        -3569.699951171875,
        -5000.50048828125,
        1013.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4967.50048828125,
      "bbox_min": [
        -3569.699951171875,
        -4967.50048828125,
        993.70703125
      ],
      "bbox_max": [
        -3560.10009765625,
        -4966.00048828125,
        1013.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4966.00048828125,
      "bbox_min": [
        -3569.699951171875,
        -4967.50048828125,
        993.70703125
      ],
      "bbox_max": [
        -3560.10009765625,
        -4966.00048828125,
        1013.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3560.10009765625,
      "bbox_min": [
        -3569.699951171875,
        -4967.50048828125,
        993.70703125
      ],
      "bbox_max": [
        -3560.10009765625,
        -4966.00048828125,
        1013.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3569.699951171875,
      "bbox_min": [
        -3569.699951171875,
        -4967.50048828125,
        993.70703125
      ],
      "bbox_max": [
        -3569.699951171875,
        -4966.00048828125,
        1013.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49515438079833984,
        0.857633113861084,
        0.1388797163963318
      ],
      "plane_d": 5970.208984375,
      "bbox_min": [
        -3618.0517578125,
        -5037.12646484375,
        846.3855590820312
      ],
      "bbox_max": [
        -3548.697021484375,
        -4944.0283203125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8576340675354004,
        0.49515289068222046,
        0.13887900114059448
      ],
      "plane_d": 5455.8212890625,
      "bbox_min": [
        -3618.0517578125,
        -5037.12646484375,
        846.3855590820312
      ],
      "bbox_max": [
        -3548.697021484375,
        -4944.0283203125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9903093576431274,
        -0.0,
        0.13887919485569
      ],
      "plane_d": 3460.956298828125,
      "bbox_min": [
        -3618.0517578125,
        -5037.12646484375,
        846.3855590820312
      ],
      "bbox_max": [
        -3548.697021484375,
        -4944.0283203125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8576340675354004,
        -0.4951527416706085,
        0.13887979090213776
      ],
      "plane_d": 520.13671875,
      "bbox_min": [
        -3618.0517578125,
        -5037.12646484375,
        846.3855590820312
      ],
      "bbox_max": [
        -3548.697021484375,
        -4944.0283203125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.7903956834052224e-07,
        0.9903091788291931,
        0.1388804018497467
      ],
      "plane_d": 4866.2763671875,
      "bbox_min": [
        -3615.45166015625,
        -5037.12646484375,
        846.3855590820312
      ],
      "bbox_max": [
        -3548.697021484375,
        -4944.0283203125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7894070148468018,
        0.4557643234729767,
        0.4112364649772644
      ],
      "plane_d": 4778.03125,
      "bbox_min": [
        -3615.45166015625,
        -5037.12646484375,
        846.3855590820312
      ],
      "bbox_max": [
        -3548.697021484375,
        -4944.0283203125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9115298986434937,
        -0.0,
        0.4112338125705719
      ],
      "plane_d": 2941.86279296875,
      "bbox_min": [
        -3615.45166015625,
        -5037.12646484375,
        846.3855590820312
      ],
      "bbox_max": [
        -3548.697021484375,
        -4944.0283203125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45576462149620056,
        0.7894071340560913,
        0.41123586893081665
      ],
      "plane_d": 5251.4970703125,
      "bbox_min": [
        -3615.45166015625,
        -5037.12646484375,
        846.3855590820312
      ],
      "bbox_max": [
        -3548.697021484375,
        -4944.0283203125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.019351595412445e-07,
        0.9115289449691772,
        0.41123586893081665
      ],
      "plane_d": 4235.38671875,
      "bbox_min": [
        -3615.45166015625,
        -5037.12646484375,
        855.2870483398438
      ],
      "bbox_max": [
        -3548.697021484375,
        -4944.0283203125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7894081473350525,
        -0.45576465129852295,
        0.4112339913845062
      ],
      "plane_d": 234.976318359375,
      "bbox_min": [
        -3615.45166015625,
        -5037.12646484375,
        855.3571166992188
      ],
      "bbox_max": [
        -3548.697021484375,
        -4944.0283203125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4951542913913727,
        0.8576332330703735,
        0.1388794630765915
      ],
      "plane_d": 2439.8330078125,
      "bbox_min": [
        -3603.81689453125,
        -5037.12646484375,
        876.488525390625
      ],
      "bbox_max": [
        -3548.697021484375,
        -4944.0283203125,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49515417218208313,
        -0.8576332926750183,
        0.1388794481754303
      ],
      "plane_d": -2578.68017578125,
      "bbox_min": [
        -3603.81689453125,
        -4945.3232421875,
        876.6228637695312
      ],
      "bbox_max": [
        -3601.944580078125,
        -4944.0283203125,
        878.70703125
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}